"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[72037,74645],{

/***/ 50550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-close {\n    top: 20px;\n    right: 30px;\n    font-size: 14px;\n    font-weight: bold;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    border: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 40px 50px 30px;\n  }\n\n  .ant-modal-close {\n    top: 3%;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    height: 90%;\n    overflow-y: scroll;\n  }\n\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-f78b26fb-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}));


/***/ }),

/***/ 30079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ Page; },
/* harmony export */   "V3": function() { return /* binding */ privacyPageTheme; }
/* harmony export */ });
/* unused harmony export Theme */
var theme = {};
var Theme;
(function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
})(Theme || (Theme = {}));
var Page;
(function(Page) {
    Page["privacyDark"] = "privacy-page-dark";
    Page["privacyLight"] = "privacy-page-light";
})(Page || (Page = {}));
var privacyPageTheme = {
    dark: {
        page: Page.privacyDark,
        textPrimary: "#cbcbcb",
        textSecondary: "#858585",
        backgroundPrimary: "#121212",
        backgroundSecondary: "#121212",
        borderPrimary: "#121212"
    },
    light: {
        page: Page.privacyLight,
        textPrimary: "#333333",
        textSecondary: "#858585",
        backgroundPrimary: "#ffffff",
        backgroundSecondary: "#f2f2f2",
        borderPrimary: "#dadada"
    }
};

/* harmony default export */ __webpack_exports__["ZP"] = (theme);


/***/ }),

/***/ 39246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/calendar.ts


var request = (0,requestExodus/* default */.Z)();
var CALENDAR_URL = "".concat(api/* API_EXODUS_URL */.q7, "/corpaction");
var getCalendarTodaySummary = function(symbol) {
    return request.get(CALENDAR_URL, {
        params: {
            symbol: symbol
        }
    });
};
/**
 * @summary - Get Calendar Data based on Type
 * @param {string} calendarType - type of calendar. type: economic | dividend | stocksplit
 * | reversesplit | rightissue | warrant | bonus | tenderoffer | rups | pubex | ipo
 * @return {Promise} Axios promise
 */ var getCalendarFor = function(calendarType, symbol) {
    return request.get("".concat(CALENDAR_URL, "/").concat(calendarType), {
        params: {
            symbol: symbol
        }
    });
};


;// CONCATENATED MODULE: ./src/features/calendar/slice.ts




var CONTEXT = "@feature/calendar";
var actionType = {
    GET_CALENDAR_TODAY: "".concat(CONTEXT, "/GET_CALENDAR_TODAY"),
    GET_CALENDAR_ECONOMIC: "".concat(CONTEXT, "/GET_CALENDAR_ECONOMIC"),
    GET_CALENDAR_CASH_DIVIDEND: "".concat(CONTEXT, "/GET_CALENDAR_CASH_DIVIDEND"),
    GET_CALENDAR_STOCK_DIVIDEND: "".concat(CONTEXT, "/GET_CALENDAR_STOCK_DIVIDEND"),
    GET_CALENDAR_STOCKSPLIT: "".concat(CONTEXT, "/GET_CALENDAR_STOCKSPLIT"),
    GET_CALENDAR_REVERSESPLIT: "".concat(CONTEXT, "/GET_CALENDAR_REVERSESPLIT"),
    GET_CALENDAR_RIGHTISSUE: "".concat(CONTEXT, "/GET_CALENDAR_RIGHTISSUE"),
    GET_CALENDAR_WARRANT: "".concat(CONTEXT, "/GET_CALENDAR_WARRANT"),
    GET_CALENDAR_BONUS: "".concat(CONTEXT, "/GET_CALENDAR_BONUS"),
    GET_CALENDAR_TENDER: "".concat(CONTEXT, "/GET_CALENDAR_TENDER"),
    GET_CALENDAR_RUPS: "".concat(CONTEXT, "/GET_CALENDAR_RUPS"),
    GET_CALENDAR_PUBEX: "".concat(CONTEXT, "/GET_CALENDAR_PUBEX"),
    GET_CALENDAR_IPO: "".concat(CONTEXT, "/GET_CALENDAR_IPO")
};
var initialState = {
    calendarToday: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarEconomic: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarCashDividend: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarStockDividend: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarStocksplit: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarReversesplit: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarRightIssue: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarWarrant: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarBonus: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarTender: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarRups: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarPubex: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarIpo: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    }
};
var calendarState = function(state) {
    return state.calendar;
};
var selectors = (0,es/* createSelector */.P1)(calendarState, function(calendar) {
    return {
        calendarToday: calendar.calendarToday,
        calendarEconomic: calendar.calendarEconomic,
        calendarCashDividend: calendar.calendarCashDividend,
        calendarStockDividend: calendar.calendarStockDividend,
        calendarStocksplit: calendar.calendarStocksplit,
        calendarReversesplit: calendar.calendarReversesplit,
        calendarRightIssue: calendar.calendarRightIssue,
        calendarWarrant: calendar.calendarWarrant,
        calendarBonus: calendar.calendarBonus,
        calendarTender: calendar.calendarTender,
        calendarRups: calendar.calendarRups,
        calendarPubex: calendar.calendarPubex,
        calendarIpo: calendar.calendarIpo
    };
});
/**
 * Get Calendar Data based on Type
 * @summary - available calendar type: economic | dividened | stocksplit
 * | reversesplit | reversesplit | rightissue | warrant | bonus | tenderoffer | rups | pubex | ipo
 * @param {string} calendarTypes - type of calendar
 */ var effects = {
    getCalendarToday: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_TODAY, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarTodaySummary();
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get today calendar is failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarEconomic: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_ECONOMIC, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("economic");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for economic failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarCashDividend: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_CASH_DIVIDEND, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("dividend");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for dividend failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarStockDividend: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_STOCK_DIVIDEND, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("stock_dividend");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for stock dividend failed");
                case 6:
                    data = responds.data;
                    ;
                    ;
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getCalendarStocksplit: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_STOCKSPLIT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("stocksplit");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for stocksplit failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarReversesplit: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_REVERSESPLIT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("reversesplit");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for reverse split failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarRightIssue: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_RIGHTISSUE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("rightissue");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for right issue failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarWarrant: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_WARRANT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("warrant");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for warrant failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarBonus: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_BONUS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("bonus");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for bonus failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarTender: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_TENDER, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("tenderoffer");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for tender offer failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarRups: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_RUPS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("rups");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for RUPS failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarPubex: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_PUBEX, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("pubex");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for PUBEX failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarIpo: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_IPO, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("ipo");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for IPO failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    })))
};
var extraReducer = function(builder) {
    builder.addCase(effects.getCalendarToday.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarToday.isLoading = false;
        state.calendarToday.data = data;
        state.calendarToday.message = message;
    }).addCase(effects.getCalendarToday.pending, function(state, action) {
        state.calendarToday.isLoading = true;
    }).addCase(effects.getCalendarToday.rejected, function(state, action) {
        state.calendarToday.isLoading = false;
        state.calendarToday.error = action.payload.error;
    }).addCase(effects.getCalendarEconomic.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarEconomic.data = data;
        state.calendarEconomic.message = message;
        state.calendarEconomic.isLoading = false;
    }).addCase(effects.getCalendarEconomic.pending, function(state, action) {
        state.calendarEconomic.isLoading = true;
    }).addCase(effects.getCalendarEconomic.rejected, function(state, action) {
        state.calendarEconomic.error = action.payload.error;
        state.calendarEconomic.isLoading = false;
    }).addCase(effects.getCalendarCashDividend.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarCashDividend.data = data;
        state.calendarCashDividend.message = message;
        state.calendarCashDividend.isLoading = false;
    }).addCase(effects.getCalendarCashDividend.pending, function(state, action) {
        state.calendarCashDividend.isLoading = true;
    }).addCase(effects.getCalendarCashDividend.rejected, function(state, action) {
        state.calendarCashDividend.error = action.payload.error;
        state.calendarCashDividend.isLoading = false;
    }).addCase(effects.getCalendarStockDividend.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarStockDividend.data = data;
        state.calendarStockDividend.message = message;
        state.calendarStockDividend.isLoading = false;
    }).addCase(effects.getCalendarStockDividend.pending, function(state, action) {
        state.calendarStockDividend.isLoading = true;
    }).addCase(effects.getCalendarStockDividend.rejected, function(state, action) {
        state.calendarStockDividend.error = action.payload.error;
        state.calendarStockDividend.isLoading = false;
    }).addCase(effects.getCalendarStocksplit.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarStocksplit.data = data;
        state.calendarStocksplit.message = message;
        state.calendarStocksplit.isLoading = false;
    }).addCase(effects.getCalendarStocksplit.pending, function(state, action) {
        state.calendarStocksplit.isLoading = true;
    }).addCase(effects.getCalendarStocksplit.rejected, function(state, action) {
        state.calendarStocksplit.error = action.payload.error;
        state.calendarStocksplit.isLoading = false;
    }).addCase(effects.getCalendarReversesplit.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarReversesplit.data = data;
        state.calendarReversesplit.message = message;
        state.calendarReversesplit.isLoading = false;
    }).addCase(effects.getCalendarReversesplit.pending, function(state, action) {
        state.calendarReversesplit.isLoading = true;
    }).addCase(effects.getCalendarReversesplit.rejected, function(state, action) {
        state.calendarReversesplit.error = action.payload.error;
        state.calendarReversesplit.isLoading = false;
    }).addCase(effects.getCalendarRightIssue.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarRightIssue.data = data;
        state.calendarRightIssue.message = message;
        state.calendarRightIssue.isLoading = false;
    }).addCase(effects.getCalendarRightIssue.pending, function(state, action) {
        state.calendarRightIssue.isLoading = true;
    }).addCase(effects.getCalendarRightIssue.rejected, function(state, action) {
        state.calendarRightIssue.error = action.payload.error;
        state.calendarRightIssue.isLoading = false;
    }).addCase(effects.getCalendarWarrant.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarWarrant.data = data;
        state.calendarWarrant.message = message;
        state.calendarWarrant.isLoading = false;
    }).addCase(effects.getCalendarWarrant.pending, function(state, action) {
        state.calendarWarrant.isLoading = true;
    }).addCase(effects.getCalendarWarrant.rejected, function(state, action) {
        state.calendarWarrant.error = action.payload.error;
        state.calendarWarrant.isLoading = false;
    }).addCase(effects.getCalendarBonus.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarBonus.data = data;
        state.calendarBonus.message = message;
        state.calendarBonus.isLoading = false;
    }).addCase(effects.getCalendarBonus.pending, function(state, action) {
        state.calendarBonus.isLoading = true;
    }).addCase(effects.getCalendarBonus.rejected, function(state, action) {
        state.calendarBonus.error = action.payload.error;
        state.calendarBonus.isLoading = false;
    }).addCase(effects.getCalendarTender.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarTender.data = data;
        state.calendarTender.message = message;
        state.calendarTender.isLoading = false;
    }).addCase(effects.getCalendarTender.pending, function(state, action) {
        state.calendarTender.isLoading = true;
    }).addCase(effects.getCalendarTender.rejected, function(state, action) {
        state.calendarTender.error = action.payload.error;
        state.calendarTender.isLoading = false;
    }).addCase(effects.getCalendarRups.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarRups.data = data;
        state.calendarRups.message = message;
        state.calendarRups.isLoading = false;
    }).addCase(effects.getCalendarRups.pending, function(state, action) {
        state.calendarRups.isLoading = true;
    }).addCase(effects.getCalendarRups.rejected, function(state, action) {
        state.calendarRups.error = action.payload.error;
        state.calendarRups.isLoading = false;
    }).addCase(effects.getCalendarPubex.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarPubex.data = data;
        state.calendarPubex.message = message;
        state.calendarPubex.isLoading = false;
    }).addCase(effects.getCalendarPubex.pending, function(state, action) {
        state.calendarPubex.isLoading = true;
    }).addCase(effects.getCalendarPubex.rejected, function(state, action) {
        state.calendarPubex.error = action.payload.error;
        state.calendarPubex.isLoading = false;
    }).addCase(effects.getCalendarIpo.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarIpo.data = data;
        state.calendarIpo.message = message;
        state.calendarIpo.isLoading = false;
    }).addCase(effects.getCalendarIpo.pending, function(state, action) {
        state.calendarIpo.isLoading = true;
    }).addCase(effects.getCalendarIpo.rejected, function(state, action) {
        state.calendarIpo.error = action.payload.error;
        state.calendarIpo.isLoading = false;
    });
};
var calendarSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "calendar",
    initialState: initialState,
    // for non-async reducer logic
    reducers: {},
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ var slice = (calendarSlice);


/***/ }),

/***/ 62893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29172);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42227);








// APIs


// Initial state
var initialState = {
    list: {},
    subsectors: [],
    sectors: [],
    pageTitle: null,
    error: null,
    isLoading: false,
    message: "",
    companies: []
};
// Selectors
var catalog = function(state) {
    return state.catalog;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(catalog, function(cat) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cat);
});
// Action type
var CONTEXT = "@feature/catalog";
var actionType = {
    GET_COMPANY_LIST: "".concat(CONTEXT, "/GET_COMPANY_LIST"),
    GET_SECTOR_LIST: "".concat(CONTEXT, "/GET_SECTOR_LIST")
};
// Side effects
var effects = {
    getSectorList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_SECTOR_LIST, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, _data, data, error_type, error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSectorList */ .Z.getSectorList();
                case 2:
                    res = _ctx.sent;
                    if (res.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Failed to fetch sector list");
                case 5:
                    _data = res.data, data = _data.data, error_type = _data.error_type, error = _data.error, message = _data.message;
                    if (!(error_type || error)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(message);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data,
                        error: error,
                        message: message
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    getCompanyList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_LIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var sector, subsector, _isCatalog, isCatalog, getState, companies, companyListPayload, getSectors, ref, sectors, getSectorData, sectorData, getSubsector, getSubsectorData, subsectorData, companyResponse, getCompanyInSector, getCompanyInSectorData, companyRequest, listCompanyResponse, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sector = param.sector, subsector = param.subsector, _isCatalog = param.isCatalog, isCatalog = _isCatalog === void 0 ? false : _isCatalog, getState = param1.getState;
                        _ctx.prev = 1;
                        companies = [];
                        companyListPayload = {};
                        ;
                        if (sector) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Sector is required");
                    case 7:
                        ref = getState(), sectors = ref.catalog.sectors;
                        if (!(sectors.length === 0)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 11;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSectorList */ .Z.getSectorList();
                    case 11:
                        // Get sector list first
                        getSectors = _ctx.sent;
                        if (getSectors.data) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error("Attempt to get sector list failed");
                    case 14:
                        getSectorData = sectors.length > 0 ? {
                            data: sectors
                        } : getSectors === null || getSectors === void 0 ? void 0 : getSectors.data;
                        if (!getSectorData.error) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: "Error sector",
                            message: getSectorData.message
                        });
                    case 17:
                        sectorData = getSectorData.data.find(function(sc) {
                            return (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sc.alias1) === (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sector);
                        });
                        if (sectorData) {
                            _ctx.next = 20;
                            break;
                        }
                        throw new Error("Sector not found");
                    case 20:
                        _ctx.next = 22;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSubsectorList */ .Z.getSubsectorList(sectorData.id);
                    case 22:
                        getSubsector = _ctx.sent;
                        if (getSubsector.data) {
                            _ctx.next = 25;
                            break;
                        }
                        throw new Error("Attempt to get sub sector data failed");
                    case 25:
                        getSubsectorData = getSubsector.data;
                        if (!getSubsectorData.error) {
                            _ctx.next = 28;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: "Error subsector",
                            message: getSubsectorData.message
                        });
                    case 28:
                        ;
                        companyResponse = {
                            data: {
                                data: null
                            }
                        };
                        if (!subsector) {
                            _ctx.next = 44;
                            break;
                        }
                        // if subsector available in url path, we will
                        // call company list by subsector id
                        subsectorData = getSubsectorData.data.find(function(sb) {
                            return (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sb.alias1) === (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(subsector);
                        });
                        if (subsectorData) {
                            _ctx.next = 36;
                            break;
                        }
                        {
                            companyListPayload = {
                                error: "Error subsector",
                                message: "Subsector not found"
                            };
                        }
                        _ctx.next = 42;
                        break;
                    case 36:
                        _ctx.next = 38;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyList */ .Z.getCompanyList(sectorData.id, subsectorData.id);
                    case 38:
                        // Get company list based on subsector
                        companyResponse = _ctx.sent;
                        if (companyResponse.data) {
                            _ctx.next = 41;
                            break;
                        }
                        throw new Error("Attempt to get company list failed");
                    case 41:
                        companies = companyResponse.data.data;
                    case 42:
                        _ctx.next = 60;
                        break;
                    case 44:
                        if (!isCatalog) {
                            _ctx.next = 52;
                            break;
                        }
                        _ctx.next = 47;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyInSector */ .Z.getCompanyInSector(sectorData.id);
                    case 47:
                        getCompanyInSector = _ctx.sent;
                        getCompanyInSectorData = getCompanyInSector.data;
                        companies = getCompanyInSectorData.data;
                        _ctx.next = 60;
                        break;
                    case 52:
                        _ctx.next = 54;
                        return getSubsectorData.data.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(subsector) {
                                var company;
                                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyList */ .Z.getCompanyList(sectorData.id, subsector.id);
                                        case 2:
                                            company = _ctx.sent;
                                            return _ctx.abrupt("return", {
                                                company: company,
                                                subsectorName: subsector.alias1
                                            });
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(subsector) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    case 54:
                        companyRequest = _ctx.sent;
                        _ctx.next = 57;
                        return Promise.all(companyRequest);
                    case 57:
                        listCompanyResponse = _ctx.sent;
                        companyResponse = {
                            data: {
                                data: []
                            }
                        };
                        listCompanyResponse.map(function(response) {
                            companyResponse.data.data.push({
                                alias: response.subsectorName,
                                data: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(response.company.data.data)
                            });
                        });
                    case 60:
                        _data = companyResponse.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 64;
                            break;
                        }
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(message || (_$error === null || _$error === void 0 ? void 0 : _$error.message), constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 64:
                        return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            data: data,
                            message: message,
                            sector: sector,
                            sectors: getSectorData.data,
                            subsector: subsector,
                            subsectors: getSubsectorData.data,
                            companies: companies
                        }, companyListPayload));
                    case 67:
                        _ctx.prev = 67;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 71:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    67
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    updateList: function(state, action) {
        var newList = {};
        var _payload = action.payload, symbol = _payload.index, data = _payload.data;
        Object.keys(state.list).map(function(key1) {
            newList[key1] = {};
            Object.keys(state.list[key1]).map(function(key2) {
                newList[key1][key2] = [];
                var values = state.list[key1][key2];
                values.map(function(value) {
                    if (value.symbol === symbol) {
                        newList[key1][key2].push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, value), {
                            last: data.lastprice,
                            change: data.change,
                            percent: data.percentage_change
                        }));
                    } else {
                        newList[key1][key2].push(value);
                    }
                });
            });
        });
        state.list = newList;
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getCompanyList.pending, function(state, action) {
        state.error = null;
        state.isLoading = true;
        var sector = action.meta.arg.sector;
        if (!state.list[sector]) {
            state.list[sector] = {};
        }
    }).addCase(effects.getCompanyList.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, sector = _payload.sector, sectors = _payload.sectors, subsector = _payload.subsector, subsectors = _payload.subsectors, companies = _payload.companies;
        if (error) {
            state.error = error;
        }
        if (sectors && sector && !subsector) {
            state.sectors = sectors;
            var activeSector = sectors.find(function(item) {
                return (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(item === null || item === void 0 ? void 0 : item.alias1) === (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sector);
            });
            state.pageTitle = (activeSector === null || activeSector === void 0 ? void 0 : activeSector.name) || null;
            if (data) {
                data.map(function(item) {
                    state.list[sector][item.alias] = item.data;
                });
            }
        }
        if (subsectors) {
            state.subsectors = subsectors;
            if (subsector) {
                state.list[sector][subsector] = data;
            }
        }
        state.companies = companies;
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getCompanyList.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    })// Get sector list
    .addCase(effects.getSectorList.pending, function(state) {
        state.isLoading = true;
        state.error = false;
    }).addCase(effects.getSectorList.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
            state.sectors = data;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getSectorList.rejected, function(state, action) {
        state.error = action.payload;
        state.isLoading = false;
    });
};
var catalogSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "catalog",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (catalogSlice);


/***/ }),

/***/ 34566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ DISCOVER_FILTERS; },
/* harmony export */   "FT": function() { return /* binding */ SUGGESTIONS_PERPAGE; },
/* harmony export */   "_u": function() { return /* binding */ LIMIT_SEARCH_USER; },
/* harmony export */   "ce": function() { return /* binding */ QUERY_KEY_DATA; }
/* harmony export */ });
/* unused harmony exports LIMIT_TRENDING_USER, USER_TYPES, EMPTY_MESSAGE */
var DISCOVER_FILTERS = [
    {
        label: "Trending",
        value: "TRENDING"
    },
    {
        label: "Suggestions",
        value: "SUGGEST"
    },
    {
        label: "Friends",
        value: "CONTACT"
    }, 
];
var EMPTY_MESSAGE = {
    contacts: "You have no suggested people on your contact",
    facebook: "You have no facebook friends",
    all: "You have no suggested people",
    official: "You have no suggested official contact"
};
var USER_TYPES = {
    OFFICIAL_USER: "OFFICIAL",
    TOP: "TOP"
};
var SUGGESTIONS_PERPAGE = 30;
var LIMIT_SEARCH_USER = 20;
var LIMIT_TRENDING_USER = 100;
var QUERY_KEY_DATA = {
    SUGGEST: "getDataFriendSuggestionsList",
    CONTACT: "getDataContactList",
    SEARCH: "getSearchUserList",
    TRENDING: "getTrendingUserList"
};



/***/ }),

/***/ 58603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ actionType; },
/* harmony export */   "FO": function() { return /* binding */ getTrendingUserDiscovery; },
/* harmony export */   "Fi": function() { return /* binding */ normalizeData; },
/* harmony export */   "Iq": function() { return /* binding */ getCurrentQueryKey; },
/* harmony export */   "NX": function() { return /* binding */ DiscoverPeopleContext; },
/* harmony export */   "P_": function() { return /* binding */ followUser; },
/* harmony export */   "Qd": function() { return /* binding */ INDEX_DATA_FILTER; },
/* harmony export */   "lU": function() { return /* binding */ getFriendSuggestionsContact; },
/* harmony export */   "n1": function() { return /* binding */ getSearchUser; },
/* harmony export */   "vR": function() { return /* binding */ getSuggestFriends; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63699);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44590);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37213);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34566);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28635);







// app constants



var CONTEXT = "@discover-people";
var actionType = {
    FETCH_TRENDING: "".concat(CONTEXT, "/FETCH_TRENDING"),
    FETCH_SUGGESTIONS: "".concat(CONTEXT, "/FETCH_SUGGESTIONS"),
    FETCH_CONTACT: "".concat(CONTEXT, "/FETCH_CONTACT"),
    FOLLOW_ALL: "".concat(CONTEXT, "/FOLLOW_ALL"),
    SEARCH_USER: "".concat(CONTEXT, "/SEARCH_USER"),
    TOGGLE_FOLLOW_USER: "".concat(CONTEXT, "/TOGGLE_FOLLOW_USER")
};
var INDEX_DATA_FILTER = {
    SUGGEST: "useSuggestionList",
    CONTACT: "useContactList",
    SEARCH: "useSearchUser",
    TRENDING: "useTrendingList"
};
var DiscoverPeopleContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
// normalize data
var normalizeData = function(data, actionName) {
    if (actionName === actionType.FETCH_SUGGESTIONS) {
        return data.map(function(param) {
            var user = param.user, reason = param.reason, type = param.type;
            return {
                avatar: "".concat(constants_api__WEBPACK_IMPORTED_MODULE_5__/* .AVATAR_URL */ .q$, "/").concat(user.user_avatar),
                fullname: user.user_fullname,
                isFollowed: user.follow,
                isOfficial: user.is_verified,
                verifiedStatus: user === null || user === void 0 ? void 0 : user.verified_status,
                isLoading: false,
                reason: reason,
                type: type,
                id: user.userid,
                username: user.username
            };
        });
    }
    if (actionName === actionType.FETCH_CONTACT) {
        return data.map(function(user) {
            return {
                avatar: "".concat(constants_api__WEBPACK_IMPORTED_MODULE_5__/* .AVATAR_URL */ .q$, "/").concat(user.user_avatar),
                fullname: user.user_fullname,
                isFollowed: user.follow,
                isOfficial: user.is_verified,
                verifiedStatus: user === null || user === void 0 ? void 0 : user.verified_status,
                isLoading: false,
                id: user.userid,
                username: user.username
            };
        });
    }
    if (actionName === actionType.SEARCH_USER) {
        return data.people.map(function(_param) {
            var desc = _param.desc, is_following = _param.is_following, id = _param.id, img = _param.img, name = _param.name, is_verified = _param.is_verified, type = _param.type, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "desc",
                "is_following",
                "id",
                "img",
                "name",
                "is_verified",
                "type"
            ]);
            return {
                avatar: "".concat(constants_api__WEBPACK_IMPORTED_MODULE_5__/* .AVATAR_URL */ .q$, "/").concat(img),
                fullname: desc,
                id: id,
                isFollowed: is_following,
                isOfficial: is_verified,
                verifiedStatus: rest === null || rest === void 0 ? void 0 : rest.verified_status,
                isLoading: false,
                reason: "",
                type: type,
                username: name
            };
        });
    }
    if (actionName === actionType.FETCH_TRENDING) {
        return data.users.map(function(item) {
            var ref;
            return {
                avatar: item.avatar.thumb,
                id: item.id,
                username: item.username,
                fullname: item.fullname,
                isOfficial: item.status.is_verified,
                verifiedStatus: (ref = item.status) === null || ref === void 0 ? void 0 : ref.verified_status
            };
        });
    }
    return [];
};
var getSuggestFriends = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
        var config, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    config = {
                        limit: _constants__WEBPACK_IMPORTED_MODULE_6__/* .SUGGESTIONS_PERPAGE */ .FT,
                        page: page
                    };
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSuggestFriends */ .Z.getSuggestFriends(config);
                case 3:
                    data = _ctx.sent.data;
                    if (!(!data || data.error)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("failed to fetch friends suggestions");
                case 6:
                    return _ctx.abrupt("return", normalizeData((data === null || data === void 0 ? void 0 : data.data) || [], actionType.FETCH_SUGGESTIONS));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSuggestFriends(page) {
        return _ref.apply(this, arguments);
    };
}();
var getTrendingUserDiscovery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var timeframe, limit, cursor, response, data, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    timeframe = _args.length > 0 && _args[0] !== void 0 ? _args[0] : _types__WEBPACK_IMPORTED_MODULE_7__/* .TrendingTimeFrame.ALL */ .b.ALL, limit = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 100, cursor = _args.length > 2 ? _args[2] : void 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getTrending */ .Z.getTrending(timeframe, limit, cursor);
                case 3:
                    response = _ctx.sent;
                    data = response.data.data;
                    if (data) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("failed to fetch trending user");
                case 7:
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTrendingUserDiscovery() {
        return _ref.apply(this, arguments);
    };
}();
var getSearchUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page, keyword) {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_search__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getSearchPeople */ .Z.getSearchPeople(keyword, page);
                case 2:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Cannot perform request");
                case 5:
                    data = response.data.data;
                    return _ctx.abrupt("return", normalizeData(data, actionType.SEARCH_USER));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchUser(page, keyword) {
        return _ref.apply(this, arguments);
    };
}();
var getFriendSuggestionsContact = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
        var ref, config, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    config = {
                        limit: _constants__WEBPACK_IMPORTED_MODULE_6__/* .SUGGESTIONS_PERPAGE */ .FT,
                        page: page
                    };
                    _ctx.next = 4;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSuggestFriendsContacts */ .Z.getSuggestFriendsContacts(config.limit, config.page);
                case 4:
                    data = _ctx.sent.data;
                    if (!(!data || data.error)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("failed to fetch friends suggestions");
                case 7:
                    return _ctx.abrupt("return", normalizeData((data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.found) || [], actionType.FETCH_CONTACT));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFriendSuggestionsContact(page) {
        return _ref.apply(this, arguments);
    };
}();
var followUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var id, index, isFollowed, targetAPI, response;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    id = body.userid, index = body.index, isFollowed = body.isFollowed;
                    if (!(typeof index !== "number")) {
                        _ctx.next = 3;
                        break;
                    }
                    throw new Error("index must be a number");
                case 3:
                    if (id) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("userid is required");
                case 5:
                    targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postFollowUser */ .Z.postFollowUser;
                    if (isFollowed) {
                        targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postUnfollowUser */ .Z.postUnfollowUser;
                    }
                    _ctx.next = 9;
                    return targetAPI(id);
                case 9:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 12;
                        break;
                    }
                    throw new Error("Cannot perform request");
                case 12:
                    return _ctx.abrupt("return", response.data);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function followUser(body) {
        return _ref.apply(this, arguments);
    };
}();
var getCurrentQueryKey = function(filter) {
    return _constants__WEBPACK_IMPORTED_MODULE_6__/* .QUERY_KEY_DATA */ .ce[filter];
};


/***/ }),

/***/ 79695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "nO": function() { return /* binding */ earningsEffects; },
  "Y5": function() { return /* binding */ earningsSelectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/earnings.ts


var request = (0,requestExodus/* default */.Z)();
var GET_EARNINGS = "".concat(api/* API_EXODUS_URL */.q7, "/earnings");
var getEarnings = function(param) {
    var page = param.page, order = param.order, sortcol = param.sortcol, year = param.year, quarter = param.quarter, companySymbol = param.companySymbol, filter = param.filter;
    return request.get(GET_EARNINGS, {
        params: {
            filter: filter,
            search: companySymbol,
            quarter: quarter,
            year: year,
            sort_column: sortcol,
            order: order,
            page: page
        }
    });
};
/* harmony default export */ var earnings = (getEarnings);

// EXTERNAL MODULE: ./src/lib/api/screener.ts
var screener = __webpack_require__(70735);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
;// CONCATENATED MODULE: ./src/features/earnings/slice.ts








var CONTEXT = "@feature/earnings";
var actionType = {
    GET_SCREENER_UNIVERSE: "".concat(CONTEXT, "/GET_SCREENER_UNIVERSE"),
    GET_EARNINGS: "".concat(CONTEXT, "/GET_EARNINGS"),
    GET_SUGGESTED_COMPANY: "".concat(CONTEXT, "/GET_SUGGESTED_COMPANY")
};
var initialState = {
    screenerUniverse: {
        data: {},
        message: undefined,
        error: undefined,
        isLoading: undefined
    },
    earings: {
        data: {},
        message: undefined,
        error: undefined,
        isLoading: undefined
    },
    suggestedCompanies: {
        data: {},
        error: undefined,
        isLoading: undefined,
        message: undefined
    }
};
var earningsState = function(state) {
    return state.earnings;
};
var earningsSelectors = (0,es/* createSelector */.P1)(earningsState, function(calendar) {
    return {
        screenerUniverse: calendar.screenerUniverse,
        earnings: calendar.earings,
        suggestedCompanies: calendar.suggestedCompanies
    };
});
var reducers = {
    clearSuggestionCompany: function(state) {
        state.suggestedCompanies.data.company = [];
    }
};
var earningsEffects = {
    getScreenerUniverse: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SCREENER_UNIVERSE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return screener/* default.getScreenerUniverse */.Z.getScreenerUniverse();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get screener universe is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getEarnings: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EARNINGS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var page, order, sortcol, year, quarter, companySymbol, filter, response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        page = param.page, order = param.order, sortcol = param.sortcol, year = param.year, quarter = param.quarter, companySymbol = param.companySymbol, filter = param.filter;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return earnings({
                            page: page,
                            order: order,
                            sortcol: sortcol,
                            year: year,
                            quarter: quarter,
                            companySymbol: companySymbol,
                            filter: filter
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt get earnings data is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            filter: filter
                        }));
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getsuggestedCompanies: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SUGGESTED_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var query, response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = param.query;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.getSearchCompany */.Z.getSearchCompany(query);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt get suggested companies is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducer = function(builder) {
    builder.addCase(earningsEffects.getScreenerUniverse.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error;
        if (error) {
            state.screenerUniverse.error = error;
        } else {
            state.screenerUniverse.data = data;
            state.screenerUniverse.message = message;
        }
        state.screenerUniverse.isLoading = false;
    }).addCase(earningsEffects.getScreenerUniverse.pending, function(state) {
        state.screenerUniverse.isLoading = true;
    }).addCase(earningsEffects.getScreenerUniverse.rejected, function(state, action) {
        state.screenerUniverse.error = action.payload.error;
        state.screenerUniverse.isLoading = false;
    }).addCase(earningsEffects.getEarnings.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error, filter = _payload.filter;
        if (error) {
            state.earings.error = error;
        } else {
            state.earings.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                filter: filter
            });
            state.earings.message = message;
        }
        state.earings.isLoading = false;
    }).addCase(earningsEffects.getEarnings.pending, function(state) {
        state.earings.isLoading = true;
    }).addCase(earningsEffects.getEarnings.rejected, function(state, action) {
        state.earings.error = action.payload.error;
        state.earings.isLoading = false;
    }).addCase(earningsEffects.getsuggestedCompanies.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error;
        if (error) {
            state.suggestedCompanies.error = error;
        } else {
            state.suggestedCompanies.data = data;
            state.suggestedCompanies.message = message;
        }
        state.suggestedCompanies.isLoading = false;
    }).addCase(earningsEffects.getsuggestedCompanies.pending, function(state) {
        state.suggestedCompanies.isLoading = true;
    }).addCase(earningsEffects.getsuggestedCompanies.rejected, function(state, action) {
        state.suggestedCompanies.error = action.payload.error;
        state.suggestedCompanies.isLoading = false;
    });
};
var earningsSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "earnings",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ var slice = (earningsSlice);


/***/ }),

/***/ 86033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ DISCOVER_PEOPLE_STATE; }
/* harmony export */ });
// this state name follows the naming in the './slice' `initialState`
var DISCOVER_PEOPLE_STATE = {
    SUGGEST: "getSuggestFriends",
    SEARCH: "getSearchPeople"
};
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 36203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63699);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44590);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86033);



// APIs



// Models

// initial state
var initialState = {
    getSuggestFriends: {
        data: [],
        isLoading: true,
        error: null,
        message: ""
    },
    followUser: {
        data: {},
        isLoading: true,
        error: null,
        message: ""
    },
    getSearchPeople: {
        data: {
            company: [],
            sector: [],
            insider: [],
            chat: [],
            user_more: 0,
            company_more: 0,
            people: []
        },
        isLoading: true,
        error: null,
        message: ""
    }
};
// selectors
var discoverPeopleState = function(state) {
    return state.onboarding.discoverPeople;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(discoverPeopleState, function(discoverPeopleState) {
    return {
        getSuggestFriends: discoverPeopleState.getSuggestFriends,
        postFollowUser: discoverPeopleState.followUser,
        getSearchPeople: discoverPeopleState.getSearchPeople
    };
}, function(state) {
    return state;
});
// action types
var CONTEXT = "@onboarding/discoverPeople";
var actionType = {
    GET_SUGGEST_FRIENDS: "".concat(CONTEXT, "/GET_SUGGEST_FRIENDS"),
    FOLLOW_USER: "".concat(CONTEXT, "/FOLLOW_USER"),
    GET_SEARCH_PEOPLE: "".concat(CONTEXT, "/GET_SEARCH_PEOPLE")
};
// side effects
var effects = {
    // getSuggestFriends -------------------------------------------------------------------
    getSuggestFriends: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SUGGEST_FRIENDS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_friends__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSuggestFriends */ .Z.getSuggestFriends(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 9;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 9:
                        throw new Error("Attempt to get friends suggest Failed");
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postFollowUser -------------------------------------------------------------------
    toggleFollowUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.FOLLOW_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var index, userid, stateKey, _type, type, targetAPI, response, _data, data, message, _$error, dataUserChanged;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        index = param.index, userid = param.userid, stateKey = param.stateKey, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("userid is required");
                    case 4:
                        targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postFollowUser */ .Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postUnfollowUser */ .Z.postUnfollowUser;
                        }
                        _ctx.next = 8;
                        return targetAPI(userid);
                    case 8:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (response.data) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error("Cannot perform request");
                    case 12:
                        dataUserChanged = {
                            userid: userid,
                            followed: type
                        };
                        return _ctx.abrupt("return", {
                            data: data,
                            error: _$error,
                            message: message,
                            index: index,
                            stateKey: stateKey,
                            dataUserChanged: dataUserChanged
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // getSearchPeople -------------------------------------------------------------------
    getSearchPeople: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_PEOPLE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var keyword, page, response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = param.keyword, page = param.page;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSearchPeople */ .Z.getSearchPeople(keyword, page);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        throw new Error("Attempt to search friends Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// reducers
var reducers = {
    clearSearch: function(state) {
        state.getSearchPeople.data = {
            company: [],
            sector: [],
            insider: [],
            chat: [],
            user_more: 0,
            company_more: 0,
            people: []
        };
    }
};
// extra reducers
var extraReducers = function(builder) {
    builder.addCase(effects.getSuggestFriends.pending, function(state) {
        state.getSuggestFriends.isLoading = true;
    }).addCase(effects.getSuggestFriends.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.getSuggestFriends.error = error;
        } else {
            state.getSuggestFriends.data = data;
        }
        state.getSuggestFriends.message = message;
        state.getSuggestFriends.isLoading = false;
    }).addCase(effects.getSuggestFriends.rejected, function(state, action) {
        state.getSuggestFriends.error = action.payload.error;
        state.getSuggestFriends.isLoading = false;
    }).addCase(effects.toggleFollowUser.pending, function(state) {
        state.followUser.isLoading = true;
    }).addCase(effects.toggleFollowUser.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, index = _payload.index, stateKey = _payload.stateKey, dataUserChanged = _payload.dataUserChanged;
        if (error) {
            state.followUser.error = error;
        } else {
            var isFollowed = dataUserChanged.followed === "FOLLOW";
            var selectedState = state[stateKey].data;
            if (stateKey === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DISCOVER_PEOPLE_STATE.SUGGEST */ .v.SUGGEST) {
                selectedState[index].user.follow = isFollowed;
            } else if (stateKey === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DISCOVER_PEOPLE_STATE.SEARCH */ .v.SEARCH) {
                selectedState.people[index].is_following = isFollowed;
            }
            state.followUser.data = data;
        }
        state.followUser.message = message;
        state.followUser.isLoading = false;
    }).addCase(effects.toggleFollowUser.rejected, function(state, action) {
        state.followUser.error = action.payload.error;
        state.followUser.isLoading = false;
    }).addCase(effects.getSearchPeople.pending, function(state) {
        state.getSearchPeople.isLoading = true;
    }).addCase(effects.getSearchPeople.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.getSearchPeople.error = error;
        } else {
            state.getSearchPeople.data = data;
        }
        state.getSearchPeople.message = message;
        state.getSearchPeople.isLoading = false;
    }).addCase(effects.getSearchPeople.rejected, function(state, action) {
        state.getSearchPeople.error = action.payload.error;
        state.getSearchPeople.isLoading = false;
    });
};
// Create the slice
var discoverPeopleSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "discoverPeople",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (discoverPeopleSlice);


/***/ }),

/***/ 9073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var lib_entities_company__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74645);




// API

// Company reducer

// Initial State
var initialState = {
    suggestions: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    }
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(function(state) {
    return {
        suggestions: state.onboarding.discoverStock.suggestions
    };
}, function(state) {
    return state;
});
// Action Types
var CONTEXT = "@onboarding/discoverStock";
var actionType = {
    FETCH_SUGGESTION: "".concat(CONTEXT, "/FETCH_SUGGESTION")
};
// Effects
var effects = {
    getSuggestionCompany: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.FETCH_SUGGESTION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(watchlistId) {
            var response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanySuggestions */ .Z.getCompanySuggestions(watchlistId);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 9;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 9:
                        throw new Error("Attempt to fetch Suggestion company Failed");
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(watchlistId) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var _obj;
// Extra reducers
var extraReducers = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, effects.getSuggestionCompany.pending, function(state) {
    state.suggestions.isLoading = true;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, effects.getSuggestionCompany.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
    if (error) {
        state.suggestions.error = error;
    } else {
        state.suggestions.data = data;
    }
    state.suggestions.isLoading = false;
    state.suggestions.message = message;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, effects.getSuggestionCompany.rejected, function(state, action) {
    state.suggestions.error = action.payload.error;
    state.suggestions.isLoading = false;
}), // TODO: Listen only if given parameter to update
// success follow company
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .effects.postFollowCompany.fulfilled */ .Sz.postFollowCompany.fulfilled, function(state, action) {
    // find index of company by id
    // update followed value to `1`
    var STATUS_FOLLOWING = 1;
    var _payload = action.payload, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
    if (data && stateToUpdate === lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .STATE_SUGGESTION */ .IN) {
        var companyid = data.companyid;
        // const newSuggestions = state.suggestions.data.map((s) => ({ ...s }));
        var newSuggestions = state.suggestions.data;
        var companyIndex = newSuggestions.findIndex(function(param) {
            var id = param.id;
            return Number(id) === Number(companyid);
        });
        // there's company in suggestion list
        if (companyIndex > -1) {
            // update `companyData` following status to `1` alias followed
            state.suggestions.data[companyIndex].followed = STATUS_FOLLOWING;
        }
    }
}), // success unfollow company
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .effects.postUnfollowCompany.fulfilled */ .Sz.postUnfollowCompany.fulfilled, function(state, action) {
    // find index of company by id
    // update followed value to 0
    var STATUS_UNFOLLOWING = 0;
    var _payload = action.payload, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
    if (data && stateToUpdate === lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .STATE_SUGGESTION */ .IN) {
        var companyid = data.companyid;
        // const newSuggestions = state.suggestions.data.map((s) => ({ ...s }));
        var newSuggestions = state.suggestions.data;
        var companyIndex = newSuggestions.findIndex(function(param) {
            var id = param.id;
            return Number(id) === Number(companyid);
        });
        // there's company in suggestion list
        if (companyIndex > -1) {
            // update `companyData` following status to `0` alias unfollowed
            state.suggestions.data[companyIndex].followed = STATUS_UNFOLLOWING;
        }
    }
}), _obj);
var discoverStockSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "discoverStock",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (discoverStockSlice);


/***/ }),

/***/ 12229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61876);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1955);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);



// APIs

// alert error message

// constant

// Initial state
var initialState = {
    uploadImage: {
        isLoading: false,
        error: null
    },
    uploadToken: {
        data: {
            bucketUrl: "",
            key: "",
            xAmzCredential: "",
            xAmzAlgorithm: "",
            xAmzDate: "",
            xAmzSecurityToken: "",
            policy: "",
            xAmzSignature: ""
        },
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return {
        uploadImageAvatar: state.onboarding.uploadImageAvatar.uploadImage,
        uploadToken: state.onboarding.uploadImageAvatar.uploadToken
    };
}, function(state) {
    return state;
});
// Action types
var CONTEXT = "@onboarding/uploadImageAvatar";
var actionType = {
    UPLOAD_IMAGE_AVATAR: "".concat(CONTEXT, "/UPLOAD_IMAGE_AVATAR"),
    RETRIEVE_UPLOAD_TOKEN: "".concat(CONTEXT, "/RETRIEVE_UPLOAD_TOKEN")
};
var effects = {
    retrieveUploadToken: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.RETRIEVE_UPLOAD_TOKEN, function() {
        var _ref = // @ts-ignore
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(fileName) {
            var response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"].retrieveUploadToken */ .Z.retrieveUploadToken(fileName);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].UPLOAD_FAILED */ .Z.UPLOAD_FAILED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(fileName) {
            return _ref.apply(this, arguments);
        };
    }()),
    // uploadImageAvatar -------------------------------------------------------------------
    uploadImageAvatar: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.UPLOAD_IMAGE_AVATAR, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataFile, param) {
            var dispatch, getState, state, file, fd, formerFile, _data, key, xAmzCredential, xAmzAlgorithm, xAmzDate, xAmzSecurityToken, policy, xAmzSignature;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch = param.dispatch, getState = param.getState;
                        state = getState();
                        file = dataFile.file;
                        _ctx.prev = 3;
                        fd = new FormData();
                        formerFile = null;
                        /* eslint no-underscore-dangle: 0 */ if (file._file) formerFile = file._file;
                        _data = state.onboarding.uploadImageAvatar.uploadToken.data, key = _data.key, xAmzCredential = _data.xAmzCredential, xAmzAlgorithm = _data.xAmzAlgorithm, xAmzDate = _data.xAmzDate, xAmzSecurityToken = _data.xAmzSecurityToken, policy = _data.policy, xAmzSignature = _data.xAmzSignature;
                        fd.append("key", key);
                        fd.append("content-type", "image/jpeg");
                        fd.append("x-amz-credential", xAmzCredential);
                        fd.append("x-amz-algorithm", xAmzAlgorithm);
                        fd.append("x-amz-date", xAmzDate);
                        fd.append("x-amz-security-token", xAmzSecurityToken);
                        fd.append("policy", policy);
                        fd.append("x-amz-signature", xAmzSignature);
                        if (!formerFile) {
                            fd.append("file", file);
                        } else {
                            fd.append("file", formerFile);
                        }
                        return _ctx.abrupt("return", fetch(state.onboarding.uploadImageAvatar.uploadToken.data.bucketUrl, {
                            method: "POST",
                            cache: "default",
                            body: fd,
                            mode: "cors"
                        }).then(function(response) {
                            if (response.status === 204) {
                                return {
                                    message: "ok"
                                };
                            }
                            (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].UPLOAD_FAILED */ .Z.UPLOAD_FAILED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                            throw new Error("error while trying to upload image");
                        }));
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](3);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    20
                ]
            ]);
        }));
        return function(dataFile, _) {
            return _ref.apply(this, arguments);
        };
    }())
};
// reducers
var reducers = {};
var extraReducers = function(builder) {
    builder.addCase(effects.retrieveUploadToken.pending, function(state, action) {
        state.uploadToken.isLoading = true;
    }).addCase(effects.retrieveUploadToken.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        var url = data.url, fields = data.fields;
        if (error) {
            state.uploadToken.error = error;
        } else {
            state.uploadToken.data.bucketUrl = url;
            state.uploadToken.data.key = fields[0].value;
            state.uploadToken.data.xAmzCredential = fields[2].value;
            state.uploadToken.data.xAmzAlgorithm = fields[3].value;
            state.uploadToken.data.xAmzDate = fields[4].value;
            state.uploadToken.data.xAmzSecurityToken = fields[5].value;
            state.uploadToken.data.policy = fields[6].value;
            state.uploadToken.data.xAmzSignature = fields[7].value;
        }
        state.uploadToken.message = message;
        state.uploadToken.isLoading = false;
    }).addCase(effects.retrieveUploadToken.rejected, function(state, action) {
        state.uploadToken.error = action.payload.error;
        state.uploadToken.isLoading = false;
    }).addCase(effects.uploadImageAvatar.pending, function(state, action) {
        state.uploadImage.isLoading = true;
    }).addCase(effects.uploadImageAvatar.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.uploadImage.error = error;
        }
        state.uploadImage.isLoading = false;
    }).addCase(effects.uploadImageAvatar.rejected, function(state, action) {
        state.uploadImage.error = action.payload.error;
        state.uploadImage.isLoading = false;
    });
};
// Create slice
var uploadAvatarSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "uploadImageAvatar",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (uploadAvatarSlice);


/***/ }),

/***/ 28563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51679);
/* harmony import */ var global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47225);
/* harmony import */ var lib_entities_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25641);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14601);
/* eslint-disable no-undef */ 







var STATUS_FOLLOWING = 1;
var STATUS_UNFOLLOWING = 0;
var STATUS_SAVED = 1;
var STATUS_UNSAVED = 0;
var STATUS_LIKED = 1;
var STATUS_UNLIKED = 0;
var initialState = {
    post: {},
    isLoading: true,
    error: null,
    message: ""
};
// selectors
var postDetail = function(state) {
    return state.postDetail;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(postDetail, function(detail) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, detail);
});
// Action types
var CONTEXT = "@features/post-detail";
var actionType = {
    GET_POST: "".concat(CONTEXT, "/GET_POST")
};
var effects = {
    getPostDetail: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_POST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var postId, response, _data, _$error, message, postData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postId = param.postId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStreamDetail */ .Z.getStreamDetail(postId);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get stream post detail failed");
                    case 7:
                        _data = response.data, _$error = _data.error_type, message = _data.message, postData = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        data = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .transformStreamV3 */ .hp)(postData);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            postid: postId
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {};
var extraReducers = function(builder) {
    builder.addCase(effects.getPostDetail.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getPostDetail.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, postid = _payload.postid;
        if (error) {
            state.error = error;
        } else {
            state.post[postid] = data;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.likePost.fulfilled */ .Sz.likePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].liked = STATUS_LIKED;
            state.post[postid].likes = data.likes;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.unlikePost.fulfilled */ .Sz.unlikePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].liked = STATUS_UNLIKED;
            state.post[postid].likes = data.likes;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.followPost.fulfilled */ .Sz.followPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].follow = STATUS_FOLLOWING;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.unfollowPost.fulfilled */ .Sz.unfollowPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].follow = STATUS_UNFOLLOWING;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.savePost.fulfilled */ .Sz.savePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].saved = STATUS_SAVED;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.unsavePost.fulfilled */ .Sz.unsavePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].saved = STATUS_UNSAVED;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.postVotePolling.fulfilled */ .Sz.postVotePolling.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        var postid = action.meta.arg.postid;
        if (!error && state.post[postid]) {
            state.post[postid].polling = [
                data
            ];
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.postVoteTargetPrice.fulfilled */ .Sz.postVoteTargetPrice.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        var postid = action.meta.arg.postid;
        if (!error && state.post[postid]) {
            state.post[postid].target_price = data === null || data === void 0 ? void 0 : data.target_price;
        }
    })// Update likes count after get stream likers
    .addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.getStreamLikers.fulfilled */ .Sz.getStreamLikers.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, postid = _payload.postid, error = _payload.error;
        if (!error && state.post[postid]) {
            var ref;
            state.post[postid].likes = data === null || data === void 0 ? void 0 : (ref = data.likers) === null || ref === void 0 ? void 0 : ref.length;
        }
    })// Update stream if updated
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_3__/* .effects.updatePostStream.fulfilled */ .Sz.updatePostStream.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        var currentPost = state.post[data === null || data === void 0 ? void 0 : data.postid];
        // @ts-ignore
        if (data && !error && currentPost) {
            state.post[data === null || data === void 0 ? void 0 : data.postid] = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, currentPost, data);
        }
    });
};
var postDetailSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "postDetail",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (postDetailSlice);


/***/ }),

/***/ 2915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var utils_generateUsername__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49431);
/* harmony import */ var lib_api_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6242);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9260);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7865);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28456);



// Auth Related Modules





// Actions
var CONTEXT = "@feature/register/facebook";
var actionType = {
    FB_GENERATE_USERNAME: "".concat(CONTEXT, "/generateUsername")
};
var initialState = {
    isLoading: false,
    error: null,
    message: ""
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function(state) {
    return {
        isLoading: state.register.facebookOauth.isLoading,
        error: state.register.facebookOauth.error,
        message: state.register.facebookOauth.message
    };
}, function(state) {
    return state;
});
// Effects (thunks / async operations that needs side effects)
var effects = {
    generateUsername: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.FB_GENERATE_USERNAME, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var accountkey, accountid, fbError, email, fullname, dispatch, data, username, ref, ref1, responseMessage;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        accountkey = param.accessToken, accountid = param.id, fbError = param.error, email = param.email, fullname = param.name, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        if (!(fbError || !accountkey || !accountid)) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error(fbError);
                    case 4:
                        _ctx.next = 6;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validateSocialMedia */ .Z.validateSocialMedia(accountid, accountkey, email, _constants__WEBPACK_IMPORTED_MODULE_5__/* .newRegisterTypes.FACEBOOK */ .AY.FACEBOOK);
                    case 6:
                        data = _ctx.sent.data;
                        username = utils_generateUsername__WEBPACK_IMPORTED_MODULE_1__/* ["default"].normalUsername */ .Z.normalUsername(fullname);
                        _ctx.next = 10;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validateRegisterForm */ .Z.validateRegisterForm("username", username, data.data.key).catch(function(_) {
                            username = utils_generateUsername__WEBPACK_IMPORTED_MODULE_1__/* ["default"].randomUsername */ .Z.randomUsername(fullname);
                        });
                    case 10:
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_3__/* ["default"].actions.storeEmailVerifData */ .ZP.actions.storeEmailVerifData({
                            tempKey: data.data.key,
                            emailStatus: data.data.status
                        }));
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_3__/* ["default"].actions.storeSocialIdentities */ .ZP.actions.storeSocialIdentities({
                            accountid: accountid,
                            accountkey: accountkey,
                            email: email,
                            fullname: fullname,
                            username: username,
                            type: _constants__WEBPACK_IMPORTED_MODULE_5__/* .registerTypes.FACEBOOK */ .E8.FACEBOOK
                        }));
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_3__/* ["default"].actions.changeForm */ .ZP.actions.changeForm({
                            target: _constants__WEBPACK_IMPORTED_MODULE_5__/* .formTypes.EMAIL */ .o_.EMAIL
                        }));
                        return _ctx.abrupt("return", {
                            accountid: accountid,
                            accountkey: accountkey,
                            email: email,
                            fullname: fullname,
                            username: username
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        responseMessage = ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message;
                        (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .handleRegistrationError */ .zj)(responseMessage, email);
                        return _ctx.abrupt("return", Promise.reject(responseMessage));
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra reducers (handle actions that are not defined in this slice)
var extraReducers = function(builder) {
    // generate username - pending
    builder.addCase(effects.generateUsername.pending, function(state) {
        state.isLoading = true;
    });
    // generate username - fulfilled
    builder.addCase(effects.generateUsername.fulfilled, function(state) {
        state.isLoading = false;
        state.error = null;
    });
    // generate username - rejected
    builder.addCase(effects.generateUsername.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    });
};
var loginSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "facebook",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (loginSlice);


/***/ }),

/***/ 84405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var utils_generateUsername__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49431);
/* harmony import */ var lib_api_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6242);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9260);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7865);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28456);



// Auth Related Modules





// Actions
var CONTEXT = "@register/googleOauth";
var actionType = {
    GOOGLE_LOGIN: "".concat(CONTEXT, "/login"),
    GOOGLE_REGISTER: "".concat(CONTEXT, "/register"),
    GOOGLE_GENERATE_USERNAME: "".concat(CONTEXT, "/generateUsername")
};
var initialState = {
    isLoading: false,
    error: null,
    message: ""
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function(state) {
    return {
        isLoading: state.register.googleOauth.isLoading,
        error: state.register.googleOauth.error,
        message: state.register.googleOauth.message
    };
}, function(state) {
    return state;
});
// Effects (thunks / async operations that needs side effects)
var effects = {
    // register
    generateUsername: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GOOGLE_GENERATE_USERNAME, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var _profileObj, email, fullname, accountid, accountkey, errorResponse, dispatch, data, username, ref, ref1, responseMessage;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _profileObj = param.profileObj, email = _profileObj.email, fullname = _profileObj.name, accountid = param.googleId, accountkey = param.tokenId, errorResponse = param.error, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        if (!errorResponse) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error(errorResponse);
                    case 4:
                        _ctx.next = 6;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validateSocialMedia */ .Z.validateSocialMedia(accountid, accountkey, email, _constants__WEBPACK_IMPORTED_MODULE_5__/* .newRegisterTypes.GOOGLE */ .AY.GOOGLE);
                    case 6:
                        data = _ctx.sent.data;
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_3__/* ["default"].actions.storeEmailVerifData */ .ZP.actions.storeEmailVerifData({
                            tempKey: data.data.key,
                            emailStatus: data.data.status
                        }));
                        username = utils_generateUsername__WEBPACK_IMPORTED_MODULE_1__/* ["default"].normalUsername */ .Z.normalUsername(fullname);
                        _ctx.next = 11;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validateRegisterForm */ .Z.validateRegisterForm("username", username, data.data.key).catch(function(_) {
                            username = utils_generateUsername__WEBPACK_IMPORTED_MODULE_1__/* ["default"].randomUsername */ .Z.randomUsername(fullname);
                        });
                    case 11:
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_3__/* ["default"].actions.storeSocialIdentities */ .ZP.actions.storeSocialIdentities({
                            accountid: accountid,
                            accountkey: accountkey,
                            email: email,
                            fullname: fullname,
                            username: username,
                            type: _constants__WEBPACK_IMPORTED_MODULE_5__/* .registerTypes.GOOGLE */ .E8.GOOGLE
                        }));
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_3__/* ["default"].actions.changeForm */ .ZP.actions.changeForm({
                            target: _constants__WEBPACK_IMPORTED_MODULE_5__/* .formTypes.EMAIL */ .o_.EMAIL
                        }));
                        return _ctx.abrupt("return", {
                            accountid: accountid,
                            accountkey: accountkey,
                            email: email,
                            fullname: fullname,
                            username: username
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        responseMessage = ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message;
                        (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .handleRegistrationError */ .zj)(responseMessage, email);
                        return _ctx.abrupt("return", Promise.reject(responseMessage));
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra reducers (handle actions that are not defined in this slice)
var extraReducers = function(builder) {
    // generate username - pending
    builder.addCase(effects.generateUsername.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    });
    // generate username - fullfilled
    builder.addCase(effects.generateUsername.fulfilled, function(state) {
        state.isLoading = false;
        state.error = null;
    });
    // generate username - rejected
    builder.addCase(effects.generateUsername.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    });
};
var googleOauthSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "googleOauth",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (googleOauthSlice);


/***/ }),

/***/ 39910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_research__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47752);





// action types
var CONTEXT = "@feature/research";
var actionType = {
    GET_SNIPS: "".concat(CONTEXT, "/GET_SNIPS"),
    GET_CATEGORIES: "".concat(CONTEXT, "/GET_CATEGORIES")
};
var initialState = {
    research: {
        isLoading: true,
        message: null,
        data: [],
        error: null,
        hasMore: true
    },
    categories: {
        isLoading: true,
        message: null,
        data: [],
        error: null
    }
};
var researchState = function(state) {
    return state.research;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(researchState, function(research) {
    return {
        research: {
            isLoading: research.research.isLoading,
            message: research.research.message,
            data: research.research.data,
            error: research.research.error,
            hasMore: research.research.hasMore
        },
        categories: {
            isLoading: research.categories.isLoading,
            message: research.categories.message,
            data: research.categories.data,
            error: research.categories.error
        }
    };
});
var effects = {
    getData: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SNIPS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, param) {
            var getState, categories, ref, _$error, error_type, data, message, research, _research, oldData;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,lib_api_research__WEBPACK_IMPORTED_MODULE_1__/* .getResearchData */ .RJ)(params);
                    case 4:
                        categories = _ctx.sent;
                        if (!(categories.status !== 200)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error");
                    case 7:
                        ref = categories === null || categories === void 0 ? void 0 : categories.data, _$error = ref.error, error_type = ref.error_type, data = ref.data, message = ref.message;
                        if (!(_$error || error_type)) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error || error_type);
                    case 10:
                        research = getState().research;
                        _research = research.research, oldData = _research.data;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            oldData: oldData
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(params, _) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCategories: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_CATEGORIES, // @ts-ignore
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var categories, ref, _$error, error_type, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,lib_api_research__WEBPACK_IMPORTED_MODULE_1__/* .getCategories */ .CP)();
                case 3:
                    categories = _ctx.sent;
                    if (!(categories.status !== 200)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error");
                case 6:
                    ref = categories === null || categories === void 0 ? void 0 : categories.data, _$error = ref.error, error_type = ref.error_type, data = ref.data, message = ref.message;
                    if (!(_$error || error_type)) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error || error_type);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
var extraReducer = function(builder) {
    builder.addCase(effects.getData.pending, function(state) {
        state.research.isLoading = true;
    }).addCase(effects.getData.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, oldData = _payload.oldData;
        state.research.isLoading = false;
        if (data === null || data === void 0 ? void 0 : data.length) {
            state.research.data = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(oldData).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(data));
        } else {
            state.research.hasMore = false;
        }
        state.research.message = message;
    }).addCase(effects.getData.rejected, function(state, action) {
        state.research.isLoading = false;
        state.research.error = action.payload.error;
    }).addCase(effects.getCategories.pending, function(state) {
        state.categories.isLoading = true;
    }).addCase(effects.getCategories.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.categories.isLoading = false;
        state.categories.data = (data === null || data === void 0 ? void 0 : data.category) || [];
        state.categories.message = message;
    }).addCase(effects.getCategories.rejected, function(state, action) {
        state.categories.isLoading = false;
        state.categories.error = action.payload.error;
    });
};
var researchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "research",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducer
});
/* harmony default export */ __webpack_exports__["ZP"] = (researchSlice);


/***/ }),

/***/ 7021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6242);




// Auth Related Modules

// Actions
var CONTEXT = "@reset-password";
var actionType = {
    SUBMIT_NEW_PASSWORD: "".concat(CONTEXT, "/SUBMIT_NEW_PASSWORD")
};
// initial state
var initialState = {
    error: null,
    form: {
        newpass: "",
        confirmpass: "",
        passkey: "",
        userid: ""
    },
    isLoading: false,
    isSuccess: false,
    message: "",
    data: null
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return {
        error: state.resetPassword.error,
        isLoading: state.resetPassword.isLoading,
        isSuccess: state.resetPassword.isSuccess,
        message: state.resetPassword.message,
        data: state.resetPassword.data
    };
}, function(state) {
    return state;
});
// Reducer
var reducers = {
    storeCredentials: function(draft, actions) {
        draft.passkey = actions.payload.passkey;
        draft.userid = actions.payload.userid;
    }
};
// effects
var effects = {
    // login
    resetPassword: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SUBMIT_NEW_PASSWORD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var passkey, userid, newpass, confirmpass, response, _data, message, _$error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        passkey = param.passkey, userid = param.userid, newpass = param.newpass, confirmpass = param.confirmpass;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].resetPassword */ .Z.resetPassword(userid, passkey, newpass, confirmpass);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when changing password, no data recevied");
                    case 7:
                        _data = response.data, message = _data.message, _$error = _data.error, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            message: message,
                            data: data
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var _obj;
// Extra / Async Reducer
var extraReducers = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, effects.resetPassword.pending, function(state) {
    state.isLoading = true;
    state.isSuccess = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, effects.resetPassword.fulfilled, function(state, action) {
    state.message = action.payload.message;
    state.isLoading = false;
    state.isSuccess = true;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, effects.resetPassword.rejected, function(state, action) {
    state.isLoading = false;
    state.isSuccess = false;
    state.error = action.error;
}), _obj);
// Slice
var resetPasswordSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "resetPassword",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (resetPasswordSlice);


/***/ }),

/***/ 15183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ko": function() { return /* binding */ screenerEffects; },
/* harmony export */   "p0": function() { return /* binding */ screenerSelectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61876);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_screener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70735);
/* eslint-disable no-undef */ 









// action types
var CONTEXT = "@feature/screener";
var actionType = {
    GET_SCREENER_FAVORITES: "".concat(CONTEXT, "/GET_SCREENER_FAVORITES"),
    GET_SCREENER_PRESET: "".concat(CONTEXT, "/GET_SCREENER_PRESET"),
    ADD_FAVORITE_SCREENER: "".concat(CONTEXT, "/ADD_FAVORITE_SCREENER"),
    REMOVE_FAVORITE_SCREENER: "".concat(CONTEXT, "/REMOVE_FAVORITE_SCREENER"),
    GET_SCREENER_UNIVERSE: "".concat(CONTEXT, "/GET_SCREENER_UNIVERSE"),
    GET_SCREENER_FINANCIAL: "".concat(CONTEXT, "/GET_SCREENER_FINANCIAL"),
    SAVE_OR_RUN_SCREENER: "".concat(CONTEXT, "/SAVE_OR_RUN_SCREENER"),
    GET_SCREENER: "".concat(CONTEXT, "/GET_SCREENER"),
    GET_SCREENER_CUSTOM: "".concat(CONTEXT, "/GET_SCREENER_CUSTOM"),
    REMOVE_SCREENER_CUSTOM: "".concat(CONTEXT, "/REMOVE_SCREENER_CUSTOM")
};
var initialState = {
    screenerUtils: {
        isFormActive: false,
        isFormEditMode: false,
        isFormCreateMode: false,
        isModalPresetScreenerActive: false,
        isModalFinancialMetricActive: false,
        isModalAddColumnActive: false,
        screenerAction: null,
        isEmptyResult: false
    },
    screenerFavorites: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerPreset: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    activeScreener: 0,
    addFavoriteScreenerResult: {
        isError: false,
        isLoading: false,
        message: ""
    },
    removeFavoriteScreenerResult: {
        isError: false,
        isLoading: false,
        message: ""
    },
    screenerUniverse: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    },
    screenerFinancialMetric: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerResult: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    },
    screenerModal: {
        financialModal: {
            id: null,
            name: null
        },
        presetModal: {
            id: null,
            name: null
        },
        addColumnModal: {
            id: null,
            name: null
        }
    },
    screenerCustom: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    removeCustomScreenerResult: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerPostResult: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    }
};
var screenerState = function(state) {
    return state.screener;
};
var screenerSelectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(screenerState, function(screener) {
    return {
        screenerUtils: screener.screenerUtils,
        screenerPreset: screener.screenerPreset,
        screenerFavorites: screener.screenerFavorites,
        addFavoriteScreenerResult: screener.addFavoriteScreenerResult,
        removeFavoriteScreenerResult: screener.removeFavoriteScreenerResult,
        screenerUniverse: screener.screenerUniverse,
        screenerFinancialMetric: screener.screenerFinancialMetric,
        screenerModal: screener.screenerModal,
        screenerResult: screener.screenerResult,
        screenerCustom: screener.screenerCustom,
        removeScreenerCustomResult: screener.removeCustomScreenerResult,
        screenerPostResult: screener.screenerPostResult
    };
});
var screenerEffects = {
    getScreenerFavorites: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_FAVORITES, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerFavorites */ .Z.getScreenerFavorites();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get list of favorites screener failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getScreenerPreset: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_PRESET, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerMetrics */ .Z.getScreenerMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get list of screener preset failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    addFavorite: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.ADD_FAVORITE_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, screenerType, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, screenerType = param.screenerType;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].addScreenerFavorite */ .Z.addScreenerFavorite(screenerID, screenerType);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to add screener favorite failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    removeFavorite: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.REMOVE_FAVORITE_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, screenerType, response, data, removedID;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, screenerType = param.screenerType;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].removeScreenerFavorite */ .Z.removeScreenerFavorite(screenerID, screenerType);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to remove screener favorite failed");
                    case 7:
                        data = response.data;
                        removedID = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, data), {
                            data: screenerID
                        });
                        return _ctx.abrupt("return", removedID);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreenerUniverse: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_UNIVERSE, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerUniverse */ .Z.getScreenerUniverse();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get screener universe is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getScreenerFinancialMetric: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_FINANCIAL, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerFinancial */ .Z.getScreenerFinancial();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get financial metric is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    postScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.SAVE_OR_RUN_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var fromForm, payload, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        fromForm = _param.fromForm, payload = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
                            "fromForm"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postScreenerListResult */ .Z.postScreenerListResult(payload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt save or run screener is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, data), {
                            fromForm: fromForm
                        }));
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, type, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLoadPresetScreener */ .Z.getLoadPresetScreener(screenerID, type);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get screener data is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_CUSTOM, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerCustom */ .Z.getScreenerCustom();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get custom screener is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    removeScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.REMOVE_SCREENER_CUSTOM, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].removeScreenerCustom */ .Z.removeScreenerCustom(id);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to remove custom screener is failed");
                    case 7:
                        data = response.data;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SCREENER_TEMPLATE_DELETED */ .Z.SCREENER_TEMPLATE_DELETED, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    setIsFormActive: function(state, action) {
        state.screenerUtils.isFormActive = action.payload;
    },
    setIsFormEditMode: function(state, action) {
        state.screenerUtils.isFormEditMode = action.payload;
    },
    setIsFormCreateMode: function(state, action) {
        state.screenerUtils.isFormCreateMode = action.payload;
    },
    setIsModalPresetScreenerActive: function(state, action) {
        state.screenerUtils.isModalPresetScreenerActive = action.payload;
    },
    setIsModalFinancialMetricActive: function(state, action) {
        state.screenerUtils.isModalFinancialMetricActive = action.payload;
    },
    setIsModalAddColumnActive: function(state, action) {
        state.screenerUtils.isModalAddColumnActive = action.payload;
    },
    setActiveScreener: function(state, action) {
        state.activeScreener = action.payload;
    },
    setScreenerModal: function(state, action) {
        var _payload = action.payload, screenerType = _payload.screenerType, id = _payload.id, name = _payload.name;
        if (screenerType === "preset") {
            state.screenerModal.presetModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.presetModal), {
                id: id,
                name: name
            });
            state.screenerModal.presetModal.name = name;
        } else if (screenerType === "financial") {
            state.screenerModal.financialModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.financialModal), {
                id: id,
                name: name
            });
            state.screenerModal.financialModal.name = name;
        } else if (screenerType === "column") {
            state.screenerModal.addColumnModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.addColumnModal), {
                id: id,
                name: name
            });
        }
    },
    resetFormState: function(state) {
        state.screenerUtils.isFormActive = false;
        state.screenerUtils.isFormEditMode = false;
        state.screenerUtils.isFormCreateMode = false;
        state.screenerResult.data = {};
        state.screenerPostResult.data = {};
        state.screenerUtils.screenerAction = null;
        state.screenerUtils.isEmptyResult = false;
    },
    addNewColumn: function(state) {
        state.screenerUtils.isFormActive = false;
        state.screenerUtils.isFormEditMode = false;
        state.screenerUtils.isFormCreateMode = false;
    },
    updateScreenerResult: function(state, action) {
        var _payload = action.payload, screenerAction = _payload.screenerAction, screener = _payload.screener;
        if (screenerAction === "get") {
            state.screenerResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, screener);
        }
        if (screenerAction === "post") {
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, screener);
        }
    },
    resetAddColumnModal: function(state) {
        state.screenerModal.addColumnModal = {
            id: null,
            name: null
        };
    }
};
var extraReducer = function(builder) {
    builder.addCase(screenerEffects.getScreenerFavorites.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerFavorites.isError = true;
        } else {
            state.screenerFavorites.data = data;
            state.screenerFavorites.message = message;
        }
        state.screenerFavorites.isLoading = false;
    }).addCase(screenerEffects.getScreenerFavorites.pending, function(state) {
        state.screenerFavorites.isLoading = true;
    }).addCase(screenerEffects.getScreenerFavorites.rejected, function(state, action) {
        state.screenerFavorites.isError = action.payload.isError;
        state.screenerFavorites.isLoading = false;
    }).addCase(screenerEffects.getScreenerPreset.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerPreset.isError = true;
        } else {
            state.screenerPreset.data = data;
            state.screenerPreset.message = message;
        }
        state.screenerPreset.isLoading = false;
    }).addCase(screenerEffects.getScreenerPreset.pending, function(state) {
        state.screenerPreset.isLoading = true;
    }).addCase(screenerEffects.getScreenerPreset.rejected, function(state, action) {
        state.screenerPreset.isError = action.payload.isError;
        state.screenerPreset.isLoading = false;
    }).addCase(screenerEffects.addFavorite.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        var _screenerFavorites = state.screenerFavorites, baseFavorite = _screenerFavorites.data;
        if (!data) {
            state.addFavoriteScreenerResult.isError = true;
        } else {
            var result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(baseFavorite).concat([
                data
            ]);
            state.screenerFavorites.data = result;
            state.addFavoriteScreenerResult.message = message;
        }
        state.addFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.addFavorite.pending, function(state) {
        state.addFavoriteScreenerResult.isLoading = true;
    }).addCase(screenerEffects.addFavorite.rejected, function(state, action) {
        state.addFavoriteScreenerResult.isError = action.payload.isError;
        state.addFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeFavorite.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, obsoleteData = _payload.data;
        var _screenerFavorites = state.screenerFavorites, baseFavorite = _screenerFavorites.data;
        if (!obsoleteData) {
            state.removeFavoriteScreenerResult.isError = true;
        } else {
            var IDRemove = obsoleteData;
            var result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(baseFavorite).filter(function(favoritesScreener) {
                return favoritesScreener.id !== IDRemove;
            });
            state.screenerFavorites.data = result;
            state.removeFavoriteScreenerResult.message = message;
        }
        state.removeFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeFavorite.pending, function(state) {
        state.removeFavoriteScreenerResult.isLoading = true;
    }).addCase(screenerEffects.removeFavorite.rejected, function(state, action) {
        state.removeFavoriteScreenerResult.isError = action.payload.isError;
        state.removeFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.getScreenerUniverse.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerUniverse.isError = true;
        } else {
            state.screenerUniverse.data = data;
            state.screenerUniverse.message = message;
        }
        state.screenerUniverse.isLoading = false;
    }).addCase(screenerEffects.getScreenerUniverse.pending, function(state) {
        state.screenerUniverse.isLoading = true;
    }).addCase(screenerEffects.getScreenerUniverse.rejected, function(state, action) {
        state.screenerUniverse.isError = action.payload.isError;
        state.screenerUniverse.isLoading = false;
    }).addCase(screenerEffects.getScreenerFinancialMetric.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerFinancialMetric.isError = true;
        } else {
            state.screenerFinancialMetric.data = data;
            state.screenerFinancialMetric.message = message;
        }
        state.screenerFinancialMetric.isLoading = false;
    }).addCase(screenerEffects.getScreenerFinancialMetric.pending, function(state) {
        state.screenerFinancialMetric.isLoading = true;
    }).addCase(screenerEffects.getScreenerFinancialMetric.rejected, function(state, action) {
        state.screenerFinancialMetric.isError = action.payload.isError;
        state.screenerFinancialMetric.isLoading = false;
    }).addCase(screenerEffects.postScreener.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, fromForm = _payload.fromForm;
        var arg = action.meta.arg;
        if (!data) {
            state.screenerPostResult.isError = true;
        } else {
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, data);
            // Sync ScreenerForm state after submitting form
            // use case for `rules`, etc.
            if (fromForm) {
                var screenerid = data.screenerid, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data, [
                    "screenerid"
                ]);
                state.screenerResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, rest), {
                    screenerid: arg.save === "1" ? screenerid : state.screenerResult.data.screenerid
                });
            }
            state.screenerPostResult.message = message;
            state.screenerUtils.isFormCreateMode = false;
        }
        state.screenerPostResult.isLoading = false;
    }).addCase(screenerEffects.postScreener.pending, function(state) {
        state.screenerPostResult.isLoading = true;
        state.screenerUtils.screenerAction = "post";
        state.screenerUtils.isEmptyResult = false;
    }).addCase(screenerEffects.postScreener.rejected, function(state, action) {
        state.screenerPostResult.isError = action.payload.isError;
        state.screenerPostResult.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.getScreener.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerResult.isError = true;
        } else {
            var screenerid = data.screenerid, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data, [
                "screenerid"
            ]);
            state.screenerResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, rest), {
                screenerid: rest.isguru ? 0 : screenerid
            });
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, rest), {
                screenerid: screenerid
            });
            state.screenerResult.message = message;
        }
        state.screenerResult.isLoading = false;
    }).addCase(screenerEffects.getScreener.pending, function(state) {
        state.screenerResult.isLoading = true;
        state.screenerPostResult.data = {};
        state.screenerUtils.screenerAction = "get";
        state.screenerUtils.isEmptyResult = false;
    }).addCase(screenerEffects.getScreener.rejected, function(state, action) {
        state.screenerResult.isError = action.payload.isError;
        state.screenerResult.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.getScreenerCustom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerCustom.isError = true;
        } else {
            state.screenerCustom.data = data;
            state.screenerCustom.message = message;
        }
        state.screenerCustom.isLoading = false;
    }).addCase(screenerEffects.getScreenerCustom.pending, function(state) {
        state.screenerCustom.isLoading = true;
    }).addCase(screenerEffects.getScreenerCustom.rejected, function(state, action) {
        state.screenerCustom.isError = action.payload.isError;
        state.screenerCustom.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.removeScreenerCustom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.removeCustomScreenerResult.isError = true;
        } else {
            state.removeCustomScreenerResult.data = data;
            state.removeCustomScreenerResult.message = message;
        }
        state.removeCustomScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeScreenerCustom.pending, function(state) {
        state.removeCustomScreenerResult.isLoading = true;
    }).addCase(screenerEffects.removeScreenerCustom.rejected, function(state, action) {
        state.removeCustomScreenerResult.isError = action.payload.isError;
        state.removeCustomScreenerResult.isLoading = false;
    });
};
var screenerSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "screener",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ __webpack_exports__["ZP"] = (screenerSlice);


/***/ }),

/***/ 30690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Es": function() { return /* binding */ OA_REGISTER_STATUS; },
/* harmony export */   "Gj": function() { return /* binding */ SUBSCRIPTION_ALIAS; },
/* harmony export */   "f2": function() { return /* binding */ SUBSCRIPTION_PACKAGE; },
/* harmony export */   "z": function() { return /* binding */ PAYMENT_OPTION; }
/* harmony export */ });
/* unused harmony export PAYMENT_METHOD */
var PAYMENT_METHOD;
(function(PAYMENT_METHOD) {
    PAYMENT_METHOD["PAYMENT_METHOD_GOPAY"] = "PAYMENT_METHOD_GOPAY";
    PAYMENT_METHOD["PAYMENT_METHOD_BCA_VA"] = "PAYMENT_METHOD_BCA_VA";
    PAYMENT_METHOD["PAYMENT_METHOD_CREDIT_CARD"] = "PAYMENT_METHOD_CREDIT_CARD";
    PAYMENT_METHOD["PAYMENT_METHOD_BANK_TRANSFER"] = "PAYMENT_METHOD_BANK_TRANSFER";
    PAYMENT_METHOD["PAYMENT_METHOD_CIMB_CLICKS"] = "PAYMENT_METHOD_CIMB_CLICKS";
    PAYMENT_METHOD["PAYMENT_METHOD_BRI_EPAY"] = "PAYMENT_METHOD_BRI_EPAY";
    PAYMENT_METHOD["PAYMENT_METHOD_MIDTRANS"] = "PAYMENT_METHOD_MIDTRANS";
})(PAYMENT_METHOD || (PAYMENT_METHOD = {}));
var PAYMENT_OPTION = [
    {
        id: 0,
        name: "Gopay",
        code: PAYMENT_METHOD.PAYMENT_METHOD_GOPAY,
        description: "gopay",
        icon: "gopay_round"
    },
    {
        id: 1,
        name: "BCA Virtual Account",
        code: PAYMENT_METHOD.PAYMENT_METHOD_BCA_VA,
        description: "bca_va",
        icon: "bca_va"
    },
    {
        id: 2,
        name: "Credit Card / Transfer ATM / Mandiri Clickpay",
        code: PAYMENT_METHOD.PAYMENT_METHOD_MIDTRANS,
        description: "veritrans",
        icon: "veritrans"
    }, 
];
var SUBSCRIPTION_ALIAS = {
    SUBSCRIPTION_ONE_YEAR: "1 Tahun Berlangganan",
    SUBSCRIPTION_SIX_MONTHS: "6 Bulan Berlangganan",
    SUBSCRIPTION_ONE_MONTH: "1 Bulan Berlangganan",
    SUBSCRIPTION_ONE_DAY: "1 Hari Berlangganan"
};
var SUBSCRIPTION_PACKAGE = {
    SUBSCRIPTION_ONE_YEAR: "1 Tahun Stockbit Pro",
    SUBSCRIPTION_SIX_MONTHS: "6 Bulan Stockbit Pro",
    SUBSCRIPTION_ONE_MONTH: "1 Bulan Stockbit Pro",
    SUBSCRIPTION_ONE_DAY: "1 Hari Stockbit Pro"
};
var OA_REGISTER_STATUS;
(function(OA_REGISTER_STATUS) {
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["HAS_NOT_STARTED"] = 0] = "HAS_NOT_STARTED";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["INCOMPLETE"] = 1] = "INCOMPLETE";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["CS_PROGRESS"] = 2] = "CS_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["KSEI_PROGRESS"] = 3] = "KSEI_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["RDN_PROGRESS"] = 4] = "RDN_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["SUBMIT_REGISTRATION"] = 5] = "SUBMIT_REGISTRATION";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["DOCUMENT_VERIFICATION"] = 88] = "DOCUMENT_VERIFICATION";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["REJECTED"] = 99] = "REJECTED";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["OTHERS"] = -1] = "OTHERS";
})(OA_REGISTER_STATUS || (OA_REGISTER_STATUS = {}));


/***/ }),

/***/ 31366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XP": function() { return /* binding */ translatePackageOption; },
/* harmony export */   "fX": function() { return /* binding */ checkIsWaitingAccount; },
/* harmony export */   "gs": function() { return /* binding */ createMonthlyStatements; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30690);



var createMonthlyStatements = function(orders) {
    var dict = {};
    orders.forEach(function(order) {
        var month = moment__WEBPACK_IMPORTED_MODULE_0___default()(order.date).format("MMMM YYYY");
        if (Array.isArray(dict[month])) {
            dict[month].push(order);
        } else {
            dict[month] = [
                order
            ];
        }
    });
    return dict;
};
var translatePackageOption = function() {
    var packageItem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", dateOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(packageItem === null || packageItem === void 0 ? void 0 : packageItem.split(" "), 2), tmp = ref[0], packageDuration = tmp === void 0 ? "" : tmp, tmp1 = ref[1], packageType = tmp1 === void 0 ? "" : tmp1;
    switch(packageType.toLowerCase()){
        case "month":
            {
                if (Number(packageDuration) >= 12) {
                    return "1 Tahun ".concat(dateOnly && "Stockbit Pro");
                }
                return "".concat(packageDuration, " Bulan ").concat(dateOnly ? "Stockbit Pro" : "");
            }
        case "day":
            {
                return "".concat(packageDuration, " Hari ").concat(dateOnly ? "Stockbit Pro" : "");
            }
        default:
            {
                return "".concat(packageDuration, " Tahun ").concat(dateOnly ? "Stockbit Pro" : "");
            }
    }
};
var checkIsWaitingAccount = function(status) {
    var waitingStatuses = [
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.CS_PROGRESS */ .Es.CS_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.KSEI_PROGRESS */ .Es.KSEI_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.RDN_PROGRESS */ .Es.RDN_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.SUBMIT_REGISTRATION */ .Es.SUBMIT_REGISTRATION,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.DOCUMENT_VERIFICATION */ .Es.DOCUMENT_VERIFICATION, 
    ];
    return waitingStatuses.includes(status);
};


/***/ }),

/***/ 83100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38597);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331);








var initialState = {
    tab: "order",
    isFilterActive: false,
    orderSearchValue: {
        action: "",
        stock: "",
        text: ""
    },
    orderSearchOptions: [],
    orderFilterValue: {
        status: [],
        orderType: [],
        expiry: [],
        accountType: []
    },
    orderSearchFilterResult: []
};
var orderTableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, initialState), {
        setOrderTab: function(tab) {
            set({
                tab: tab
            });
        },
        setOrderSearchValue: function(orderSearchValue) {
            if (orderSearchValue === null) {
                set({
                    orderSearchValue: initialState.orderSearchValue
                });
                return;
            }
            set({
                orderSearchValue: orderSearchValue
            });
        },
        setOrderSearchOptions: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(stock) {
                var ref, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(stock === null)) {
                                _ctx.next = 3;
                                break;
                            }
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.prev = 3;
                            ;
                            _ctx.next = 7;
                            return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchEmiten */ .Z.getSearchEmiten(stock);
                        case 7:
                            data = _ctx.sent.data;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company) {
                                set({
                                    orderSearchOptions: data.data.company.map(function(d) {
                                        return {
                                            name: d === null || d === void 0 ? void 0 : d.name,
                                            desc: d === null || d === void 0 ? void 0 : d.desc
                                        };
                                    })
                                });
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(stock) {
                return _ref.apply(this, arguments);
            };
        }(),
        setOrderFilterValue: function(orderFilterValue) {
            if (orderFilterValue === null) {
                set({
                    orderFilterValue: initialState.orderFilterValue
                });
                return;
            }
            set({
                orderFilterValue: orderFilterValue
            });
        },
        searchAndFilter: function(source) {
            if (source === null) {
                set({
                    orderSearchFilterResult: source
                });
                return;
            }
            var ref = get(), orderSearchValue = ref.orderSearchValue, orderFilterValue = ref.orderFilterValue;
            var searchResult = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .search */ .yC)(source, orderSearchValue);
            var searchFilterResult = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)(searchResult, orderFilterValue);
            set({
                orderSearchFilterResult: searchFilterResult,
                isFilterActive: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .checkFilterAvailability */ .XI)(orderFilterValue)
            });
        },
        resetOrderTableStore: function() {
            set(initialState);
        }
    });
}, {
    name: "zustandOrderTableStore",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            isFilterActive: state.isFilterActive,
            orderSearchValue: state.orderSearchValue,
            orderFilterValue: state.orderFilterValue
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (orderTableStore);


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ splitSearch; },
/* harmony export */   "Gd": function() { return /* binding */ checkIsCancelable; },
/* harmony export */   "XI": function() { return /* binding */ checkFilterAvailability; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "v1": function() { return /* binding */ checkIsAmendable; },
/* harmony export */   "yC": function() { return /* binding */ search; }
/* harmony export */ });
/* harmony import */ var global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6421);

var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(v, f) {
            return f(v);
        }, x);
    };
};
var splitSearch = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedStock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var arrSearch = search.split(" ");
    if (arrSearch.length === 1) {
        return {
            action: selectedStock || arrSearch[0],
            stock: selectedStock || arrSearch[0],
            text: selectedStock || arrSearch[0]
        };
    }
    if (arrSearch.length > 1) {
        return {
            action: arrSearch[0],
            stock: selectedStock || arrSearch[1],
            text: [
                arrSearch[0],
                selectedStock || arrSearch[1]
            ].join(" ")
        };
    }
    return {
        action: "",
        stock: "",
        text: ""
    };
};
var search = function(source, searchValue) {
    if (!searchValue) {
        return source;
    }
    var action = searchValue.action, stock = searchValue.stock;
    if (action !== "" && action === stock) {
        return source.filter(function(e) {
            return e.action.startsWith(action.toLocaleUpperCase()) || e.symbol.startsWith(action.toLocaleUpperCase());
        });
    }
    if (action !== "" && stock !== "") {
        return source.filter(function(e) {
            return action.toLocaleUpperCase() === e.action && e.symbol.startsWith(stock.toLocaleUpperCase());
        });
    }
    return source;
};
var filter = function(source, filterValue) {
    if (!filterValue) {
        return source;
    }
    var status = filterValue.status, orderType = filterValue.orderType, expiry = filterValue.expiry, _accountType = filterValue.accountType, accountType = _accountType === void 0 ? [] : _accountType;
    var filterFn = function(valueToCheck) {
        var filterValueItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if ((filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.length) === 0) {
            return true;
        }
        return filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.includes(valueToCheck);
    };
    var filterStatus = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.status) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), status);
        });
    };
    var filterOrderType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.label) === null || ref === void 0 ? void 0 : ref.toUpperCase(), orderType);
        });
    };
    var filterExpiry = function(s) {
        return s.filter(function(i) {
            return filterFn(i.gtc_text, expiry);
        });
    };
    var filterAccountType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.day_trade_is_day_trade) === null || ref === void 0 ? void 0 : ref.toString(), accountType);
        });
    };
    return pipe(filterStatus, filterOrderType, filterExpiry, filterAccountType)(source);
};
var checkFilterAvailability = function(filterValue) {
    var filterArr = Object.keys(filterValue).map(function(k) {
        var ref;
        return (ref = filterValue[k]) === null || ref === void 0 ? void 0 : ref.length;
    });
    return filterArr.some(function(i) {
        return i > 0;
    });
};
var SMART_ORDER_LABELS = new Set([
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.SL */ .D0.SL,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.TP */ .D0.TP,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.TS */ .D0.TS,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.AB */ .D0.AB,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.LIT_SELL */ .D0.LIT_SELL,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.BO */ .D0.BO,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.VTO */ .D0.VTO, 
]);
var isSmartOrder = function(label) {
    return SMART_ORDER_LABELS.has(label);
};
var checkIsCancelable = function(item) {
    return isSmartOrder(item.label) ? item.cancel_target !== "ACTION_TARGET_UNSPECIFIED" : item.cancel_action;
};
var checkIsAmendable = function(item) {
    return isSmartOrder(item.label) ? item.amend_target !== "ACTION_TARGET_UNSPECIFIED" : item.amend_action;
};



/***/ }),

/***/ 67266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6430);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63762);








// utils

// constants
var SLICE_NAME = "collection";
// initial state
var initialState = {
    available: [],
    isDropdownOpen: false,
    isFormOpen: false,
    isCollectionLoading: false,
    error: null,
    needRefresh: false,
    selectedForModify: null,
    modalVisible: "none"
};
var reducers = {
    handleSetDropdown: function(draft, action) {
        draft.isDropdownOpen = action.payload.isOpen;
    },
    handleSetFormOpen: function(draft, action) {
        draft.isFormOpen = action.payload.isOpen;
    },
    handleSelectForModify: function(draft, action) {
        draft.selectedForModify = draft.available[action.payload.selectedIndex];
        draft.modalVisible = action.payload.modalType;
        draft.isDropdownOpen = false;
    }
};
var thunks = {
    createCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/CREATE_NEW_COMPANY_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, desc, response, _data, error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, desc = param.desc;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].createNewWatchlist */ .Z.createNewWatchlist(name, desc);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to add watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: "New watchlist group is added",
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    fetchSavedCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_SAVED_COMPANY_WATCHLIST"), (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAllWatchlist */ .Z.getAllWatchlist();
                case 2:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to get saved watchlist failed!");
                case 5:
                    _data = response.data, data = _data.data, error = _data.error_type;
                    if (!error) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(error);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    editCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/EDIT_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, desc, id, response, _data, error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, desc = param.desc, id = param.id;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].updateWatchlist */ .Z.updateWatchlist(id, name, desc);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to update saved watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: "Your stock watchlist is updated",
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/DELETE_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, response, _data, error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].deleteWatchlistById */ .Z.deleteWatchlistById(id);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete saved watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data, message = _data.message;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: message,
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            id: id
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    // fetchSavedCompanyWatchlist
    builder.addCase(thunks.fetchSavedCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
        draft.needRefresh = false;
    }).addCase(thunks.fetchSavedCompanyWatchlist.fulfilled, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.available = action.payload.data;
    }).addCase(thunks.fetchSavedCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// createCompanyWatchlist
    .addCase(thunks.createCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.createCompanyWatchlist.fulfilled, function(draft, action) {
        var newWatchlist = action.payload.data;
        if (newWatchlist) {
            draft.available.push(newWatchlist);
        }
        draft.isCollectionLoading = false;
        draft.needRefresh = false;
        draft.isFormOpen = false;
    }).addCase(thunks.createCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// editCompanyWatchlist
    .addCase(thunks.editCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.editCompanyWatchlist.fulfilled, function(draft) {
        draft.isCollectionLoading = false;
        draft.selectedForModify = null;
        draft.modalVisible = "none";
        draft.needRefresh = true;
    }).addCase(thunks.editCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// deleteCompanyWatchlist
    .addCase(thunks.deleteCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.deleteCompanyWatchlist.fulfilled, function(draft, action) {
        var id = action.payload.id;
        var newList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(draft.available);
        var idx = newList.findIndex(function(item) {
            return Number(item.watchlist_id) === Number(id);
        });
        if (idx > -1) {
            newList.splice(idx, 1);
            draft.available = newList;
        }
        draft.isCollectionLoading = false;
        draft.selectedForModify = null;
        draft.modalVisible = "none";
    // draft.needRefresh = true;
    }).addCase(thunks.deleteCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, function(state) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.collection), {
        activeWatchlistId: state.root.activeWatchlistId,
        activeWatchlistName: state.root.activeWatchlistName
    });
});
var collectionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (collectionSlice);


/***/ }),

/***/ 66960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6430);
/* harmony import */ var _Table_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85833);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63762);






// other slice


// utils

// constants
var SLICE_NAME = "deleteCompanyModal";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    isModalVisible: false,
    selected: undefined
};
var reducers = {
    handleDeleteCompanyClick: function(draft, action) {
        draft.isModalVisible = true;
        draft.selected = action.payload;
    },
    handleModalCancel: function(draft) {
        draft.isModalVisible = false;
        draft.selected = null;
    }
};
var thunks = {
    handleConfirmRemoveCompany: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/CONFIRM_REMOVE_COMPANY"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var companyid, watchlistid, dispatch, response, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        companyid = param.companyid, watchlistid = param.watchlistid, dispatch = param1.dispatch;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postUnfollowCompany */ .Z.postUnfollowCompany(watchlistid, companyid);
                    case 3:
                        response = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(error);
                    case 7:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                            content: "Stock is removed",
                            messageType: "success",
                            alertType: "plain"
                        });
                        dispatch(_Table_slice__WEBPACK_IMPORTED_MODULE_3__/* .thunks.fetchCompanyWatchlist */ .CJ.fetchCompanyWatchlist({
                            watchlistid: watchlistid
                        }));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// delete
    .addCase(thunks.handleConfirmRemoveCompany.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.handleConfirmRemoveCompany.fulfilled, function(draft) {
        draft.isLoading = false;
        draft.isModalVisible = false;
        draft.selected = null;
    }).addCase(thunks.handleConfirmRemoveCompany.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.isModalVisible = false;
        draft.selected = null;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, function(state) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.watchlistTable.deleteModal), {
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var deleteCompanyModalSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (deleteCompanyModalSlice);


/***/ }),

/***/ 13795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ FinancialMetric_slice; },
  "xv": function() { return /* binding */ listMetricsSelector; },
  "wl": function() { return /* binding */ slice_selectors; },
  "CJ": function() { return /* binding */ thunks; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/metric.ts

var request = (0,requestExodus/* default */.Z)();
var getFinancialMetric = function() {
    return request.get("/watchlist/metric");
};
/* harmony default export */ var metric = ({
    getFinancialMetric: getFinancialMetric
});

// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/features/watchlist/selectors.ts
var selectors = __webpack_require__(63762);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/Table/slice.ts
var slice = __webpack_require__(85833);
;// CONCATENATED MODULE: ./src/features/watchlist/WatchlistTable/FinancialMetric/slice.ts










// utils

// local slices

// destructure
var tableActions = slice/* default.actions */.ZP.actions;
// constants
var SLICE_NAME = "financialMetrics";
var THUNK_CONTEXT = "feature/watchlist/financialMetrics";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    isModalOpen: false,
    list: [],
    menu: [
        [],
        [],
        []
    ],
    selectedColumnId: {
        0: null,
        1: null
    }
};
var reducers = {
    toggleModalVisibility: function(draft, action) {
        var isOpen = action.payload.visibility || !draft.isModalOpen;
        draft.isModalOpen = isOpen;
    },
    handleMenuClick: function(draft, action) {
        var _payload = action.payload, columnIndex = _payload.columnIndex, childs = _payload.childs, id = _payload.id;
        // update the selected column id per column index
        draft.selectedColumnId[columnIndex] = id;
        //  reset the child columns first
        draft.menu[columnIndex + 1] = [];
        if (columnIndex === 0) {
            draft.menu[columnIndex + 2] = [];
        }
        // then re-fill up the child column
        draft.menu[columnIndex + 1] = childs;
    }
};
var thunks = {
    fetchMetrics: (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(THUNK_CONTEXT, "/FETCH_METRICS"), (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, body;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return metric.getFinancialMetric();
                case 2:
                    response = _ctx.sent;
                    body = response.data;
                    if (!body.error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(body.error);
                case 6:
                    return _ctx.abrupt("return", {
                        data: body.data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    addMetrics: (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(THUNK_CONTEXT, "/ADD_METRICS"), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var fitem, watchlistid, name, dispatch, response, _data, data, error, message, result, ref, message1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        fitem = param.fitem, watchlistid = param.watchlistid, name = param.name, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.addFinancialMetrics */.Z.addFinancialMetrics(watchlistid, fitem);
                    case 4:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error, message = _data.message;
                        if (!error) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(error);
                    case 8:
                        (0,AlertMessage/* default */.Z)({
                            content: message,
                            messageType: "success",
                            alertType: "plain"
                        });
                        result = {
                            column: {
                                dataIndex: data.item_id.toString(),
                                title: data.item_name,
                                key: data.item_id.toString()
                            },
                            results: data.results
                        };
                        dispatch(tableActions.addColumn(result));
                        _ctx.next = 18;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message1 = (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message) || "";
                        if (message1.toLowerCase().includes("duplicate")) {
                            (0,AlertErrorMessage/* default */.Z)("Column '".concat(name, "' already exist"), errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        }
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// fetch financial metrics
    .addCase(thunks.fetchMetrics.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.fetchMetrics.fulfilled, function(draft, action) {
        draft.isLoading = false;
        draft.list = action.payload.data;
        draft.menu[0] = action.payload.data;
    }).addCase(thunks.fetchMetrics.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// add financial metrics to watchlist
    .addCase(thunks.addMetrics.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.addMetrics.fulfilled, function(draft) {
        draft.isLoading = false;
        draft.isModalOpen = false;
    }).addCase(thunks.addMetrics.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// selectors
var slice_selectors = (0,es/* createSelector */.P1)(selectors/* default */.ZP, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.watchlistTable.financialMetrics), {
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var listMetricsSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.watchlist.watchlistTable.financialMetrics.list;
}, function(state) {
    return state;
});
var financialMetricSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var FinancialMetric_slice = (financialMetricSlice);


/***/ }),

/***/ 78086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "_7": function() { return /* binding */ suggestionSelector; }
/* harmony export */ });
/* unused harmony export selectors */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68697);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var _Table_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85833);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63762);









// utils

// constants
var SLICE_NAME = "table";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    suggestions: []
};
var reducers = {
    clearSearch: function(state) {
        state.suggestions = [];
        return state;
    }
};
var thunks = {
    fetchCompanySuggestions: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_COMPANY_SUGGESTIONS"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var params, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _param);
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchCompany */ .Z.getSearchCompany(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to fetch suggestion company failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data === null || data === void 0 ? void 0 : data.companies
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    handleSuggestionsSelected: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/ADD_SUGGESTIONS_TO_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var companyid, watchlistid, dispatch, response, _data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        companyid = param.companyid, watchlistid = param.watchlistid, dispatch = param1.dispatch;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postFollowCompany */ .Z.postFollowCompany(watchlistid, companyid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to follow company failed");
                    case 6:
                        _data = response.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        dispatch(_Table_slice__WEBPACK_IMPORTED_MODULE_3__/* .thunks.fetchCompanyWatchlist */ .CJ.fetchCompanyWatchlist({
                            watchlistid: watchlistid
                        }));
                        return _ctx.abrupt("return", {
                            data: response.data.data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// handle save to company
    .addCase(thunks.handleSuggestionsSelected.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.handleSuggestionsSelected.fulfilled, function(draft) {
        draft.isLoading = false;
    }).addCase(thunks.handleSuggestionsSelected.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// Extra reducers for fetch suggestions
    .addCase(thunks.fetchCompanySuggestions.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.fetchCompanySuggestions.fulfilled, function(draft, action) {
        draft.isLoading = false;
        draft.suggestions = action.payload.data;
    }).addCase(thunks.fetchCompanySuggestions.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, function(state) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state.watchlistTable.companySuggestions), {
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var suggestionSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function(state) {
    return state.watchlist.watchlistTable.companySuggestions.suggestions;
}, function(state) {
    return state;
});
var companySuggestionsSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (companySuggestionsSlice);


/***/ }),

/***/ 85833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "GY": function() { return /* binding */ dataSourceSelector; },
/* harmony export */   "_P": function() { return /* binding */ loadingTableSelector; },
/* harmony export */   "wl": function() { return /* binding */ selectors; },
/* harmony export */   "yV": function() { return /* binding */ columnSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68697);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62974);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6430);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63762);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26857);
/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable camelcase */ 









// utils

// Utils

// constants
var SLICE_NAME = "table";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    columns: [],
    fitems: {},
    headers: [],
    symbols: {}
};
var reducers = {
    addColumn: function(draft, action) {
        draft.columns.push(action.payload.column);
    },
    updateColumns: function(draft, action) {
        draft.columns = action.payload.columns;
    }
};
var thunks = {
    fetchCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_COMPANY_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistid, params, response, body, _data, headerCustom, result, customHeader, customColumn, companyDataSource, customHeaderObject, symbols, datasource;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistid = param.watchlistid;
                        params = {
                            setfincol: 1
                        };
                        _ctx.next = 4;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getDetailWatchlist */ .Z.getDetailWatchlist(watchlistid, params);
                    case 4:
                        response = _ctx.sent;
                        body = response.data;
                        if (!body.error) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(body.error);
                    case 8:
                        _data = body.data, headerCustom = _data.header_custom, result = _data.result;
                        customHeader = _utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mapCustomHeader */ .Z.mapCustomHeader(headerCustom);
                        customColumn = customHeader.map(_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mapCustomColumnFromHeader */ .Z.mapCustomColumnFromHeader);
                        companyDataSource = result.map(_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mapCompanyDataSource */ .Z.mapCompanyDataSource);
                        customHeaderObject = customHeader.reduce(_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].customHeaderObjectReducer */ .Z.customHeaderObjectReducer, {});
                        symbols = _utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].generateSymbols */ .Z.generateSymbols(companyDataSource, customHeaderObject);
                        datasource = Object.keys(symbols).map(function(key) {
                            return symbols[key];
                        });
                        return _ctx.abrupt("return", {
                            datasource: datasource,
                            symbols: symbols,
                            customColumn: customColumn
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    fetchFinancialItemValues: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_FINANCIAL_ITEM_VALUES"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistid, fitemids, datasourceResponse, datasources;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistid = param.watchlistid, fitemids = param.fitemids;
                        _ctx.next = 3;
                        return Promise.all(fitemids.map(function(id) {
                            return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getFinancialValues */ .Z.getFinancialValues(watchlistid, id);
                        }));
                    case 3:
                        datasourceResponse = _ctx.sent;
                        datasources = datasourceResponse.map(function(response) {
                            var _data = response.data, data = _data.data, error = _data.error;
                            if (error) {
                                throw new Error(error);
                            }
                            return data;
                        });
                        return _ctx.abrupt("return", {
                            datasources: datasources
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    removeColumn: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/REMOVE_FINANCIAL_COLUMN"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistid, fitemid, response, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistid = param.watchlistid, fitemid = param.fitemid;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeFinancialMetrics */ .Z.removeFinancialMetrics(watchlistid, fitemid);
                    case 3:
                        response = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(error);
                    case 7:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content: constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FINANCIAL_COLUMN_DELETED */ .Z.FINANCIAL_COLUMN_DELETED,
                            alertType: "plain",
                            messageType: "success"
                        });
                        return _ctx.abrupt("return", {
                            fitemid: fitemid
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    reorderColumn: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/REORDER_FINANCIAL_COLUMN"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var column, watchlistid, columnIndex, response, _data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        column = param.column, watchlistid = param.watchlistid;
                        columnIndex = column.map(function(col) {
                            return col.dataIndex;
                        }).join();
                        _ctx.next = 4;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].reorderFinancialValues */ .Z.reorderFinancialValues(watchlistid, columnIndex);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to reorder financial column failed");
                    case 7:
                        _data = response.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(error);
                    case 10:
                        return _ctx.abrupt("return", {
                            column: column
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// fetch company watchlist
    .addCase(thunks.fetchCompanyWatchlist.pending, function(draft) {
        draft.isLoading = true;
    // Reset symbols state
    // draft.symbols = {};
    }).addCase(thunks.fetchCompanyWatchlist.fulfilled, function(draft, action) {
        var _payload = action.payload, customColumn = _payload.customColumn, symbols = _payload.symbols;
        draft.isLoading = false;
        draft.symbols = symbols;
        draft.columns = customColumn;
    }).addCase(thunks.fetchCompanyWatchlist.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// fetch company watchlist
    .addCase(thunks.fetchFinancialItemValues.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.fetchFinancialItemValues.fulfilled, function(draft, action) {
        var datasources = action.payload.datasources;
        datasources.forEach(function(param) {
            var item_id = param.item_id, results = param.results;
            results.forEach(function(result) {
                var symbol = result.symbol, value = result.value;
                draft.symbols[symbol] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, draft.symbols[symbol]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item_id, utils_number__WEBPACK_IMPORTED_MODULE_3__/* ["default"].numberFormatter */ .ZP.numberFormatter({
                    num: value,
                    fixed: 2
                })));
            });
        });
        draft.isLoading = false;
    }).addCase(thunks.fetchFinancialItemValues.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    }).addCase(thunks.removeColumn.fulfilled, function(draft, action) {
        draft.columns = draft.columns.filter(function(param) {
            var key = param.key;
            return key !== action.payload.fitemid;
        });
    }).addCase(thunks.reorderColumn.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.reorderColumn.fulfilled, function(draft, action) {
        var column = action.payload.column;
        draft.columns = column;
    }).addCase(thunks.reorderColumn.rejected, function(draft, action) {
        // do something if error
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, function(state) {
    var table = state.watchlistTable.table;
    var datasource = Object.keys(table.symbols).map(function(key) {
        return table.symbols[key];
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, table), {
        datasource: datasource,
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var loadingTableSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(function(state) {
    return state.watchlist.watchlistTable.table.isLoading;
}, function(state) {
    return state;
});
var columnSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(function(state) {
    return state.watchlist.watchlistTable.table.columns;
}, function(state) {
    return state;
});
var dataSourceSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_12__/* .tableSelector */ .ki, function(state) {
    var datasource = Object.keys(state.symbols).map(function(key) {
        return state.symbols[key];
    });
    return datasource;
});
var tableSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (tableSlice);


/***/ }),

/***/ 26857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable eqeqeq */ /* eslint-disable no-param-reassign */ 



function getChangeDirection(change) {
    if (change > 0) {
        return "up";
    }
    if (change < 0) {
        return "down";
    }
    return "neutral";
}
function mapCustomHeader(customHeaders) {
    return customHeaders.map(function(header) {
        return {
            key: header.item_id,
            name: header.value,
            isLoading: false,
            value: {
                itemid: parseInt(header.item_id, 10),
                itemname: header.value,
                results: null
            }
        };
    });
}
var mapCustomColumnFromHeader = function(header) {
    return {
        dataIndex: header.key,
        key: header.key,
        title: header.name,
        className: "table-dragable-column"
    };
};
var mapCompanyDataSource = function(item) {
    return {
        key: item.id,
        price: {
            id: item.id,
            change: numeral__WEBPACK_IMPORTED_MODULE_0___default()(Number(item.change)).format("0,0.00"),
            changeDirection: getChangeDirection(item.change),
            percentage: numeral__WEBPACK_IMPORTED_MODULE_0___default()(Number(item.percent)).format("0,0.00"),
            price: numeral__WEBPACK_IMPORTED_MODULE_0___default()(Number(item.last)).format("0,0[.]00"),
            last: item.last,
            formatted_price: item.formatted_price
        },
        symbol: {
            id: item.id,
            name: item.name,
            symbol: item.symbol,
            uma: item.uma,
            notation: item.notation,
            corp_action: item.corp_action,
            tradeable: item.tradeable,
            status: item.status,
            type: item.type
        },
        notation: item.notation,
        uma: item.uma
    };
};
var customHeaderObjectReducer = function(prev, current) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current.key, null));
};
function generateSymbols(companyDataSources, customHeaderObject) {
    var symbols = companyDataSources.reduce(function(prev, current) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current.symbol.symbol, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, current, customHeaderObject)));
    }, {});
    return symbols;
}
function tableSorter(ax, bx) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "numeric";
    if (type == "string") {
        if (ax < bx) return -1;
        if (ax > bx) return 1;
        return 0;
    }
    ax = String(ax);
    bx = String(bx);
    if (ax == "-" || ax == "n/a") return -1;
    if (bx == "-" || bx == "n/a") return 1;
    ax = ax.replace(/,/g, "");
    bx = bx.replace(/,/g, "");
    ax = ax.replace("%", "");
    bx = bx.replace("%", "");
    ax = ax.replace("+", "");
    bx = bx.replace("+", "");
    if (ax.indexOf("(") > -1) {
        ax = ax.replace("(", "-");
        ax = ax.replace(")", "");
    }
    if (bx.indexOf("(") > -1) {
        bx = bx.replace("(", "-");
        bx = bx.replace(")", "");
    }
    if (ax.indexOf("b") > -1 || ax.indexOf("B") > -1) {
        ax = parseFloat(ax) * 1000000000;
    } else if (ax.indexOf("m") > -1 || ax.indexOf("M") > -1) {
        ax = parseFloat(ax) * 1000000;
    } else if (ax.indexOf("k") > -1 || ax.indexOf("K") > -1) {
        ax = parseFloat(ax) * 1000;
    } else {
        ax = parseFloat(ax);
    }
    if (bx.indexOf("b") > -1 || bx.indexOf("B") > -1) {
        bx = parseFloat(bx) * 1000000000;
    } else if (bx.indexOf("m") > -1 || bx.indexOf("M") > -1) {
        bx = parseFloat(bx) * 1000000;
    } else if (bx.indexOf("k") > -1 || bx.indexOf("K") > -1) {
        bx = parseFloat(bx) * 1000;
    } else {
        bx = parseFloat(bx);
    }
    if (ax < bx) return -1;
    if (ax > bx) return 1;
    return 0;
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    getChangeDirection: getChangeDirection,
    mapCustomHeader: mapCustomHeader,
    mapCustomColumnFromHeader: mapCustomColumnFromHeader,
    mapCompanyDataSource: mapCompanyDataSource,
    customHeaderObjectReducer: customHeaderObjectReducer,
    generateSymbols: generateSymbols,
    tableSorter: tableSorter
});


/***/ }),

/***/ 63762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ activeWlSelector; },
/* harmony export */   "PY": function() { return /* binding */ activeWlNameSelector; },
/* harmony export */   "ki": function() { return /* binding */ tableSelector; }
/* harmony export */ });
/* unused harmony export collectionSelector */
var rootSelector = function(state) {
    return state.watchlist;
};
var collectionSelector = function(state) {
    return state.watchlist.collection;
};
var tableSelector = function(state) {
    return state.watchlist.watchlistTable.table;
};
var activeWlSelector = function(state) {
    return state.watchlist.root.activeWatchlistId;
};
var activeWlNameSelector = function(state) {
    return state.watchlist.root.activeWatchlistName;
};
/* harmony default export */ __webpack_exports__["ZP"] = (rootSelector);


/***/ }),

/***/ 25612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fO": function() { return /* binding */ activeWatchlistIdSelector; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export activeWatchlistNameSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64435);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63762);
/* harmony import */ var _Collection_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67266);






// constants
var SLICE_NAME = "root";
// initial state
var initialState = {
    activeWatchlistId: null,
    activeWatchlistName: "All Watchlist",
    connectionStatus: "Normal"
};
var reducers = {
    handleChangeActiveWatchlist: function(draft, action) {
        draft.activeWatchlistId = action.payload.selected;
        draft.activeWatchlistName = action.payload.name;
    }
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, function(state) {
    var ref, ref1;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.root), {
        isExpand: ((ref = state.watchlistTable.table.columns) === null || ref === void 0 ? void 0 : ref.length) > 5,
        isComposed: ((ref1 = state.watchlistTable.table.columns) === null || ref1 === void 0 ? void 0 : ref1.length) < 2
    });
});
var activeWatchlistIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* .activeWlSelector */ .AW, function(state) {
    return state;
});
var activeWatchlistNameSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* .activeWlNameSelector */ .PY, function(state) {
    return state;
});
var extraReducers = function(builder) {
    builder.addCase(_Collection_slice__WEBPACK_IMPORTED_MODULE_1__/* .thunks.editCompanyWatchlist.fulfilled */ .CJ.editCompanyWatchlist.fulfilled, function(state, action) {
        var data = action.payload.data;
        if (data) {
            var id = data.watchlist_id, name = data.name;
            if (state.activeWatchlistId === id) {
                state.activeWatchlistName = name;
            }
        }
    }).addCase(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_0__/* .effects.logout.fulfilled */ .Sz.logout.fulfilled, function(state) {
        // reset active watchlist
        state.activeWatchlistId = null;
        state.activeWatchlistName = "All Watchlist";
    });
};
var rootSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (rootSlice);


/***/ }),

/***/ 80341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .sysmsg-alert {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0;\n\n    .anticon {\n      display: none;\n    }\n\n    & > div {\n      background: transparent;\n      padding: 0;\n    }\n\n    & > div > div > span > {\n      .message-success {\n        background: #e1f6e5;\n        color: ",
        ";\n      }\n\n      .message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .message-warning {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .message-info {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-default {\n        border-radius: 5px;\n        padding: 10px 15px;\n      }\n\n      .alert-snackbar {\n        font-family: var(--font-bold);\n        text-align: left;\n        line-height: 1.15;\n        font-size: 12px;\n        border-radius: 4px;\n        padding: 15px 20px;\n        max-width: 317px;\n\n        span {\n          margin: 0 12px;\n        }\n      }\n\n      .alert-plain,\n      .alert-plain-default {\n        font-family: var(--font-regular);\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 8px 10px;\n        line-height: 16.1px;\n        max-width: 300px;\n      }\n\n      .alert-plain.message-success {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-success {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-snackbar-dark {\n        font-family: var(--font-bold);\n        text-align: left;\n        line-height: 1.15;\n        font-size: 12px;\n        border-radius: 2px;\n        padding: 15px 20px;\n        max-width: 317px;\n        min-width: 335px;\n        position: relative;\n        border-radius: 4px;\n\n        span {\n          margin: 0 12px 0 8px;\n        }\n\n        background: #3b3b3b;\n        color: ",
        ";\n\n        .notif-close-icon {\n          position: absolute;\n          right: 20px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var alertStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].alertRed */ .Z.alertRed, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].alertOrange */ .Z.alertOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].alertBlue */ .Z.alertBlue, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].valencia */ .Z.valencia, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].valencia */ .Z.valencia, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = (alertStyles);


/***/ }),

/***/ 59016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/search/index.js

var schema = {
    company: [],
    sector: [],
    insider: [],
    chat: [],
    user_more: 0,
    company_more: 0,
    people: []
};
var propTypesPeople = (0,prop_types.shape)({
    id: prop_types.number,
    img: prop_types.string,
    followed: prop_types.number,
    official: prop_types.number,
    name: prop_types.string,
    desc: prop_types.string,
    url: prop_types.string,
    type: prop_types.string,
    other: prop_types.string,
    total_followers: prop_types.number
});
var propTypes = {
    company: (0,prop_types.arrayOf)(prop_types.object),
    sector: (0,prop_types.arrayOf)(prop_types.object),
    insider: (0,prop_types.arrayOf)(prop_types.object),
    chat: (0,prop_types.arrayOf)(prop_types.object),
    user_more: prop_types.number,
    company_more: prop_types.number,
    people: (0,prop_types.arrayOf)(propTypesPeople)
};
/* harmony default export */ var models_search = ({
    schema: schema,
    propTypes: propTypes,
    propTypesPeople: propTypesPeople
});

;// CONCATENATED MODULE: ./src/global/Header/Search/slice.ts







// Action type
var CONTEXT = "@global/search";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT"),
    POST_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/POST_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: schema,
    recent: {
        list: []
    }
};
// Selectors
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.search;
}, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result,
        recent: state.recent
    };
});
// Effects
var effects = {
    getSearchResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return search/* default.getSearch */.Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    getSearchRecentResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SEARCH_RECENT_RESULT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return search/* default.getSearchRecent */.Z.getSearchRecent();
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }))),
    postSearchRecentResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_SEARCH_RECENT_RESULT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var keyword, target, type, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = param.keyword, target = param.target, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.postSearchRecent */.Z.postSearchRecent(keyword, target, type);
                    case 4:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            result: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.data
        });
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            error: action.payload
        });
    }).addCase(effects.getSearchRecentResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.getSearchRecentResult.fulfilled, function(state, action) {
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            recent: {
                list: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.data
            }
        });
    }).addCase(effects.getSearchRecentResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            error: action.payload
        });
    }).addCase(effects.postSearchRecentResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.postSearchRecentResult.fulfilled, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false
        });
    }).addCase(effects.postSearchRecentResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            error: action.payload
        });
    });
};
// Slice
var searchSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "search",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ var slice = (searchSlice);


/***/ }),

/***/ 61884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainApp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 3 modules
var queryClient = __webpack_require__(51767);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/global/Scripts/google.js
/* eslint-disable react/no-danger */ 




var Google = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: app/* STAGE */.or !== "development",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
            children: app/* GTM_ID */.Ax ? // eslint-disable-next-line @next/next/next-script-for-ga
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-tag-manager",
                strategy: "afterInteractive",
                children: "\n                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&ra='+Date.now();f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer', '".concat(app/* GTM_ID */.Ax, "');\n              ")
            }) : null
        })
    });
};
/* harmony default export */ var google = (Google);

// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/lib/api/friends.ts
var friends = __webpack_require__(63699);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/features/discover-people/constants.ts
var constants = __webpack_require__(34566);
// EXTERNAL MODULE: ./src/features/discover-people/helper.ts
var helper = __webpack_require__(58603);
;// CONCATENATED MODULE: ./src/features/discover-people/slice.ts






// alert
// import handleErrorMessageAPI from 'global/AlertErrorMessage';
// import SUCCESS_MESSAGE from 'constants/successMessage';
// API Endpoints Related Modules



// feature constants


// initial state
var initialState = {
    error: null,
    isLoading: true,
    isLastPage: false,
    keyword: "",
    list: [],
    filter: constants/* DISCOVER_FILTERS.0.value */.DY[0].value,
    page: 1
};
var discoverPeopleSelector = function(state) {
    return state.discoverPeople;
};
// Selectors
var selectors = (0,reselect_es/* createSelector */.P1)(discoverPeopleSelector, function(discoverPeople) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discoverPeople), {
        // select methods
        getAllIds: function() {
            return discoverPeople.list.map(function(user) {
                return user.id;
            });
        },
        getUserByIndex: function(index) {
            return discoverPeople.list[index] || [];
        }
    });
});
// Reducer
var reducers = {
    changeType: function(state, action) {
        state.filter = action.payload;
    },
    resetData: function(state) {
        state.keyword = "";
        state.list = [];
        state.filter = state.filter ? state.filter : constants/* DISCOVER_FILTERS.0.value */.DY[0].value;
    }
};
// effects
var effects = {
    // Search users
    searchUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.SEARCH_USER */.At.SEARCH_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var keyword, _page, page, response, _data, data, message, composedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = param.keyword, _page = param.page, page = _page === void 0 ? 1 : _page;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.getSearchPeople */.Z.getSearchPeople(keyword, page);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Cannot perform request");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        composedData = (0,helper/* normalizeData */.Fi)(data, helper/* actionType.SEARCH_USER */.At.SEARCH_USER);
                        return _ctx.abrupt("return", {
                            data: composedData,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // toggle follower
    toggleFollowUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.TOGGLE_FOLLOW_USER */.At.TOGGLE_FOLLOW_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var userid, _isFollowed, isFollowed, index, targetAPI, response, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        userid = param.userid, _isFollowed = param.isFollowed, isFollowed = _isFollowed === void 0 ? false : _isFollowed, index = param.index;
                        _ctx.prev = 1;
                        if (!(typeof index !== "number")) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("index must be a number");
                    case 4:
                        if (userid) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("userid is required");
                    case 6:
                        targetAPI = watchlist/* default.postFollowUser */.Z.postFollowUser;
                        if (isFollowed) {
                            targetAPI = watchlist/* default.postUnfollowUser */.Z.postUnfollowUser;
                        }
                        _ctx.next = 10;
                        return targetAPI(userid);
                    case 10:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error("Cannot perform request");
                    case 13:
                        message = response.data.message;
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Friends suggestions
    getFriendSuggestions: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.FETCH_SUGGESTIONS */.At.FETCH_SUGGESTIONS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _page, page, _limit, limit, config, response, _data, data, _$error, message, normalized, more;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _page = param.page, page = _page === void 0 ? 1 : _page, _limit = param.limit, limit = _limit === void 0 ? constants/* SUGGESTIONS_PERPAGE */.FT : _limit;
                        _ctx.prev = 1;
                        config = {
                            limit: limit,
                            page: page
                        };
                        _ctx.next = 5;
                        return friends/* default.getSuggestFriends */.Z.getSuggestFriends(config);
                    case 5:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!(!response.data || _$error)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("failed to fetch friends suggestions");
                    case 9:
                        normalized = (0,helper/* normalizeData */.Fi)(data, helper/* actionType.FETCH_SUGGESTIONS */.At.FETCH_SUGGESTIONS);
                        more = normalized.length >= 30;
                        return _ctx.abrupt("return", {
                            data: normalized,
                            message: message,
                            more: more
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Contact
    getFriendSuggestionsContact: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.FETCH_CONTACT */.At.FETCH_CONTACT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _page, page, _limit, limit, response, _data, found, _$error, message, normalized, more;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _page = param.page, page = _page === void 0 ? 1 : _page, _limit = param.limit, limit = _limit === void 0 ? constants/* SUGGESTIONS_PERPAGE */.FT : _limit;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return friends/* default.getSuggestFriendsContacts */.Z.getSuggestFriendsContacts(limit, page);
                    case 4:
                        response = _ctx.sent;
                        _data = response.data, found = _data.data.found, _$error = _data.error, message = _data.message;
                        if (!(!response.data || _$error)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("failed to fetch friends suggestions");
                    case 8:
                        normalized = (0,helper/* normalizeData */.Fi)(found, helper/* actionType.FETCH_CONTACT */.At.FETCH_CONTACT);
                        more = normalized.length >= 30;
                        return _ctx.abrupt("return", {
                            data: normalized,
                            message: message,
                            more: more
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra Reducer
var extraReducers = function(builder) {
    // Search by keyword
    builder.addCase(effects.searchUser.pending, function(state, action) {
        state.isLoading = true;
        state.keyword = action.meta.arg.keyword;
    }).addCase(effects.searchUser.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (error) {
            state.error = error;
        } else {
            state.list = data;
        }
        state.isLoading = false;
    }).addCase(effects.searchUser.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    })// Discover Friends Suggestions
    .addCase(effects.toggleFollowUser.pending, function(state, action) {
        var index = action.meta.arg.index;
        state.list[index].isLoading = true;
    }).addCase(effects.toggleFollowUser.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.error = error;
        } else {
            var _arg = action.meta.arg, index = _arg.index, isFollowed = _arg.isFollowed;
            state.list[index].isFollowed = !isFollowed;
            state.list[index].isLoading = false;
        }
        state.isLoading = false;
    }).addCase(effects.toggleFollowUser.rejected, function(state, action) {
        var index = action.meta.arg.index;
        state.list[index].isLoading = false;
        state.error = action.error;
    })// Discover Friends Suggestions
    .addCase(effects.getFriendSuggestions.pending, function(state, action) {
        state.isLoading = true;
        state.page = action.meta.arg.page;
        // reset
        if (action.meta.arg.page === 1) {
            state.list = initialState.list;
            state.isLastPage = false;
        }
    }).addCase(effects.getFriendSuggestions.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.error = error;
        } else if (action.payload.data.length > 0) {
            var _list;
            (_list = state.list).push.apply(_list, (0,_to_consumable_array/* default */.Z)(action.payload.data));
        } else {
            state.isLastPage = true;
        }
        state.isLoading = false;
    }).addCase(effects.getFriendSuggestions.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    })// Discover contact Suggestions
    .addCase(effects.getFriendSuggestionsContact.pending, function(state, action) {
        state.isLoading = true;
        state.page = action.meta.arg.page;
        // reset
        if (action.meta.arg.page === 1) {
            state.list = initialState.list;
            state.isLastPage = false;
        }
    }).addCase(effects.getFriendSuggestionsContact.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.error = error;
        } else if (action.payload.data.length > 0) {
            var _list;
            (_list = state.list).push.apply(_list, (0,_to_consumable_array/* default */.Z)(action.payload.data));
        } else {
            state.isLastPage = true;
        }
        state.isLoading = false;
    }).addCase(effects.getFriendSuggestionsContact.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    });
};
// Slice
var discoverPeopleSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "discoverPeople",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var slice = (discoverPeopleSlice);

;// CONCATENATED MODULE: ./src/features/discover-people/reducer.ts

var discoverPeopleReducer = slice.reducer;
/* harmony default export */ var reducer = (discoverPeopleReducer);

// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var edit_profile_slice = __webpack_require__(40927);
;// CONCATENATED MODULE: ./src/features/edit-profile/reducer.ts

var editProfileReducer = edit_profile_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var edit_profile_reducer = (editProfileReducer);

// EXTERNAL MODULE: ./src/features/onboarding/DiscoverPeople/slice.ts
var DiscoverPeople_slice = __webpack_require__(36203);
// EXTERNAL MODULE: ./src/features/onboarding/DiscoverStock/slice.js
var DiscoverStock_slice = __webpack_require__(9073);
// EXTERNAL MODULE: ./src/features/onboarding/UploadProfilePicture/slice.ts
var UploadProfilePicture_slice = __webpack_require__(12229);
;// CONCATENATED MODULE: ./src/features/onboarding/reducer.js




var onboardingReducer = (0,redux/* combineReducers */.UY)({
    discoverStock: DiscoverStock_slice/* default.reducer */.ZP.reducer,
    uploadImageAvatar: UploadProfilePicture_slice/* default.reducer */.ZP.reducer,
    discoverPeople: DiscoverPeople_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var onboarding_reducer = (onboardingReducer);

// EXTERNAL MODULE: ./src/features/register/GoogleOauth/slice.ts
var GoogleOauth_slice = __webpack_require__(84405);
// EXTERNAL MODULE: ./src/features/register/EmailRegister/slice.ts
var EmailRegister_slice = __webpack_require__(94970);
// EXTERNAL MODULE: ./src/features/register/FacebookOauth/slice.ts
var FacebookOauth_slice = __webpack_require__(2915);
// EXTERNAL MODULE: ./src/features/register/slice.ts + 1 modules
var register_slice = __webpack_require__(9260);
;// CONCATENATED MODULE: ./src/features/register/reducer.ts





// Create the register reducer
var registerReducer = (0,redux/* combineReducers */.UY)({
    emailRegister: EmailRegister_slice/* default.reducer */.ZP.reducer,
    googleOauth: GoogleOauth_slice/* default.reducer */.ZP.reducer,
    facebookOauth: FacebookOauth_slice/* default.reducer */.ZP.reducer,
    root: register_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var register_reducer = (registerReducer);

// EXTERNAL MODULE: ./src/features/reset-password/slice.js
var reset_password_slice = __webpack_require__(7021);
;// CONCATENATED MODULE: ./src/features/reset-password/reducer.js

var resetPasswordReducer = reset_password_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var reset_password_reducer = (resetPasswordReducer);

// EXTERNAL MODULE: ./src/features/user/slice.ts
var user_slice = __webpack_require__(52827);
;// CONCATENATED MODULE: ./src/features/user/reducer.ts

var userProfileReducer = user_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var user_reducer = (userProfileReducer);

// EXTERNAL MODULE: ./src/features/watchlist/Collection/slice.ts
var Collection_slice = __webpack_require__(67266);
// EXTERNAL MODULE: ./src/features/watchlist/slice.ts
var watchlist_slice = __webpack_require__(25612);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/SearchSymbol/slice.ts
var SearchSymbol_slice = __webpack_require__(78086);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/DeleteCompanyModal/slice.ts
var DeleteCompanyModal_slice = __webpack_require__(66960);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/FinancialMetric/slice.ts + 1 modules
var FinancialMetric_slice = __webpack_require__(13795);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/Table/slice.ts
var Table_slice = __webpack_require__(85833);
;// CONCATENATED MODULE: ./src/features/watchlist/WatchlistTable/reducer.ts

// slices




var watchlistTableReducer = (0,redux/* combineReducers */.UY)({
    companySuggestions: SearchSymbol_slice/* default.reducer */.ZP.reducer,
    deleteModal: DeleteCompanyModal_slice/* default.reducer */.ZP.reducer,
    financialMetrics: FinancialMetric_slice/* default.reducer */.ZP.reducer,
    table: Table_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var WatchlistTable_reducer = (watchlistTableReducer);

;// CONCATENATED MODULE: ./src/features/watchlist/reducer.ts

// slices



var watchlistFeatureReducer = (0,redux/* combineReducers */.UY)({
    root: watchlist_slice/* default.reducer */.ZP.reducer,
    collection: Collection_slice/* default.reducer */.ZP.reducer,
    // combined
    watchlistTable: WatchlistTable_reducer
});
/* harmony default export */ var watchlist_reducer = (watchlistFeatureReducer);

// EXTERNAL MODULE: ./src/features/calendar/slice.ts + 1 modules
var calendar_slice = __webpack_require__(39246);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/lib/api/stream.ts
var stream = __webpack_require__(51679);
// EXTERNAL MODULE: ./src/lib/api/securities.ts
var securities = __webpack_require__(65906);
;// CONCATENATED MODULE: ./src/features/stream/slice.js
/* eslint-disable consistent-return */ 




// api


// initial state
var slice_initialState = {
    stream: {
        list: [],
        isLoading: false,
        error: null,
        message: ""
    },
    trendingUser: {
        list: [],
        isLoading: false,
        error: null,
        message: ""
    },
    registrationStatus: {
        data: {
            status: 0
        },
        list: [],
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.stream;
}, function(state) {
    return {
        stream: {
            list: state.stream.list,
            isLoading: state.stream.isLoading,
            error: state.stream.error,
            message: state.stream.message
        },
        trendingUser: {
            list: state.trendingUser.list,
            isLoading: state.trendingUser.isLoading,
            error: state.trendingUser.error,
            message: state.trendingUser.message
        },
        registrationStatus: {
            data: state.registrationStatus.data,
            isLoading: state.registrationStatus.isLoading,
            error: state.registrationStatus.error,
            message: state.registrationStatus.message
        }
    };
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@features/stream";
var actionType = {
    GET_STREAM: "".concat(CONTEXT, "/stream/get"),
    GET_REGISTRATION_STATUS: "".concat(CONTEXT, "/registration_status/get")
};
// effects
var slice_effects = {
    getStream: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_STREAM, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return stream/* default.getStream */.Z.getStream(2, {
                        category: "all",
                        clean: 1
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch stream failed");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // Left as it was because it should be checked after OA is fully integrated with stream page
    // But the widget itself has migrated to zustand
    getRegistrationStatus: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_REGISTRATION_STATUS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return securities/* default.getOAStatus */.Z.getOAStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch oa status failed");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
var _obj;
// Extra Reducer ---------------------------------------------------------------
var slice_extraReducers = (_obj = {}, (0,_define_property/* default */.Z)(_obj, es6/* HYDRATE */.ju, function(draft, action) {
    draft.ihsg = action.payload.ihsg;
    draft.trendingStocks = action.payload.trendingStocks;
    draft.stream = action.payload.stream;
    draft.trendingUser = action.payload.trendingUser;
}), // Get Stream ----------------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, slice_effects.getStream.pending, function(state) {
    state.stream.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getStream.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.stream.error = error;
    } else {
        state.stream.list = data;
    }
    state.stream.message = message;
    state.stream.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getStream.rejected, function(state, action) {
    state.stream.error = action.payload.error;
    state.stream.isLoading = false;
}), // Get get trending user -----------------------------------------------------
(0,_define_property/* default */.Z)(_obj, slice_effects.getRegistrationStatus.pending, function(state) {
    state.registrationStatus.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getRegistrationStatus.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.registrationStatus.error = error;
    } else {
        state.registrationStatus.data = data;
    }
    state.registrationStatus.message = message;
    state.registrationStatus.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getRegistrationStatus.rejected, function(state, action) {
    state.registrationStatus.error = action.payload.error;
    state.registrationStatus.isLoading = false;
}), _obj);
// Slice -----------------------------------------------------------------------
var streamSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "stream",
    initialState: slice_initialState,
    extraReducers: slice_extraReducers
});
/* harmony default export */ var stream_slice = (streamSlice);

// EXTERNAL MODULE: ./src/features/company/slice.ts
var company_slice = __webpack_require__(90636);
;// CONCATENATED MODULE: ./src/features/company/reducer.ts

var companyProfileReducer = company_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var company_reducer = (companyProfileReducer);

// EXTERNAL MODULE: ./src/features/catalog/slice.ts
var catalog_slice = __webpack_require__(62893);
;// CONCATENATED MODULE: ./src/features/catalog/reducer.ts

var catalogReducer = catalog_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var catalog_reducer = (catalogReducer);

// EXTERNAL MODULE: ./src/features/post-detail/slice.ts
var post_detail_slice = __webpack_require__(28563);
;// CONCATENATED MODULE: ./src/features/post-detail/reducer.ts

var postDetailReducer = post_detail_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var post_detail_reducer = (postDetailReducer);

// EXTERNAL MODULE: ./src/lib/api/chartbit.ts
var chartbit = __webpack_require__(47514);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/features/chartbit/slice.ts





// APIs


// Initial state
var chartbit_slice_initialState = {
    templates: [],
    loadedTemplate: {},
    initialData: {},
    isLoading: false,
    error: null,
    message: ""
};
// selectors
var chartbitSelector = function(state) {
    return state.chartbit;
};
var chartbit_slice_selectors = (0,reselect_es/* createSelector */.P1)(chartbitSelector, function(chartbit) {
    return (0,_object_spread/* default */.Z)({}, chartbit);
});
// Action types
var slice_CONTEXT = "@feature/chartbit";
var slice_actionType = {
    GET_TEMPLATES: "".concat(slice_CONTEXT, "/GET_TEMPLATE"),
    SAVE_TEMPLATE: "".concat(slice_CONTEXT, "/SAVE_TEMPLATE"),
    DELETE_TEMPLATE: "".concat(slice_CONTEXT, "/DELETE_TEMPLATE"),
    LOAD_TEMPLATE: "".concat(slice_CONTEXT, "/LOAD_TEMPLATE"),
    GET_INITIAL_DATA: "".concat(slice_CONTEXT, "/GET_INITIAL_DATA")
};
// Side effects
var chartbit_slice_effects = {
    getTemplates: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.GET_TEMPLATES, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return chartbit/* default.getChartTemplate */.Z.getChartTemplate();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get chart template failed");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    (0,logger/* default */.ZP)(_ctx.t0, {
                        event: slice_actionType.GET_TEMPLATES,
                        place: "chartbit/slice"
                    });
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    saveTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.SAVE_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var name, content, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, content = param.content;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return chartbit/* default.saveChartTemplate */.Z.saveChartTemplate(name, content);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to save chart template failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: slice_actionType.SAVE_TEMPLATE,
                            place: "chartbit/slice"
                        });
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.DELETE_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(templateId) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return chartbit/* default.deleteChartTemplate */.Z.deleteChartTemplate(templateId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete chart template failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            templateId: templateId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: slice_actionType.DELETE_TEMPLATE,
                            place: "chartbit/slice"
                        });
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(templateId) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.LOAD_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, templateId, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, templateId = param.templateId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return chartbit/* default.loadChartTemplate */.Z.loadChartTemplate(templateId, symbol);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to load template failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            templateId: templateId
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: slice_actionType.LOAD_TEMPLATE,
                            place: "chartbit/slice"
                        });
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var slice_reducers = {};
var chartbit_slice_extraReducers = function(builder) {
    builder.addCase(chartbit_slice_effects.getTemplates.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(chartbit_slice_effects.getTemplates.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.templates = data;
            state.error = null;
        }
        state.isLoading = false;
        state.message = message;
    })// Save templates doesn't affects reducer, thus we don't need to add the case here
    .addCase(chartbit_slice_effects.deleteTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, templateId = _payload.templateId;
        if (error) {
            state.error = error;
        } else {
            var newTemplates = (0,_to_consumable_array/* default */.Z)(state.templates);
            var templateIdx = newTemplates.findIndex(function(param) {
                var id = param.id;
                return id === templateId;
            });
            if (templateIdx > -1) {
                newTemplates.splice(templateIdx, 1);
                state.templates = newTemplates;
            }
        }
        state.message = message;
    }).addCase(chartbit_slice_effects.loadTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, templateId = _payload.templateId, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            state.loadedTemplate[templateId] = data;
        }
        state.message = message;
    });
};
var chartbitSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "chartbit",
    initialState: chartbit_slice_initialState,
    reducers: slice_reducers,
    extraReducers: chartbit_slice_extraReducers
});
/* harmony default export */ var chartbit_slice = (chartbitSlice);

;// CONCATENATED MODULE: ./src/features/chartbit/reducer.ts

var chartbitReducer = chartbit_slice.reducer;
/* harmony default export */ var chartbit_reducer = (chartbitReducer);

// EXTERNAL MODULE: ./src/features/screener/slice.ts
var screener_slice = __webpack_require__(15183);
// EXTERNAL MODULE: ./src/features/research/slice.ts
var research_slice = __webpack_require__(39910);
// EXTERNAL MODULE: ./src/features/earnings/slice.ts + 1 modules
var earnings_slice = __webpack_require__(79695);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
;// CONCATENATED MODULE: ./src/global/TradingModal/slice.ts


// initial state
var TradingModal_slice_initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: trading/* ORDER_TYPE.BUY */.Jm.BUY
};
var TradingModal_slice_reducers = {
    showModal: function(draft, action) {
        draft.visible = true;
        draft.symbol = action.payload.symbol;
        draft.price = action.payload.price;
        draft.orderType = action.payload.type;
    },
    resetModal: function(draft) {
        draft.visible = false;
        draft.symbol = null;
        draft.orderType = trading/* ORDER_TYPE.BUY */.Jm.BUY;
    },
    setOrderType: function(draft, action) {
        draft.orderType = action.payload;
    }
};
// Selectors
var TradingModal_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return {
        visible: state.orderbookModal.visible,
        symbol: state.orderbookModal.symbol,
        price: state.orderbookModal.price,
        orderType: state.orderbookModal.orderType
    };
}, function(state) {
    return state;
});
// Slice
var rootSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "@orderbook/trading-modal",
    initialState: TradingModal_slice_initialState,
    reducers: TradingModal_slice_reducers,
    extraReducers: {}
});
/* harmony default export */ var TradingModal_slice = (rootSlice);

// EXTERNAL MODULE: ./src/global/Moderation/slice.ts
var Moderation_slice = __webpack_require__(98170);
;// CONCATENATED MODULE: ./src/global/Moderation/reducer.ts

var moderationReducer = Moderation_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var Moderation_reducer = (moderationReducer);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/slice.ts
var BandarDetector_slice = __webpack_require__(46881);
// EXTERNAL MODULE: ./src/lib/api/company.ts
var company = __webpack_require__(1349);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Hotlist/slice.js






// Auth Related Modules

// Actions
var Hotlist_slice_CONTEXT = "@side-widget/hotlist";
var Hotlist_slice_actionType = {
    GET_HOTLIST: "".concat(Hotlist_slice_CONTEXT, "/GET_HOTLIST")
};
// hotlist type
var HOTLIST_TYPE = {
    TOP_GAINER: "topGainer",
    TOP_LOSER: "topLoser",
    MOST_ACTIVE: "mostActive"
};
var slice_obj;
// hotlist api
var HOTLIST_API = (slice_obj = {}, (0,_define_property/* default */.Z)(slice_obj, HOTLIST_TYPE.TOP_GAINER, company/* default.getTopGainer */.Z.getTopGainer), (0,_define_property/* default */.Z)(slice_obj, HOTLIST_TYPE.TOP_LOSER, company/* default.getTopLoser */.Z.getTopLoser), (0,_define_property/* default */.Z)(slice_obj, HOTLIST_TYPE.MOST_ACTIVE, company/* default.getMostActive */.Z.getMostActive), slice_obj);
// initial state
var Hotlist_slice_initialState = {
    topGainer: {
        data: [],
        isLoading: false,
        error: null
    },
    topLoser: {
        data: [],
        isLoading: false,
        error: null
    },
    mostActive: {
        data: [],
        isLoading: false,
        error: null
    }
};
// Selectors
var Hotlist_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    var _hotlist = state.mainLayout.hotlist, topGainer = _hotlist.topGainer, topLoser = _hotlist.topLoser, mostActive = _hotlist.mostActive;
    return {
        // all
        topGainer: topGainer,
        topLoser: topLoser,
        mostActive: mostActive,
        // top gainer
        topGainerError: topGainer.error,
        topGainerData: topGainer.data,
        topGainerLoading: topGainer.isLoading,
        // top loser
        topLoserError: topLoser.error,
        topLoserData: topLoser.data,
        topLoserLoading: topLoser.isLoading,
        // most active
        mostActiveError: mostActive.error,
        mostActiveData: mostActive.data,
        mostActiveLoading: mostActive.isLoading
    };
}, function(state) {
    return state;
});
// Reducer
var Hotlist_slice_reducers = {};
// effects
var Hotlist_slice_effects = {
    // login
    getHotlist: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(Hotlist_slice_actionType.GET_HOTLIST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _type, type, targetAPI, response, _data, data, _$error, message, normalized;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _type = param.type, type = _type === void 0 ? HOTLIST_TYPE.TOP_GAINER : _type;
                        _ctx.prev = 1;
                        targetAPI = HOTLIST_API[type] || HOTLIST_API[HOTLIST_TYPE.TOP_GAINER];
                        _ctx.next = 5;
                        return targetAPI();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Error when changing password, no data recevied");
                    case 8:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(_$error);
                    case 11:
                        normalized = data.map(function(item) {
                            var change = item.change;
                            var changeIndicator = change[0];
                            var changeValue = change;
                            var changeFlow = "neutral";
                            if (changeIndicator === "+") {
                                changeFlow = "up";
                                changeValue = change.substring(1);
                            } else if (changeIndicator === "-") {
                                changeFlow = "down";
                            } else {
                                changeFlow = "neutral";
                            }
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                changeFlow: changeFlow,
                                changeIndicator: changeIndicator,
                                changeValue: changeValue
                            });
                        });
                        return _ctx.abrupt("return", {
                            data: normalized,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var _obj1;
// Extra / Async Reducer
var Hotlist_slice_extraReducers = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, Hotlist_slice_effects.getHotlist.pending, function(state, action) {
    var type = action.meta.arg.type;
    state[type].error = null;
    state[type].isLoading = true;
}), (0,_define_property/* default */.Z)(_obj1, Hotlist_slice_effects.getHotlist.fulfilled, function(state, action) {
    var type = action.meta.arg.type;
    state[type].data = action.payload.data;
    state[type].error = null;
    state[type].isLoading = true;
    state[type].message = action.payload.message;
}), (0,_define_property/* default */.Z)(_obj1, Hotlist_slice_effects.getHotlist.rejected, function(state, action) {
    var type = action.meta.arg.type;
    state[type].error = action.error;
    state[type].isLoading = true;
}), _obj1);
// Slice
var hotlistSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "hotlist",
    initialState: Hotlist_slice_initialState,
    reducers: Hotlist_slice_reducers,
    extraReducers: Hotlist_slice_extraReducers
});
/* harmony default export */ var Hotlist_slice = (hotlistSlice);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/slice.ts
var PriceAlert_slice = __webpack_require__(16835);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Valuation/slice.ts
var Valuation_slice = __webpack_require__(9139);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/slice.ts
var ListWatchlist_slice = __webpack_require__(31390);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/slice.ts
var CompanyWatchlist_slice = __webpack_require__(6767);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/slice.ts
var Orderbook_slice = __webpack_require__(18388);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/slice.ts
var Watchlist_slice = __webpack_require__(78626);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/reducer.ts





var sideWidgetReducer = (0,redux/* combineReducers */.UY)({
    orderbook: Orderbook_slice/* default.reducer */.ZP.reducer,
    listWatchlist: ListWatchlist_slice/* default.reducer */.ZP.reducer,
    company: CompanyWatchlist_slice/* default.reducer */.ZP.reducer,
    root: Watchlist_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var Watchlist_reducer = (sideWidgetReducer);

// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/reducer.js







var reducer_sideWidgetReducer = (0,redux/* combineReducers */.UY)({
    hotlist: Hotlist_slice.reducer,
    priceAlert: PriceAlert_slice/* default.reducer */.ZP.reducer,
    valuation: Valuation_slice/* default.reducer */.ZP.reducer,
    root: MainLayout_slice/* default.reducer */.ZP.reducer,
    bandarDetector: BandarDetector_slice/* default.reducer */.ZP.reducer,
    watchlist: Watchlist_reducer
});
/* harmony default export */ var MainLayout_reducer = (reducer_sideWidgetReducer);

// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var StreamWidget_slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./src/global/StreamConversation/slice.ts
var StreamConversation_slice = __webpack_require__(61048);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/lib/entities/watchlist/index.ts
var entities_watchlist = __webpack_require__(14675);
;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/slice.js






// External slice

// APIs

// Initial state
var SuggestedPeopleWidget_slice_initialState = {
    list: [],
    isLoading: true,
    message: "",
    error: null,
    toggleFollow: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selector
var SuggestedPeopleWidget_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.suggestedPeople;
}, function(suggestedPeople) {
    return {
        list: suggestedPeople.list,
        isLoading: suggestedPeople.isLoading,
        error: suggestedPeople.error,
        toggleFollow: suggestedPeople.toggleFollow
    };
});
// Action type
var SuggestedPeopleWidget_slice_CONTEXT = "@global/suggestedPeople";
var SuggestedPeopleWidget_slice_actionType = {
    GET_SUGGESTED_PEOPLE: "".concat(SuggestedPeopleWidget_slice_CONTEXT, "/GET_SUGGESTED_PEOPLE"),
    FOLLOW_USER: "".concat(SuggestedPeopleWidget_slice_CONTEXT, "/FOLLOW_USER")
};
var SuggestedPeopleWidget_slice_effects = {
    getSuggestedPeople: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(SuggestedPeopleWidget_slice_actionType.GET_SUGGESTED_PEOPLE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
            var page, limit, rest, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        page = _param.page, limit = _param.limit, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "page",
                            "limit"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return friends/* default.getSuggestFriends */.Z.getSuggestFriends((0,_object_spread/* default */.Z)({
                            page: page,
                            limit: limit
                        }, rest));
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get suggested people failed!");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }())
};
var SuggestedPeopleWidget_slice_reducers = {
    removeSugggestion: function(state, action) {
        var index = action.payload;
        state.list.splice(index, 1);
    }
};
var SuggestedPeopleWidget_slice_obj;
var SuggestedPeopleWidget_slice_extraReducers = (SuggestedPeopleWidget_slice_obj = {}, (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, SuggestedPeopleWidget_slice_effects.getSuggestedPeople.pending, function(state) {
    state.isLoading = true;
    state.error = null;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, SuggestedPeopleWidget_slice_effects.getSuggestedPeople.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
    if (error) {
        state.error = error;
    } else {
        state.list = data;
        state.error = null;
    }
    state.isLoading = false;
    state.message = message;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, SuggestedPeopleWidget_slice_effects.getSuggestedPeople.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // handle follow/unfollow user from watchlist slice
(0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, entities_watchlist/* effects.followUser.pending */.Sz.followUser.pending, function(state) {
    state.toggleFollow.isLoading = true;
    state.toggleFollow.error = null;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, entities_watchlist/* effects.followUser.fulfilled */.Sz.followUser.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, userid = _payload.userid, type = _payload.type;
    if (error) {
        state.toggleFollow.error = error;
    } else {
        state.toggleFollow.data = data;
        var userDataIndex = state.list.findIndex(// eslint-disable-next-line eqeqeq
        function(user) {
            return user.user.userid == userid;
        });
        if (userDataIndex > -1) {
            // set to true if 'FOLLOW', set false if otherwise
            state.list[userDataIndex].user.follow = type === "FOLLOW";
        }
    }
    state.toggleFollow.isLoading = false;
    state.toggleFollow.message = message;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, entities_watchlist/* effects.followUser.rejected */.Sz.followUser.rejected, function(state, action) {
    state.toggleFollow.error = action.payload.error;
    state.toggleFollow.isLoading = false;
}), SuggestedPeopleWidget_slice_obj);
var suggestedPeopleSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "suggestedPeople",
    reducers: SuggestedPeopleWidget_slice_reducers,
    extraReducers: SuggestedPeopleWidget_slice_extraReducers,
    initialState: SuggestedPeopleWidget_slice_initialState
});
/* harmony default export */ var SuggestedPeopleWidget_slice = (suggestedPeopleSlice);

;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/reducer.js

var suggestedPeopleReducer = SuggestedPeopleWidget_slice.reducer;
/* harmony default export */ var SuggestedPeopleWidget_reducer = (suggestedPeopleReducer);

// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/global/TrendingPeopleWidget/constants.ts
var TrendingPeopleWidget_constants = __webpack_require__(63600);
;// CONCATENATED MODULE: ./src/global/TrendingPeopleWidget/slice.js







// api

// feature constants

// initial state
var TrendingPeopleWidget_slice_initialState = {
    fetchStatus: TrendingPeopleWidget_constants/* FETCH_STATUS.IDLE */.e_.IDLE,
    list: [],
    message: "",
    timeRange: TrendingPeopleWidget_constants/* FILTER_CHOICE.0 */.n0[0],
    listChoice: TrendingPeopleWidget_constants/* LIST_CHOICE.TRENDING */.t6.TRENDING
};
// Selectors -------------------------------------------------------------------
var TrendingPeopleWidget_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.trendingPeople;
}, function(state) {
    return {
        fetchStatus: state.fetchStatus,
        list: state.list,
        timeRange: state.timeRange,
        listChoice: state.listChoice,
        // following states
        getUserByIndex: function(index) {
            return state.list[index] || null;
        }
    };
});
// Actions ---------------------------------------------------------------------
// types
var TrendingPeopleWidget_slice_CONTEXT = "@global/trendingPeople";
var TrendingPeopleWidget_slice_actionType = {
    FOLLOW_USER: "".concat(TrendingPeopleWidget_slice_CONTEXT, "/FOLLOW_USER"),
    GET_TRENDING_PEOPLE: "".concat(TrendingPeopleWidget_slice_CONTEXT, "/GET_TRENDING_PEOPLE"),
    GET_SUGGESTED_PEOPLE: "".concat(TrendingPeopleWidget_slice_CONTEXT, "/GET_SUGGESTED_PEOPLE")
};
// effects
var TrendingPeopleWidget_slice_effects = {
    followUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(TrendingPeopleWidget_slice_actionType.FOLLOW_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var userid, _type, type, dispatch, followUser, _payload, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        userid = param.userid, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("User id is empty!");
                    case 4:
                        _ctx.next = 6;
                        return dispatch(entities_watchlist/* effects.followUser */.Sz.followUser({
                            userid: userid,
                            type: type
                        }));
                    case 6:
                        followUser = _ctx.sent;
                        _payload = followUser.payload, _$error = _payload.error, message = _payload.message, data = _payload.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            userid: userid
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    getTrendingPeople: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(TrendingPeopleWidget_slice_actionType.GET_TRENDING_PEOPLE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _timeRange, timeRange, response, _data, data, message, composedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _timeRange = param.timeRange, timeRange = _timeRange === void 0 ? TrendingPeopleWidget_slice_initialState.timeRange : _timeRange;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return user/* default.getTrendingUser */.Z.getTrendingUser(timeRange.value);
                    case 4:
                        response = _ctx.sent;
                        if (!(!response || response.data && response.data.error)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(response.data.error);
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        composedData = data.map(function(user) {
                            return {
                                avatar: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.avatar.thumb),
                                followers: parseInt(user.statistics.follower_count, 10),
                                id: user.id,
                                isFollowed: user.is_followed,
                                official: user.is_verified,
                                username: user.username,
                                // for interactions
                                followingStatus: TrendingPeopleWidget_constants/* FETCH_STATUS.IDLE */.e_.IDLE
                            };
                        });
                        return _ctx.abrupt("return", {
                            data: composedData,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getSuggestedPeople: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(TrendingPeopleWidget_slice_actionType.GET_SUGGESTED_PEOPLE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, response, _data, data, message, composedData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return friends/* default.getSuggestFriends */.Z.getSuggestFriends({
                        page: 1,
                        limit: 5,
                        filter: "FILTER_STREAM"
                    });
                case 4:
                    response = _ctx.sent;
                    if (!(!response.data || (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.error))) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Attempt to get suggested people failed!");
                case 7:
                    _data = response.data, data = _data.data, message = _data.message;
                    composedData = data.map(function(user) {
                        return {
                            avatar: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user.user_avatar),
                            id: user.user.id,
                            isFollowed: user.followed === 1,
                            official: user.type === "OFFICIAL",
                            username: user.user.username,
                            followingStatus: TrendingPeopleWidget_constants/* FETCH_STATUS.IDLE */.e_.IDLE,
                            // key to differ list suggested people and trending
                            reason: user.reason
                        };
                    });
                    return _ctx.abrupt("return", {
                        data: composedData,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
// state management
var TrendingPeopleWidget_slice_reducers = {
    changeTimeRange: function(draft, action) {
        draft.timeRange = action.payload.timeRange;
    },
    changeListChoice: function(state, action) {
        state.listChoice = action.payload.listChoice;
    }
};
var TrendingPeopleWidget_slice_obj;
// Async / Extra Reducer
var TrendingPeopleWidget_slice_extraReducers = (TrendingPeopleWidget_slice_obj = {}, // follow user
(0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.followUser.pending, function(draft, action) {
    var index = action.meta.arg.index;
    draft.list[index].followingStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.PENDING */.e_.PENDING;
    draft.message = null;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.followUser.fulfilled, function(draft, action) {
    var _arg = action.meta.arg, index = _arg.index, type = _arg.type;
    draft.list[index].followingStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.RESOLVED */.e_.RESOLVED;
    draft.list[index].isFollowed = type === "FOLLOW";
    draft.message = action.payload.message;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.followUser.rejected, function(draft, action) {
    var index = action.meta.arg.index;
    draft.list[index].followingStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    draft.error = action.error;
}), // trending people
(0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getTrendingPeople.pending, function(draft, action) {
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.PENDING */.e_.PENDING;
    draft.timeRange = action.meta.arg.timeRange;
    draft.message = null;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getTrendingPeople.fulfilled, function(draft, action) {
    draft.list = action.payload.data;
    draft.message = action.payload.message;
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.RESOLVED */.e_.RESOLVED;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getTrendingPeople.rejected, function(draft, action) {
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    draft.message = action.error;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getSuggestedPeople.pending, function(state) {
    state.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.PENDING */.e_.PENDING;
    state.message = null;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getSuggestedPeople.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
    if (error) {
        state.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    } else {
        state.list = data;
        state.message = message;
        state.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.RESOLVED */.e_.RESOLVED;
    }
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getSuggestedPeople.rejected, function(draft, action) {
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    draft.message = action.error;
}), TrendingPeopleWidget_slice_obj);
// Slice
var trendingPeopleSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "trendingPeople",
    initialState: TrendingPeopleWidget_slice_initialState,
    reducers: TrendingPeopleWidget_slice_reducers,
    extraReducers: TrendingPeopleWidget_slice_extraReducers
});
/* harmony default export */ var TrendingPeopleWidget_slice = (trendingPeopleSlice);

;// CONCATENATED MODULE: ./src/global/TrendingPeopleWidget/reducer.js

var trendingPeopleReducer = TrendingPeopleWidget_slice.reducer;
/* harmony default export */ var TrendingPeopleWidget_reducer = (trendingPeopleReducer);

// EXTERNAL MODULE: ./src/global/WebSocket/slice.ts
var WebSocket_slice = __webpack_require__(23985);
;// CONCATENATED MODULE: ./src/global/WebSocket/reducer.ts

var websocketReducer = WebSocket_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var WebSocket_reducer = (websocketReducer);

// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
;// CONCATENATED MODULE: ./src/global/WebSocketV2/reducer.ts

var reducer_websocketReducer = WebSocketV2_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var WebSocketV2_reducer = (reducer_websocketReducer);

// EXTERNAL MODULE: ./src/global/Header/Search/slice.ts + 1 modules
var Search_slice = __webpack_require__(59016);
// EXTERNAL MODULE: ./src/lib/api/notification.ts
var notification = __webpack_require__(99368);
;// CONCATENATED MODULE: ./src/lib/models/notification/index.js
var schema = {
    count: {
        company: 0,
        stream: 0,
        other: 0
    },
    content: {
        company: [],
        stream: [],
        other: [],
        tipping: []
    }
};
/* harmony default export */ var models_notification = (schema);

// EXTERNAL MODULE: ./src/utils/notification.ts
var utils_notification = __webpack_require__(25178);
;// CONCATENATED MODULE: ./src/lib/entities/notification/slice.ts
/* eslint-disable no-unused-vars */ /* eslint-disable no-undef */ /* eslint-disable eqeqeq */ /* eslint-disable import/no-named-as-default-member */ /* eslint-disable camelcase */ 







// Action type
var notification_slice_CONTEXT = "@global/notification";
var notification_slice_actionType = {
    GET_UNREAD_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/GET_UNREAD_NOTIFICATION_DATA"),
    GET_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/GET_NOTIFICATION_DATA"),
    GET_PREVIOUS_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/GET_PREVIOUS_NOTIFICATION_DATA"),
    GET_NOTIFICATION_DATA_GROUPED_BY_TYPE: "".concat(notification_slice_CONTEXT, "/GET_NOTIFICATION_DATA_GROUPED_BY_TYPE"),
    MARK_AS_READ_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/MARK_AS_READ_NOTIFICATION_DATA")
};
// Initial state
var notification_slice_initialState = {
    error: null,
    isLoading: false,
    isLoadingMore: false,
    broadcast: models_notification,
    unread: 0,
    isReading: false,
    notificationStacks: [],
    lastId: null,
    isActivityChanged: false,
    isMentionChanged: false,
    isReportChanged: false,
    isTippingChanged: false
};
// Selectors
var notificationSelector = function(state) {
    return state.notification;
};
var notification_slice_selectors = (0,reselect_es/* createSelector */.P1)(notificationSelector, function(notificationState) {
    return (0,_object_spread/* default */.Z)({}, notificationState);
});
// Effects
var notification_slice_effects = {
    getNotificationData: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_NOTIFICATION_DATA, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return notification/* getNotification */.v6();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch notification data is failed");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getNotificationDataGroupedByType: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_NOTIFICATION_DATA_GROUPED_BY_TYPE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var _group, group, queues, results, normalizedResults;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _group = params.group, group = _group === void 0 ? [] : _group;
                        queues = group.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type) {
                                var response, _data, data, _$error;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return notification/* getNotification */.v6(type);
                                        case 2:
                                            response = _ctx.sent;
                                            if (response.data) {
                                                _ctx.next = 5;
                                                break;
                                            }
                                            throw new Error("Attempt to fetch notification data is failed");
                                        case 5:
                                            _data = response.data, data = _data.data, _$error = _data.error;
                                            if (!_$error) {
                                                _ctx.next = 8;
                                                break;
                                            }
                                            return _ctx.abrupt("return", {
                                                error: _$error
                                            });
                                        case 8:
                                            return _ctx.abrupt("return", data.result);
                                        case 9:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(type) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _ctx.next = 5;
                        return Promise.all(queues);
                    case 5:
                        results = _ctx.sent;
                        normalizedResults = results.flat();
                        return _ctx.abrupt("return", {
                            result: normalizedResults
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    markAsRead: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.MARK_AS_READ_NOTIFICATION_DATA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var _type, type, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _type = params.type, type = _type === void 0 ? [] : _type;
                        _ctx.next = 4;
                        return notification/* markAsRead */.zJ(type);
                    case 4:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data ? response.data : null);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    getUnreadNotificationNumber: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_UNREAD_NOTIFICATION_DATA, // @ts-ignore
    (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return notification/* getUnreadNotificationNumber */.O7();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch notification data is failed");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getPreviousNotificationData: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_PREVIOUS_NOTIFICATION_DATA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var limit, _types, types, lastId, response, _data, data, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        limit = params.limit, _types = params.types, types = _types === void 0 ? [] : _types, lastId = params.lastId;
                        _ctx.next = 4;
                        return notification/* getNotification */.v6(types, limit, lastId);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to fetch notification data is failed");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", data);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var notification_slice_reducers = {
    setUnreadNotificationNumber: function setUnreadNotificationNumber(draft, action) {
        draft.unread = action.payload;
    },
    // @deprecated | Not used in the project
    appendNotificationDataFromSocket: function appendNotificationDataFromSocket(draft, action) {
        var _payload = action.payload, notificationType = _payload.notificationType, index = _payload.index, data = _payload.data;
        if (index) {
            draft.broadcast.content[notificationType][index] = data;
        } else {
            draft.broadcast.content[notificationType].push(data);
        }
        draft.unread += 1;
        switch(notificationType){
            case "other":
                draft.isActivityChanged = true;
                break;
            case "stream":
                draft.isMentionChanged = true;
                break;
            case "company":
                draft.isReportChanged = true;
                break;
            case "tipping":
                draft.isTippingChanged = true;
                break;
            default:
                break;
        }
    },
    // @deprecated | Not used in the project
    removeNotificationMarkers: function removeNotificationMarkers(draft, action) {
        switch(action.payload){
            case "notification":
                draft.isActivityChanged = false;
                draft.isMentionChanged = false;
                draft.isReportChanged = false;
                draft.isTippingChanged = false;
                break;
            case "activity":
                draft.isActivityChanged = false;
                break;
            case "mention":
                draft.isMentionChanged = false;
                break;
            case "report":
                draft.isReportChanged = false;
                break;
            case "tipping":
                draft.isTippingChanged = false;
                break;
            default:
                break;
        }
    },
    // @deprecated | Not used in the project
    emptyUnreadNotificationData: function emptyUnreadNotificationData(draft) {
        draft.unread = 0;
    },
    // @deprecated | Not used in the project
    markAsReadNotificationItem: function markAsReadNotificationItem(draft, action) {
        var indexCompany = draft.broadcast.content.company.findIndex(function(item) {
            return item.id === action.payload;
        });
        var indexActivity = draft.broadcast.content.other.findIndex(function(item) {
            return item.id === action.payload;
        });
        var indexStream = draft.broadcast.content.stream.findIndex(function(item) {
            return item.id === action.payload;
        });
        var indexTipping = draft.broadcast.content.tipping.findIndex(function(item) {
            return item.id === action.payload;
        });
        // Notifiction ID is inside company (report) section
        if (indexCompany > -1) {
            draft.broadcast.content.company[indexCompany].status = 1;
        }
        // Notifiction ID is inside activity (other) section
        if (indexActivity > -1) {
            draft.broadcast.content.other[indexActivity].status = 1;
        }
        // Notifiction ID is inside stream (mention) section
        if (indexStream > -1) {
            draft.broadcast.content.stream[indexStream].status = 1;
        }
        // Notification ID is inside tipping section
        if (indexTipping > -1) {
            draft.broadcast.content.tipping[indexTipping].status = 1;
        }
    },
    // @deprecated | Not used in the project
    pushStackNotificationData: function pushStackNotificationData(draft, action) {
        draft.notificationStacks = [
            action.payload
        ];
    }
};
// Extra reducers
var notification_slice_extraReducers = function(builder) {
    // Get notification data
    builder.addCase(notification_slice_effects.getNotificationData.pending, function(state) {
        state.isLoading = true;
    }).addCase(notification_slice_effects.getNotificationData.fulfilled, function(state, action) {
        if (action.payload.error) {
            state.error = action.payload.error;
        } else {
            state.broadcast = (0,utils_notification/* normalizeNotification */.WE)(action.payload.result);
            state.unread = action.payload.unread;
            state.isLoading = false;
            // handle last id
            var result = action.payload.result;
            if (result && result.length > 0) {
                state.lastId = result[result.length - 1].id;
            }
        }
    }).addCase(notification_slice_effects.getNotificationData.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload;
    })// Get previous notification data
    .addCase(notification_slice_effects.getPreviousNotificationData.pending, function(state) {
        state.isLoadingMore = true;
    }).addCase(notification_slice_effects.getPreviousNotificationData.fulfilled, function(state, action) {
        if (action.payload.error) {
            state.error = action.payload.error;
        } else {
            var disorganizedContent = (0,utils_notification/* disorganizeNormalizedNotification */.QV)(state.broadcast.content);
            var results = (0,_to_consumable_array/* default */.Z)(disorganizedContent).concat((0,_to_consumable_array/* default */.Z)(action.payload.result));
            state.isLoadingMore = false;
            state.broadcast = (0,utils_notification/* normalizeNotification */.WE)(results);
        }
    }).addCase(notification_slice_effects.getPreviousNotificationData.rejected, function(state, action) {
        var error = action.payload.error;
        state.isLoadingMore = false;
        state.error = error;
    })// Get notification data grouped by type
    .addCase(notification_slice_effects.getNotificationDataGroupedByType.pending, function(state) {
        state.isLoading = true;
    }).addCase(notification_slice_effects.getNotificationDataGroupedByType.fulfilled, function(state, action) {
        if (action.payload.error) {
            state.error = action.payload.error;
        } else {
            var disorganizedContent = (0,utils_notification/* disorganizeNormalizedNotification */.QV)(state.broadcast.content);
            var results = (0,_to_consumable_array/* default */.Z)(disorganizedContent).concat((0,_to_consumable_array/* default */.Z)(action.payload.result));
            // handle last id
            var result = action.payload.result;
            if (result && result.length > 0) {
                state.lastId = result[result.length - 1].id;
            }
            state.isLoading = false;
            state.broadcast = (0,utils_notification/* normalizeNotification */.WE)(results);
        }
    }).addCase(notification_slice_effects.getNotificationDataGroupedByType.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload.error;
    })// Mark as read
    .addCase(notification_slice_effects.markAsRead.pending, function(state) {
        state.isReading = true;
    }).addCase(notification_slice_effects.markAsRead.fulfilled, function(state, action) {
        state.isReading = !action.payload.data;
        state.unread = 0;
    }).addCase(notification_slice_effects.markAsRead.rejected, function(state, action) {
        state.isReading = false;
        state.error = action.payload.error;
    })// Get unread notification number
    .addCase(notification_slice_effects.getUnreadNotificationNumber.fulfilled, function(state, action) {
        state.unread = action.payload.unread;
    }).addCase(notification_slice_effects.getUnreadNotificationNumber.rejected, function(state, action) {
        state.error = action.payload;
    });
};
// Slice
var notificationSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "notification",
    initialState: notification_slice_initialState,
    reducers: notification_slice_reducers,
    extraReducers: notification_slice_extraReducers
});
/* harmony default export */ var notification_slice = (notificationSlice);

// EXTERNAL MODULE: ./src/features/valuation/slice.ts
var valuation_slice = __webpack_require__(17712);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var SearchCompany_slice = __webpack_require__(33908);
// EXTERNAL MODULE: ./src/lib/entities/livestream.ts + 1 modules
var livestream = __webpack_require__(61942);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/user/trending.js

var trending_schema = {
    followers: "",
    id: "",
    isFollowed: 0,
    official: 0,
    reputation: "",
    tren_controversial: "",
    tren_trending: "",
    user_avatar: "",
    user_avatar_medium: "",
    user_avatar_thumb: "",
    user_features: "",
    username: ""
};
var propTypes = {
    followers: prop_types.string,
    id: prop_types.string,
    isFollowed: prop_types.number,
    official: prop_types.number,
    reputation: prop_types.string,
    tren_controversial: prop_types.string,
    tren_trending: prop_types.string,
    user_avatar: prop_types.string,
    user_avatar_medium: prop_types.string,
    user_avatar_thumb: prop_types.string,
    user_features: prop_types.string,
    username: prop_types.string
};
/* harmony default export */ var trending = ({
    schema: trending_schema,
    propTypes: propTypes
});

;// CONCATENATED MODULE: ./src/lib/entities/trendingUser.js






// api


// model

// initial state
var trendingUser_initialState = {
    selected: trending.schema,
    list: [],
    isLoading: false,
    error: null,
    message: ""
};
// Selectors -------------------------------------------------------------------
var trendingUser_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return {
        selected: state.user.trending.selected,
        list: state.user.trending.list,
        isLoading: state.user.trending.isLoading,
        error: state.user.trending.error,
        message: state.user.trending.message
    };
}, function(state) {
    return state;
});
// Actions ---------------------------------------------------------------------
// types
var trendingUser_CONTEXT = "@redux/user";
var trendingUser_actionType = {
    FETCH_TRENDING: "".concat(trendingUser_CONTEXT, "/FETCH_TRENDING")
};
// effects
var trendingUser_effects = {
    // getTrendinguser -------------------------------------------------------------------
    getTrendingUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(trendingUser_actionType.FETCH_TRENDING, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error, sanitizedData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return user/* default.getTrendingUser */.Z.getTrendingUser({
                        timeRange: "1W"
                    });
                case 3:
                    response = _ctx.sent;
                    if (!response.data) {
                        _ctx.next = 10;
                        break;
                    }
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 8:
                    sanitizedData = data.map(function(user) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                            // Concat User avatar url with base avatar URL
                            user_avatar: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user_avatar),
                            user_avatar_medium: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user_avatar_medium),
                            user_avatar_thumb: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user_avatar_thumb)
                        });
                    });
                    return _ctx.abrupt("return", {
                        data: sanitizedData,
                        message: message
                    });
                case 10:
                    throw new Error("Attempt to fetch Trending user Failed");
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    })))
};
// Reducer ---------------------------------------------------------------------
var trendingUser_reducers = {};
var trendingUser_obj;
// Extra Reducer ---------------------------------------------------------------
var trendingUser_extraReducers = (trendingUser_obj = {}, // Get Trending User ---------------------------------------------------------
(0,_define_property/* default */.Z)(trendingUser_obj, trendingUser_effects.getTrendingUser.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(trendingUser_obj, trendingUser_effects.getTrendingUser.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.error = error;
    } else {
        state.list = data;
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(trendingUser_obj, trendingUser_effects.getTrendingUser.rejected, function(state, action) {
    state.error = action.payload.error;
    state.message = action.payload.message;
    state.isLoading = false;
}), trendingUser_obj);
// Slice -----------------------------------------------------------------------
var trendingSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "trending",
    initialState: trendingUser_initialState,
    reducers: trendingUser_reducers,
    extraReducers: trendingUser_extraReducers
});
/* harmony default export */ var trendingUser = (trendingSlice);

// EXTERNAL MODULE: ./src/lib/entities/onboarding.ts
var onboarding = __webpack_require__(9526);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var entities_company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/lib/api/general.js
var general = __webpack_require__(69042);
;// CONCATENATED MODULE: ./src/lib/entities/general.js






// APIs

// Initial State
var general_initialState = {
    searchGif: {
        data: [],
        totalCount: 0,
        isLoading: false,
        error: null,
        message: ""
    },
    trendingGif: {
        data: [],
        totalCount: 0,
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors
var general_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.entities.general;
}, function(general) {
    return {
        searchGif: general.searchGif,
        trendingGif: general.trendingGif
    };
});
// Action type
var general_CONTEXT = "@redux/general";
var general_actionType = {
    GET_SEARCH_GIF: "".concat(general_CONTEXT, "/GET_SEARCH_GIF"),
    GET_TRENDING_GIF: "".concat(general_CONTEXT, "/GET_TRENDING_GIF"),
    LOAD_MORE_SEARCH_GIF: "".concat(general_CONTEXT, "/LOAD_MORE_SEARCH_GIF"),
    LOAD_MORE_TRENDING_GIF: "".concat(general_CONTEXT, "/LOAD_MORE_TRENDING_GIF")
};
var general_effects = {
    // search gif
    getSearchGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.GET_SEARCH_GIF, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var offset, response, _data, data, _meta, message, _$error, _pagination, totalCount, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        offset = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return general/* default.getSearchGif */.Z.getSearchGif(keyword, offset);
                    case 4:
                        response = _ctx.sent;
                        if (!(response.status >= 400)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Bad response from server");
                    case 7:
                        _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code, _pagination = _data.pagination, totalCount = _pagination.total_count;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            totalCount: totalCount
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadMoreSearchGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.LOAD_MORE_SEARCH_GIF, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var offset, response, _data, data, _meta, message, _$error, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        offset = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return general/* default.getSearchGif */.Z.getSearchGif(keyword, offset);
                    case 4:
                        response = _ctx.sent;
                        if (!(response.status >= 400)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Bad response from server");
                    case 7:
                        _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    // trending gif
    getTrendingGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.GET_TRENDING_GIF, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var offset, response, _data, data, _meta, message, _$error, _pagination, totalCount, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    offset = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 0;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return general/* default.getTrendingGif */.Z.getTrendingGif(offset);
                case 4:
                    response = _ctx.sent;
                    if (!(response.status >= 400)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Bad response from server");
                case 7:
                    _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code, _pagination = _data.pagination, totalCount = _pagination.total_count;
                    if (!_$error) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message,
                        totalCount: totalCount
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    }))),
    loadMoreTrendingGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.LOAD_MORE_TRENDING_GIF, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var offset, response, _data, data, _meta, message, _$error, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    offset = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 0;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return general/* default.getTrendingGif */.Z.getTrendingGif(offset);
                case 4:
                    response = _ctx.sent;
                    if (!(response.status >= 400)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Bad response from server");
                case 7:
                    _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code;
                    if (!_$error) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    })))
};
// Reducers
var general_reducers = {
    clearSearchGif: function(state) {
        state.searchGif = general_initialState.searchGif;
    }
};
var general_obj;
// Extra reducers
var general_extraReducers = (general_obj = {}, // search gif
(0,_define_property/* default */.Z)(general_obj, general_effects.getSearchGif.pending, function(state) {
    state.searchGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getSearchGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, totalCount = _payload.totalCount;
    if (error) {
        state.searchGif.error = error;
    } else {
        state.searchGif.data = data;
    }
    state.searchGif.totalCount = totalCount;
    state.searchGif.message = message;
    state.searchGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getSearchGif.rejected, function(state, action) {
    state.searchGif.error = action.payload.error;
    state.searchGif.isLoading = false;
}), // load more search gif
(0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreSearchGif.pending, function(state) {
    state.searchGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreSearchGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.searchGif.error = error;
    } else {
        var currentData = state.searchGif.data.map(function(i) {
            return (0,_object_spread/* default */.Z)({}, i);
        });
        state.searchGif.data = (0,_to_consumable_array/* default */.Z)(currentData).concat((0,_to_consumable_array/* default */.Z)(data));
    }
    state.searchGif.message = message;
    state.searchGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreSearchGif.rejected, function(state, action) {
    state.searchGif.error = action.payload.error;
    state.searchGif.isLoading = false;
}), // trending gif
(0,_define_property/* default */.Z)(general_obj, general_effects.getTrendingGif.pending, function(state) {
    state.trendingGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getTrendingGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, totalCount = _payload.totalCount;
    if (error) {
        state.trendingGif.error = error;
    } else {
        state.trendingGif.data = data;
    }
    state.trendingGif.totalCount = totalCount;
    state.trendingGif.message = message;
    state.trendingGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getTrendingGif.rejected, function(state, action) {
    state.trendingGif.error = action.payload.error;
    state.trendingGif.isLoading = false;
}), // load more trending gif
(0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreTrendingGif.pending, function(state) {
    state.trendingGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreTrendingGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.trendingGif.error = error;
    } else {
        var currentData = state.trendingGif.data.map(function(i) {
            return (0,_object_spread/* default */.Z)({}, i);
        });
        state.trendingGif.data = (0,_to_consumable_array/* default */.Z)(currentData).concat((0,_to_consumable_array/* default */.Z)(data));
    }
    state.trendingGif.message = message;
    state.trendingGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreTrendingGif.rejected, function(state, action) {
    state.trendingGif.error = action.payload.error;
    state.trendingGif.isLoading = false;
}), general_obj);
var generalSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "general",
    initialState: general_initialState,
    reducers: general_reducers,
    extraReducers: general_extraReducers
});
/* harmony default export */ var entities_general = (generalSlice);

// EXTERNAL MODULE: ./src/lib/entities/user.js
var entities_user = __webpack_require__(16992);
// EXTERNAL MODULE: ./src/lib/entities/stream.ts
var entities_stream = __webpack_require__(25641);
// EXTERNAL MODULE: ./src/lib/entities/moderation.js
var moderation = __webpack_require__(56214);
// EXTERNAL MODULE: ./src/lib/entities/tipping.js
var tipping = __webpack_require__(98585);
// EXTERNAL MODULE: ./src/lib/entities/comparison.ts + 1 modules
var comparison = __webpack_require__(60913);
// EXTERNAL MODULE: ./src/lib/entities/fundachart.ts
var fundachart = __webpack_require__(4822);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/lib/entities/shop.ts + 1 modules
var shop = __webpack_require__(11733);
;// CONCATENATED MODULE: ./src/lib/entities/index.js
















var entitiesReducer = (0,redux/* combineReducers */.UY)({
    chat: chat_slice/* default.reducer */.ZP.reducer,
    credentials: credentials/* default.reducer */.ZP.reducer,
    profile: profile/* default.reducer */.ZP.reducer,
    trending: trendingUser.reducer,
    onboarding: onboarding/* default.reducer */.ZP.reducer,
    company: entities_company/* default.reducer */.ZP.reducer,
    general: entities_general.reducer,
    user: entities_user/* default.reducer */.ZP.reducer,
    stream: entities_stream/* default.reducer */.ZP.reducer,
    moderation: moderation/* default.reducer */.ZP.reducer,
    tipping: tipping/* default.reducer */.ZP.reducer,
    watchlist: entities_watchlist/* default.reducer */.ZP.reducer,
    comparison: comparison/* default.reducer */.ZP.reducer,
    fundachart: fundachart/* default.reducer */.ZP.reducer,
    shop: shop/* default.reducer */.ZP.reducer
});
/* harmony default export */ var entities = (entitiesReducer);

;// CONCATENATED MODULE: ./src/lib/rootReducer.ts

// import reducers -------------------------------------------------------------
// feature specific reducers

















// globally used component reducers













// entities reducers

// combile each reducer
var rootReducer = (0,redux/* combineReducers */.UY)({
    // features
    discoverPeople: reducer,
    editProfile: edit_profile_reducer,
    onboarding: onboarding_reducer,
    register: register_reducer,
    resetPassword: reset_password_reducer,
    userProfile: user_reducer,
    watchlist: watchlist_reducer,
    companyProfile: company_reducer,
    catalog: catalog_reducer,
    postDetail: post_detail_reducer,
    mainLayout: MainLayout_reducer,
    moderation: Moderation_reducer,
    trendingPeople: TrendingPeopleWidget_reducer,
    suggestedPeople: SuggestedPeopleWidget_reducer,
    research: research_slice/* default.reducer */.ZP.reducer,
    calendar: calendar_slice/* default.reducer */.ZP.reducer,
    earnings: earnings_slice/* default.reducer */.ZP.reducer,
    websocket: WebSocket_reducer,
    websocketV2: WebSocketV2_reducer,
    chartbit: chartbit_reducer,
    orderbookModal: TradingModal_slice.reducer,
    valuation: valuation_slice/* default.reducer */.ZP.reducer,
    screener: screener_slice/* default.reducer */.ZP.reducer,
    liveStream: livestream/* default.reducer */.ZP.reducer,
    searchCompany: SearchCompany_slice/* default.reducer */.ZP.reducer,
    // globally used components
    stream: stream_slice.reducer,
    search: Search_slice/* default.reducer */.ZP.reducer,
    notification: notification_slice.reducer,
    streamConversation: StreamConversation_slice/* default.reducer */.ZP.reducer,
    streamWidget: StreamWidget_slice/* default.reducer */.ZP.reducer,
    // entities
    entities: entities
});
/* harmony default export */ var lib_rootReducer = (rootReducer);

;// CONCATENATED MODULE: ./src/lib/store.ts
/* eslint-disable no-underscore-dangle */ 

// import reducers

// devtools config definitions
var devToolsConfig = {
    name: "Stockbit Web-App"
};
var withDevtools =  false ? 0 : false;
// Config store
var makeStore = function() {
    return (0,redux_toolkit_esm/* configureStore */.xC)({
        reducer: lib_rootReducer,
        devTools: withDevtools,
        middleware: function(getDefaultMiddleware) {
            return getDefaultMiddleware({
                serializableCheck: {
                    // Ignore these action types
                    ignoredActions: [
                        "@redux/websocket/INIT_CONFIG",
                        "@redux/websocket/UPDATE_CONFIG",
                        "@redux/websocket/ADD_SOCKET_DATA", 
                    ]
                }
            });
        }
    });
};
var store = makeStore();
var wrapper = (0,es6/* createWrapper */.KV)(makeStore, {
    debug: true
});
/* harmony default export */ var lib_store = ((/* unused pure expression or super */ null && (store)));

// EXTERNAL MODULE: ./src/config/theme.ts
var theme = __webpack_require__(30079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
// EXTERNAL MODULE: ./src/global/GlobalStyles/alert.ts
var GlobalStyles_alert = __webpack_require__(80341);
;// CONCATENATED MODULE: ./src/global/GlobalStyles/layout.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .chat-page-layout-container {\n    padding-top: 60px !important;\n    margin-top: unset !important;\n    padding-right: 0px !important;\n\n    @media ",
        " {\n      padding-top: 120px !important;\n    }\n\n    @media ",
        " {\n      max-width: 1300px;\n      margin: 100px auto 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var layoutPageContainerStyles = (0,styled_components_browser_esm/* css */.iv)(_templateObject(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
/* harmony default export */ var layout = (layoutPageContainerStyles);

;// CONCATENATED MODULE: ./src/global/GlobalStyles/tooltip.ts

function tooltip_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .tooltip-overlay-white {\n  max-width: 320px;\n  \n  .ant-tooltip-arrow-content {\n    background-color: ",
        ";\n    }\n    .ant-tooltip-inner { \n      padding: 12px 16px;\n      background-color: ",
        ";\n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-green {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-dark {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      background: ",
        ";\n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-red {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      background: ",
        ";\n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-transparent {\n    cursor: pointer;\n    padding-top: 0 !important;\n    .ant-tooltip-arrow-content {\n      display: none;\n      background: transparent;\n      box-shadow: unset;\n\n      ::before {\n        transparent;\n      }\n    }\n    \n    .ant-tooltip-inner { \n      background: transparent;\n      border-radius: 4px;\n    }\n  }\n"
    ]);
    tooltip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var tooltipStyles = (0,styled_components_browser_esm/* css */.iv)(tooltip_templateObject(), color/* default.light */.Z.light, color/* default.light */.Z.light, color/* default.primary */.Z.primary, color/* default.highempahis */.Z.highempahis, color/* default.highempahis */.Z.highempahis, color/* default.sunsetOrange */.Z.sunsetOrange, color/* default.sunsetOrange */.Z.sunsetOrange);
/* harmony default export */ var tooltip = (tooltipStyles);

;// CONCATENATED MODULE: ./src/global/GlobalStyles/index.js

function GlobalStyles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Wave Color */\n  html {\n    --antd-wave-shadow-color: ",
        ";\n  }\n\n  body {\n    background-color: #f5f5f5;\n    font-family: var(--regular-font);\n    font-size: 14px;\n    height: auto;\n    font-variant: normal;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  b,\n  strong {\n    font-family: var(--bold-font);\n    font-weight: normal;\n  }\n\n  /* ANTD Modal */\n  /* .ant-modal-mask {\n    z-index: 1031;\n  }\n\n  .ant-modal-wrap {\n    z-index: 1040;\n  } */\n\n  /* Antd Popover */\n  .ant-popover-inner-content {\n    padding: 0;\n  }\n  .ant-popover-inner {\n    box-shadow: none;\n    border: none;\n  }\n  .ant-popover-arrow {\n    display: none;\n  }\n\n  .ant-popover-placement-bottomRight {\n    position: fixed;\n  }\n\n  /* Antd DatePicker */\n  .ant-picker-panel-container {\n    border: 1px solid ",
        ";\n  }\n\n  .ant-picker-decade-panel,\n  .ant-picker-year-panel,\n  .ant-picker-quarter-panel,\n  .ant-picker-month-panel,\n  .ant-picker-week-panel,\n  .ant-picker-date-panel,\n  .ant-picker-time-panel {\n    width: 230px;\n  }\n\n  .ant-picker-content {\n    table-layout: auto;\n    width: 100% !important;\n  }\n\n  .ant-picker-header-view {\n    font-size: 12px;\n    font-family: var(--font-bold);\n\n    button {\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n  .ant-picker-cell-in-view {\n    font-family: var(--font-bold);\n  }\n  .ant-picker-footer {\n    display: block !important;\n  }\n  .ant-picker-today-btn {\n    font-size: 12px;\n    color: ",
        ";\n    font-family: var(--font-bold);\n    display: block !important;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n  .ant-picker-dropdown {\n    font-size: 10px !important;\n  }\n\n  .ant-picker-cell {\n    padding: 2px 0;\n  }\n\n  .ant-picker-cell-in-view.ant-picker-cell-today\n    .ant-picker-cell-inner::before {\n    border: none !important;\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n    background: #00ab6b !important;\n    color: white !important;\n  }\n  .ant-picker-content th {\n    font-weight: bold;\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-today\n    .ant-picker-cell-inner::before {\n    border-color: ",
        ";\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n    color: unset;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    background: #00ab6b !important;\n    color: white !important;\n  }\n  .ant-picker-cell:hover:not(.ant-picker-cell-selected) .ant-picker-cell-inner {\n    background: ",
        " !important;\n    margin: -1px;\n  }\n\n  .ant-picker-year-panel,\n  .ant-picker-decade-panel {\n    width: 400px;\n    .ant-picker-body {\n      .ant-picker-cell-selected::before {\n        background: transparent !important;\n      }\n    }\n  }\n\n  /* Antd Dropdown */\n  .ant-dropdown {\n    li {\n      height: 28px !important;\n      line-height: 28px !important;\n      padding: 0 10px !important;\n    }\n  }\n  .ant-dropdown-menu {\n    border: 1px solid #dadada;\n    border-radius: 0;\n    box-shadow: 0 0 10px ",
        ";\n    padding: 0px;\n  }\n\n  .ant-dropdown-menu-item,\n  .ant-dropdown-menu-submenu-title {\n    padding: 5px;\n\n    p {\n      color: ",
        ";\n    }\n\n    &:hover,\n    &.ant-dropdown-menu-item-active {\n      p {\n        color: ",
        ";\n      }\n    }\n\n    &:first-child {\n      border-radius: 3px 3px 0 0;\n    }\n\n    &:last-child {\n      border-radius: 0 0 3px 3px;\n    }\n  }\n\n  /* Antd Select */\n  .ant-select-item {\n    font-family: 'ProximaNovaRg';\n  }\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset;\n  }\n  .ant-select-dropdown {\n    box-shadow: none;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n\n    div[aria-selected='true'] {\n      font-family: var(--bold-font);\n    }\n  }\n\n  /* Antd tag a */\n  a:hover {\n    color: ",
        ";\n  }\n\n  /* Antd autocomplete */\n  .ant-select-focused .ant-select-selector,\n  .ant-select-selector:focus,\n  .ant-select-selector:active,\n  .ant-select-selector:hover,\n  .ant-select-open .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  /* Antd modal */\n  .ant-modal-mask {\n    background-color: rgba(18, 18, 18, 0.5);\n  }\n\n  /* Antd Message */\n  .ant-message {\n    z-index: 999999; // TOP OF LAYER\n  }\n\n  .ant-btn-primary[disabled] {\n    background: #616161 !important;\n    color: #cbcbcb;\n    border: none;\n\n    &:hover > p {\n      color: #cbcbcb;\n    }\n  }\n\n  body.disabled-popover-animation .ant-popover {\n    animation-duration: 0s !important;\n  }\n\n  body.no-scroll {\n    overflow: hidden;\n    width: 100% !important;\n  }\n"
    ]);
    GlobalStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :root {\n    --font-regular: 'ProximaNovaRg', sans-serif;\n    --font-bold: 'ProximaNovaBd', sans-serif;\n  }\n\n  @keyframes placeHolderShimmer {\n    0% {\n      background-position: -468px 0;\n    }\n    100% {\n      background-position: 468px 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n\n    :root {\n      --regular-font: \"ProximaNovaRg\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      --bold-font: \"ProximaNovaBd\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      --light-font: \"ProximaNovaLt\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    }\n\n    ::-webkit-scrollbar {\n      width: 4px;\n      height: 5px;\n    }\n    ::-webkit-scrollbar-button {\n      width: 0px;\n      height: 0px;\n    }\n    ::-webkit-scrollbar-thumb {\n      background: ",
        ";\n      border: 0px none ",
        ";\n      border-radius: 0;\n    }\n    ::-webkit-scrollbar-thumb:hover {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-thumb:active {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-track {\n      background: white;\n      border: 0px none ",
        ";\n      border-radius: 0;\n    }\n    ::-webkit-scrollbar-track:hover {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-track:active {\n      background: ",
        ';\n    }\n    ::-webkit-scrollbar-corner {\n      background: transparent;\n    }\n\n    .hide {\n      display: none;\n    }\n\n    .stop-scrolling {\n      height: 100%;\n      overflow: hidden;\n    }\n\n    /* Hide crisp chat */\n    #crisp-chatbox > div > div {\n      display: none !important;\n\n      &[data-visible="true"] {\n        display: block !important;\n      }\n    }\n\n    /* Hide google recaptcha */\n    .grecaptcha-badge {\n      opacity: 0;\n      visibility: hidden;\n    }\n\n    select {\n      appearance: none;\n      cursor: pointer;\n      padding-right : 20px;\n      min-width : 48px;\n      :focus {\n        outline: 0;\n      }\n      background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgMjU1IDI1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjU1IDI1NTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnIGlkPSJhcnJvdy1kcm9wLWRvd24iPgoJCTxwb2x5Z29uIHBvaW50cz0iMCw2My43NSAxMjcuNSwxOTEuMjUgMjU1LDYzLjc1ICAgIiBmaWxsPSIjNmI2YjZiIi8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==")\n        calc(100% - 8px) center/8px auto no-repeat #fff !important;\n    }\n\n    .sysmsg-content {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      padding: 0;\n\n      & > div {\n        background: transparent;\n        padding: 0;\n      }\n\n      & > div > div > span {\n        & > .alert-green,\n        & > .alert-red,\n        & > .alert-blue,\n        & > .alert-orange {\n          border-radius: 5px;\n          padding: 10px 15px;\n        }\n      }\n\n      & > div > div > span > .alert-green {\n        background: #e1f6e5;\n        color: ',
        ";\n      }\n      \n      & > div > div > span > .alert-red {\n        background: ",
        ";\n        color: ",
        ";\n      }\n      \n      & > div > div > span > .alert-orange {\n        background: ",
        ";\n        color: ",
        ";\n      }\n      \n      & > div > div > span > .alert-blue {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      & > div > div > span > .snackbar-green {\n        font-size: 12px;\n        border-radius: 2px;\n        padding: 13px 16px;\n        font-family: var(--font-bold);\n        background: #e1f6e5;\n\n        span {\n          margin: 0 12px;\n        }\n      }\n\n      & > div > div > span > .plain-green {\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 8px 10px;\n        font-family: var(--font-regular);\n        background: ",
        ";\n        color: ",
        ";\n        line-height: 16.1px;\n      }\n    }\n\n    .modal-conversation {\n      z-index: 50 !important;\n      @media ",
        " {\n        z-index: 1000 !important;\n      }\n    }\n    \n    input:-webkit-autofill {\n      -webkit-box-shadow: 0 0 0 1000px #fff inset!important;\n      box-shadow: 0 0 0 1000px #fff inset!important;\n    }\n\n    .panel-avatar {\n      width: 30px;\n      height: 30px;\n      border: solid 1px #c0c0c0;\n      border-radius: 50%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n  \n    // FLOATING CHAT NOTIFICATION\n    .float-chat-notification {\n      min-height: 76px;\n      cursor: pointer;\n      padding: 15px !important;\n      font-family: ProximaNovaRg;\n      \n      :last-child {\n        margin-bottom: 0;\n      }\n      \n      & div > div > div {\n        margin-left: 60px !important;\n      }\n\n      & .ant-notification-close-icon {\n        font-size: 10px;\n      }\n\n      & .ant-notification-notice {\n        margin-bottom: unset;\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-description {\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-close {\n        top: 10px;\n      }\n    }\n\n    // FLOATIN ALERT NOTIFICATION\n    .float-alert-notification {\n      padding: 0;\n      border: 1px solid #dadada;\n\n      :last-child {\n        margin-bottom: 0;\n      }\n\n      .ant-notification-notice-icon {\n        left: 0;\n        top: 0;\n        margin-left: 0;\n        height: 100%;\n        \n        img {\n          width: 100%;\n          height: 100%\n        }\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        font-family: var(--font-bold);\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-top: 15px;\n        margin-left: 85px;\n      }\n\n      & .ant-notification-notice-description {\n        padding-bottom: 15px;\n        margin-left: 85px;\n        line-height: normal;\n      }\n\n      & .ant-notification-notice-close {\n        top: 16px;\n        right: 16px;\n        font-size: 12px;\n      }\n    }\n\n    // FLOATIN GENERAL NOTIFICATION\n    .float-general-notification {\n      cursor: pointer;\n      padding: 15px !important;\n      font-family: ProximaNovaRg;\n      \n      :last-child {\n        margin-bottom: 0;\n      }\n      \n      & div > div > div {\n        margin-left: 60px !important;\n      }\n\n      & .ant-notification-close-icon {\n        font-size: 10px;\n      }\n\n      & .ant-notification-notice {\n        margin-bottom: unset;\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-description {\n        font-size: 14px;\n        overflow: hidden;\n      }\n\n      & .ant-notification-notice-close {\n        top: 10px;\n      }\n    }\n\n    .reverse {\n      transform: rotate(180deg);\n    }\n\n    .button-unstyled {\n      background: transparent;\n      border: none;\n      cursor: pointer;\n\n      &.full-button {\n        display: block;\n        width: 100%;\n      }\n    }\n\n    /* FUNDACHART */\n    .fundachart-custom-tooltip {\n      height: 16px;\n      border: 1px solid #dadada;\n      position: absolute;\n      font-size: 11px;\n      display: flex;\n      align-items: center;\n      padding: 1px 5px 0 5px;\n      background-color: #FFF;\n    }\n\n    .fundachart-custom-tooltip:before {\n      content: ' ';\n      right: 100%;\n      top: 50%;\n      height: 0;\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border: solid transparent;\n      border-color: rgba(218, 218, 218, 0);\n      border-right-color: #dadada;\n      border-width: 9px;\n      margin-top: -9px;\n    }\n\n    .fundachart-custom-tooltip:after {\n      content: ' ';\n      right: 100%;\n      top: 50%;\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border: solid transparent;\n      border-color: rgba(255, 255, 255, 0);\n      border-right-color: #fff;\n      border-width: 8px;\n      margin-top: -8px;\n    }\n\n    .orderbook-text-cell {\n      color: #333333;\n      font-family: ProximaNovaRg;\n      font-size: 12px;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 16px;\n      text-align: right;\n      padding: 8px 0px;\n\n      &.up {\n        color: #00ab6b;\n      }\n\n      &.down {\n        color: #ee4a49;\n      }\n\n      &.notchange {\n        color: #979134;\n      }\n\n      &.frequency {\n        color: #8277F8;\n      }\n\n      &.lot {\n        font-size: 11px;\n      }\n\n      &.title {\n        font-family: ProximaNovaBd;\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        line-height: 16px;\n        padding: 8px 0px;\n      }\n    }\n\n    .orderbook-text-summary {\n      color: #333333;\n      font-family: ProximaNovaBd;\n      font-size: 12px;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      -webkit-font-smoothing: antialiased;\n      font-smoothing: antialiased;\n      line-height: 16px;\n      text-align: center;\n      padding: 8px 0px;\n\n      &.center {\n        text-align: center;\n      }\n\n      &.lot {\n        font-size: 11px;\n      }\n    }\n\n    .orderbook-que-bid,\n    .orderbook-que-off {\n      position: relative;\n    }\n\n    .table-live-price {\n      font-size: 12px;\n      font-family: ProximaNovaRg;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 16px;\n      margin: 12px 8px;\n      table-layout: fixed;\n      width: calc(100% - calc(2 * 8px));\n\n      td {\n        padding: 4px 0px;\n        text-align: right;\n        white-space: nowrap;\n        color: #333333;\n\n        &.up {\n          color: #00ab6b;\n        }\n  \n        &.down {\n          color: #ee4a49;\n        }\n  \n        &.notchange {\n          color: #979134;\n        }\n      }\n\n      td:first-child {\n        padding-left: 0px;\n        text-align: left;\n      }\n\n      td:nth-child(3) {\n        text-align: left;\n      }\n\n      td:nth-child(5) {\n        text-align: left;\n      }\n\n      td:last-child {\n        padding-right: 0px;\n      }\n\n      tr:first-child {\n        td {\n          padding-top: 0px;\n        }\n      }\n\n      tr:last-child {\n        td {\n          padding-bottom: 0px;\n        }\n      }\n\n      td > div.item-clickable {\n        margin-right: -4px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n\n        :hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .orderbook-last-price {\n      font-size: 14px;\n      font-family: ProximaNovaRg;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 19px;\n\n      &.up {\n        color: #00ab6b;\n      }\n\n      &.down {\n        color: #ee4a49;\n      }\n\n      &.notchange {\n        color: #979134;\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    .intercom-unread-count {\n      backface-visibility: hidden;\n      background: #fc576b;\n      border-radius: 10px;\n      box-shadow: none;\n      box-sizing: border-box;\n      color: #fff;\n      font-size: 12px;\n      height: 20px;\n      line-height: 20px;\n      min-width: 20px;\n      opacity: 0;\n      padding: 0 4px;\n      position: absolute;\n      left: -5px;\n      text-align: center;\n      top: 5px;\n      transform: scale(0.5);\n      transform-origin: center;\n      transition: opacity 0.15s ease, transform 0.15s ease;\n      font-family: sans-serif;\n\n      @media screen and (max-width: 720px) {\n          left: 3px;\n      }\n      \n      &.active {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n\n    .price-cell {\n      width: max-content;\n      \n      &.min {\n        min-width: 135px;\n      }\n\n      &.mid {\n        min-width: 156px;\n      }\n\n      &.full {\n        min-width: max-content;\n      }\n    }\n\n    /* Modal Multi Portfolio */\n    .modal-multi-porto {\n      max-width: 410px;\n\n      &.withdraw {\n        max-width: 450px;\n      }\n    }\n\n    .modal-multi-porto.no-padding .ant-modal-body {\n      padding: 0;\n    }\n\n    .modal-multi-porto .ant-modal-body > h4 {\n      text-align: left;\n      padding-left: 20px;\n      font-size: 16px;\n    }\n\n    .modal-multi-porto .ant-btn-primary[disabled] {\n      background-color: #cceee1 !important;\n      color: #ffffff !important;\n      border: none;\n\n      &:hover > p {\n        color: #ffffff;\n      }\n    }\n\n    /* Override Antd Select Modal Multi Porto */\n    .modal-multi-porto-open {\n      .ant-select-dropdown {\n        padding: 0;\n\n        .ant-select-item-option {\n          min-height: 50px;\n          padding: 0 12px;\n        }\n\n        .ant-select-item-option:not(:last-child) {\n          // border-bottom: 1px solid red;\n        }\n\n        .ant-select-item-option:hover {\n          background-color: #F7F7F7;\n        }\n      }\n\n      .ant-select-dropdown div[aria-selected='true'] {\n        img.transfer-check-icon {\n          display: block;\n        }\n\n        .option-text span.main-text {\n          font-weight: 400 !important;\n          font-family: ProximaNovaRg !important;\n        }\n      }\n\n      .ant-select-item-option {\n        div.option-text .main-porto {\n          display: flex;\n        }\n      }\n\n      .ant-select-item-option-content {\n        border-top: 1px solid #EDEDED;\n      }\n\n      .ant-select-item-option:first-child .ant-select-item-option-content {\n        border-top: none;\n      }\n\n      .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n        background-color: #ffffff;\n      }\n\n      .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n        background-color: #ffffff;\n        cursor: default;\n      }\n\n      .ant-select-disabled .ant-select-arrow {\n        display: none;\n      }\n    }\n\n    .modal-multi-porto.error {\n      .ant-modal-content {\n        border-radius: 10px;\n      }\n\n      .ant-modal-close-x {\n        margin-top: 0;\n      }\n    }\n    /* End Modal Multi Portfolio */\n\n    // Start Datepicker \n    .range-datepicker {\n      .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n        background: transparent !important;\n        border-radius: 100% !important;\n        color: rgba(0, 0, 0, 0.85) !important;\n      }\n\n      .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):not(.ant-picker-cell-range-start) .ant-picker-cell-inner,\n      .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner\n      {\n       background: transparent !important;\n        border-radius: 100% !important;\n        color: #ffffff !important;\n        border: 1px solid #00ab6b;\n        background: #00ab6b !important;\n      }\n\n      .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before {\n        left: 4px;\n        border-top-left-radius: 50%;\n        border-bottom-left-radius: 50%;\n      }\n\n      .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {\n       right: 4px;\n        border-top-right-radius: 50%;\n        border-bottom-right-radius: 50%;\n      }\n      .ant-picker-range-hover-start {\n        background: pink !important;\n        display: none !important;\n\n        div {\n          display: none !important;\n        }\n      }\n      \n      .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,\n      .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before,\n      .ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover::before,\n      .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before {\n        background: #d3ebde !important;\n      }\n    }\n\n\n    /* Modal Auto Order */\n    .modal-tnc-auto-order {\n      width: 520px !important;\n\n      .ant-btn-primary[disabled] {\n        background-color: #cceee1 !important;\n        color: #ffffff !important;\n        border: none;\n\n        &:hover > p {\n          color: #ffffff;\n        }\n      }\n\n      .ant-modal-content {\n        border-radius: 10px !important;\n      }\n\n      .ant-modal-body h4 {\n        font-size: 16px;\n        text-align: left;\n        padding-left: 20px;\n      }\n    }\n    /* End Modal Auto Order */\n\n    .hide-today-btn .ant-picker-footer {\n      display: none !important;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var overideAntdCSS = (0,styled_components_browser_esm/* css */.iv)(GlobalStyles_templateObject(), color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light, color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, "".concat(color/* default.downgray */.Z.downgray).concat((0,hexOpacity/* default */.Z)(35)), color/* default.black */.Z.black + (0,hexOpacity/* default */.Z)(60), color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro);
var variables = (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject2(), overideAntdCSS, variables, color/* default.gainsboro */.Z.gainsboro, color/* default.aliceBlue */.Z.aliceBlue, color/* default.dimgray */.Z.dimgray, color/* default.dimgray */.Z.dimgray, color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro, color/* default.black */.Z.black, color/* default.alertRed */.Z.alertRed, color/* default.black */.Z.black, color/* default.alertOrange */.Z.alertOrange, color/* default.black */.Z.black, color/* default.alertBlue */.Z.alertBlue, color/* default.black */.Z.black, color/* default.primary */.Z.primary, color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, GlobalStyles_alert/* default */.Z, tooltip, layout);
/* harmony default export */ var global_GlobalStyles = (GlobalStyles);

;// CONCATENATED MODULE: ./src/global/Scripts/TikTokPixel.js
/* eslint-disable react/no-danger */ 

var tiktokKey = "C5P9ESLODNNK397VS21G";
var TikTokPixel = function() {
    if (!tiktokKey) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: '\n            !function (w, d, t) {\n              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};\n            \n              ttq.load(\''.concat(tiktokKey, "');\n              ttq.page();\n            }(window, document, 'ttq');\n          ")
            }
        })
    });
};
/* harmony default export */ var Scripts_TikTokPixel = (TikTokPixel);

// EXTERNAL MODULE: ./src/global/SupportButton/index.tsx
var SupportButton = __webpack_require__(84468);
// EXTERNAL MODULE: ./src/global/Datafeed/index.tsx + 1 modules
var Datafeed = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/websocket_pb.js + 3 modules
var websocket_pb = __webpack_require__(71955);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.tsx
var securities_store = __webpack_require__(28840);
// EXTERNAL MODULE: ./src/global/Securities/websocket/SecuritiesContext.tsx
var SecuritiesContext = __webpack_require__(46895);
// EXTERNAL MODULE: ./src/global/Securities/websocket/constants.ts
var websocket_constants = __webpack_require__(93313);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/hooks/useUnauthorized.ts



function useUnauthorized(handleLogoutSecurities) {
    var checkUnauthorized = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(URL, token) {
            var httpsUrl, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        httpsUrl = URL.replace("wss://", "https://");
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return fetch(httpsUrl, {
                            method: "GET",
                            headers: {
                                Authorization: "Bearer ".concat(token)
                            }
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 10;
                            break;
                        }
                        if (!(response.status === websocket_constants/* ERROR_CODE.UNAUTHORIZED */.Bq.UNAUTHORIZED)) {
                            _ctx.next = 9;
                            break;
                        }
                        handleLogoutSecurities === null || handleLogoutSecurities === void 0 ? void 0 : handleLogoutSecurities();
                        return _ctx.abrupt("return", true);
                    case 9:
                        throw new Error(response.statusText);
                    case 10:
                        return _ctx.abrupt("return", false);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function checkUnauthorized(URL, token) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        checkUnauthorized: checkUnauthorized
    };
};

// EXTERNAL MODULE: ./src/global/Securities/websocket/utils.ts
var utils = __webpack_require__(46238);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/SecuritiesProvider.tsx
/* eslint-disable @typescript-eslint/no-use-before-define */ 













var WS_URL = "wss://ws-gen.stockbit.com/v1";
var SecuritiesProvider = function(props) {
    var ref;
    var children = props.children, isLoggedIn = props.isLoggedIn, _heartbeatInterval = props.heartbeatInterval, heartbeatInterval = _heartbeatInterval === void 0 ? websocket_constants/* HEARTBEAT_INTERVAL */.al : _heartbeatInterval, handleLogoutSecurities = props.handleLogoutSecurities;
    var socketRef = (0,react.useRef)();
    var lastPing = (0,react.useRef)(Date.now());
    var lastPong = (0,react.useRef)(Date.now());
    var actionsRef = (0,react.useRef)({});
    var isLoggedInRef = (0,react.useRef)(false);
    var wsIsConnectingRef = (0,react.useRef)(false);
    var reconnectCounterRef = (0,react.useRef)(1);
    var unauthorizedCounterRef = (0,react.useRef)(1);
    var reconnectTimeoutRef = (0,react.useRef)();
    var pingTimeoutRef = (0,react.useRef)();
    var healthCheckInterval = (0,react.useRef)();
    var ref1 = (0,react.useState)(), authToken = ref1[0], setAuthToken = ref1[1];
    var ref2 = (0,react.useState)(websocket_constants/* ReadyState.UNINSTANTIATED */.kQ.UNINSTANTIATED), readyState = ref2[0], setReadyState = ref2[1];
    var ref3 = (0,react.useState)(websocket_constants/* NetworkStatus.ONLINE */.Ie.ONLINE), networkStatus = ref3[0], setNetworkStatus = ref3[1];
    var ref4 = (0,securities_store/* useSecuritiesStore */.$A)(function(state) {
        return {
            channel: state.channel,
            isReconnectionFailed: state.isReconnectionFailed,
            setChannel: state.setChannel,
            resetChannel: state.resetChannel,
            setIsReconnectionFailed: state.setIsReconnectionFailed,
            setIsSocketOnline: state.setIsSocketOnline
        };
    }), channel = ref4.channel, isReconnectionFailed = ref4.isReconnectionFailed, setChannel = ref4.setChannel, resetChannel = ref4.resetChannel, setIsReconnectionFailed = ref4.setIsReconnectionFailed, setIsSocketOnline = ref4.setIsSocketOnline;
    var checkUnauthorized = useUnauthorized(handleLogoutSecurities).checkUnauthorized;
    var setCookie = (0,react.useCallback)(function(value) {
        if ((0,app/* isClient */.C5)()) {
            document.cookie = (0,utils/* generateWSCookie */.y_)(value);
        }
    }, []);
    var setAction = function(channelKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            draft[channelKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (draft === null || draft === void 0 ? void 0 : draft[channelKey]) {
                delete draft[channelKey];
            }
        });
    };
    var isWebsocketNotReady = (0,react.useCallback)(function() {
        var socket = socketRef.current;
        // If no socket instance or WebSocket isn't open or still connecting
        return !socket || socket.readyState !== WebSocket.OPEN;
    }, [
        (ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState
    ]);
    var getSecuritiesAccessToken = (0,react.useCallback)(function() {
        if ((0,app/* isClient */.C5)()) {
            var securitiesToken = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken();
            return securitiesToken.securitiesAccessToken;
        }
        return undefined;
    }, []);
    var sendPingHeartbeat = (0,react.useCallback)(function() {
        if (isWebsocketNotReady()) return;
        var pingRequest = (0,utils/* createPingPayload */.c$)();
        var bufferPing = new websocket_pb/* WebsocketRequest */.vC({
            requests: [
                pingRequest
            ]
        }).toBinary();
        socketRef.current.send(bufferPing);
        lastPing.current = Date.now();
    }, []);
    var combinedChannel = (0,react.useMemo)(function() {
        var resultArray = Object.values(channel);
        return resultArray;
    }, [
        channel
    ]);
    var sendMessageChannel = (0,react.useCallback)(function(channelRequests) {
        if (isWebsocketNotReady() || channelRequests.length === 0) {
            return;
        }
        var buffer = new websocket_pb/* WebsocketRequest */.vC({
            requests: channelRequests
        }).toBinary();
        socketRef.current.send(buffer);
        // remove channel that has been unsubscribed
        var isUnsubscribed = channelRequests.some(function(channelRequest) {
            var ref;
            return (channelRequest === null || channelRequest === void 0 ? void 0 : (ref = channelRequest.action) === null || ref === void 0 ? void 0 : ref.case) === "unsubscribe";
        });
        if (isUnsubscribed) {
            resetChannel();
        }
    }, []);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var handleMessage = (0,react.useCallback)(function(message) {
        var dataRaw = websocket_pb/* WebsocketResponse.fromBinary */.XC.fromBinary(new Uint8Array(message.data));
        var response = dataRaw.response;
        var messageCase = response.case, value = response.value;
        if (messageCase === "ping") {
            lastPong.current = Date.now();
        }
        var channelAction = actionsRef.current[messageCase];
        if (channelAction) {
            channelAction(value);
        }
    }, []);
    var handleHeartbeatMessage = function() {
        pingTimeoutRef.current = setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatInterval);
    };
    var handleOpen = function() {
        if (!socketRef.current) return;
        setAction("ping", handleHeartbeatMessage);
        sendPingHeartbeat();
        setIsSocketOnline(true);
        setReadyState(websocket_constants/* ReadyState.OPEN */.kQ.OPEN);
        socketRef.current.addEventListener("message", handleMessage);
        // Reset all reconnection state
        reconnectCounterRef.current = 1;
        setIsReconnectionFailed(false);
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = undefined;
        }
    };
    var handleReconnectionFailed = (0,react.useCallback)(function() {
        if (networkStatus === websocket_constants/* NetworkStatus.OFFLINE */.Ie.OFFLINE || reconnectCounterRef.current > websocket_constants/* MAX_POLLING_ATTEMPTS */.LU) {
            return;
        }
        reconnectTimeoutRef.current = setTimeout(function() {
            restartSocket();
        }, websocket_constants/* RECONNECT_INTERVAL */.aG);
    }, [
        networkStatus
    ]);
    var handleClose = function() {
        setIsSocketOnline(false);
        setReadyState(websocket_constants/* ReadyState.CLOSED */.kQ.CLOSED);
        if (!isLoggedInRef.current) return;
        if (reconnectCounterRef.current <= websocket_constants/* MAX_RECONNECT_ATTEMPTS */.pm) {
            restartSocket();
            reconnectCounterRef.current += 1;
            return;
        }
        setIsReconnectionFailed(true);
        handleReconnectionFailed();
        reconnectCounterRef.current += 1;
    };
    var handleError = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var token, isUnauthorized;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSocketOnline(false);
                        setReadyState(websocket_constants/* ReadyState.CLOSED */.kQ.CLOSED);
                        token = getSecuritiesAccessToken();
                        isUnauthorized = false;
                        if (!(token && networkStatus === websocket_constants/* NetworkStatus.ONLINE */.Ie.ONLINE && unauthorizedCounterRef.current <= websocket_constants/* MAX_RECONNECT_ATTEMPTS */.pm)) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return checkUnauthorized(WS_URL, token);
                    case 7:
                        isUnauthorized = _ctx.sent;
                        unauthorizedCounterRef.current += 1;
                    case 9:
                        if (isUnauthorized) {
                            resetSocket();
                            resetState();
                            isLoggedInRef.current = false;
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleError() {
            return _ref.apply(this, arguments);
        };
    }();
    var initSocket = (0,react.useCallback)(function() {
        if (!isLoggedInRef.current || networkStatus === websocket_constants/* NetworkStatus.OFFLINE */.Ie.OFFLINE || readyState === websocket_constants/* ReadyState.OPEN */.kQ.OPEN || wsIsConnectingRef.current && isReconnectionFailed) {
            return;
        }
        setAuthToken(undefined);
        var key = getSecuritiesAccessToken();
        if (!key || !WS_URL) return;
        setAuthToken(key);
        setCookie(key);
        wsIsConnectingRef.current = true;
        socketRef.current = new WebSocket(WS_URL);
        socketRef.current.binaryType = "arraybuffer";
        // @ts-ignore
        window.securitiesSocket = socketRef.current;
        socketRef.current.addEventListener("open", handleOpen, {
            once: true
        });
        socketRef.current.addEventListener("close", handleClose, {
            once: true
        });
        socketRef.current.addEventListener("error", handleError, {
            once: true
        });
        setTimeout(function() {
            wsIsConnectingRef.current = false;
        }, websocket_constants/* UPTIME */.Dp);
    }, [
        networkStatus,
        readyState,
        wsIsConnectingRef.current,
        isReconnectionFailed,
        handleOpen,
        handleClose,
        handleError, 
    ]);
    var resetTimeout = (0,react.useCallback)(function() {
        if (pingTimeoutRef.current) {
            clearTimeout(pingTimeoutRef.current);
            pingTimeoutRef.current = undefined;
        }
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = undefined;
        }
        if (healthCheckInterval.current) {
            clearInterval(healthCheckInterval.current);
            healthCheckInterval.current = undefined;
        }
    }, [
        pingTimeoutRef,
        reconnectTimeoutRef,
        healthCheckInterval
    ]);
    var resetSocket = (0,react.useCallback)(function() {
        var ref;
        if (!socketRef.current) return;
        if (((ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState) === WebSocket.OPEN) {
            socketRef.current.close();
        }
        socketRef.current = undefined;
        setAuthToken(undefined);
        removeAction("ping");
        resetTimeout();
    }, [
        setAuthToken,
        removeAction,
        resetTimeout
    ]);
    var restartSocket = (0,react.useCallback)(function() {
        if (!isLoggedInRef.current) return;
        resetSocket();
        initSocket();
    }, [
        resetSocket,
        initSocket
    ]);
    var resetState = (0,react.useCallback)(function() {
        setIsReconnectionFailed(false);
        setAuthToken(undefined);
        setCookie(undefined);
        setReadyState(websocket_constants/* ReadyState.UNINSTANTIATED */.kQ.UNINSTANTIATED);
        if (isLoggedInRef.current) {
            resetChannel();
            isLoggedInRef.current = false;
        }
        socketRef.current = undefined;
        reconnectCounterRef.current = 1;
        unauthorizedCounterRef.current = 1;
        resetTimeout();
    }, [
        setIsReconnectionFailed,
        setAuthToken,
        setCookie,
        isLoggedInRef,
        reconnectCounterRef,
        unauthorizedCounterRef,
        resetTimeout, 
    ]);
    var handleSocket = (0,react.useCallback)(function(isLogin) {
        if (!socketRef.current && isLogin) {
            restartSocket();
        } else if (socketRef.current && !isLogin) {
            resetSocket();
        }
        if (!isLogin) {
            resetState();
        }
    }, [
        restartSocket,
        resetSocket,
        resetState
    ]);
    // Handle Send Channel
    (0,react.useEffect)(function() {
        if (authToken && combinedChannel) {
            handleSendChannel(combinedChannel);
        }
    }, [
        authToken,
        combinedChannel,
        handleSendChannel
    ]);
    // Handle Socket Connection
    (0,react.useEffect)(function() {
        isLoggedInRef.current = isLoggedIn;
        var timeout = setTimeout(function() {
            handleSocket(isLoggedIn);
        }, 300);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isLoggedIn,
        handleSocket
    ]);
    // Handle Online Offline Connection
    (0,react.useEffect)(function() {
        var handleOnline = function() {
            var ref;
            setNetworkStatus(websocket_constants/* NetworkStatus.ONLINE */.Ie.ONLINE);
            if (((ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState) === websocket_constants/* ReadyState.CLOSED */.kQ.CLOSED || readyState === websocket_constants/* ReadyState.CLOSED */.kQ.CLOSED) {
                restartSocket();
            }
        };
        var handleOffline = function() {
            var ref;
            setNetworkStatus(websocket_constants/* NetworkStatus.OFFLINE */.Ie.OFFLINE);
            if (((ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState) === websocket_constants/* ReadyState.OPEN */.kQ.OPEN) {
                resetSocket();
            }
        };
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        return function() {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);
    // Handle Reconnect Interval
    (0,react.useEffect)(function() {
        if (readyState !== websocket_constants/* ReadyState.OPEN */.kQ.OPEN) return undefined;
        healthCheckInterval.current = setInterval(function() {
            var intervalPingPong = lastPing.current - lastPong.current;
            // Check if connection is unhealthy
            if (networkStatus === websocket_constants/* NetworkStatus.ONLINE */.Ie.ONLINE && intervalPingPong > heartbeatInterval * websocket_constants/* HEARTBEAT_FACTOR */.Nl) {
                restartSocket();
            }
        }, heartbeatInterval / 2);
        return function() {
            clearInterval(healthCheckInterval.current);
        };
    }, [
        restartSocket
    ]);
    var contextValue = (0,react.useMemo)(function() {
        return {
            isAuthorized: !!authToken,
            token: authToken,
            socket: socketRef.current,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction
        };
    }, [
        authToken,
        socketRef,
        setChannel,
        setAction,
        removeAction
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecuritiesContext/* SecuritiesContext.Provider */.i.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ var websocket_SecuritiesProvider = (SecuritiesProvider);

// EXTERNAL MODULE: ./src/utils/clevertap.js
var utils_clevertap = __webpack_require__(48028);
;// CONCATENATED MODULE: ./src/hooks/useClevertap.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 




function useClevertap() {
    var clevertapRef = (0,react.useRef)();
    var initClevertap = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var clevertap;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return __webpack_require__.e(/* import() */ 45707).then(__webpack_require__.t.bind(__webpack_require__, 88739, 23));
                case 2:
                    clevertap = _ctx.sent.default;
                    clevertap.privacy.push({
                        optOut: false
                    });
                    clevertap.privacy.push({
                        useIP: false
                    });
                    clevertap.init(app/* CLEVERTAP_ID */.d7, "sg1");
                    clevertap.setLogLevel(3);
                    window.clevertap = clevertap;
                    (0,utils_clevertap/* clevertapInitProfileQueue */.QU)();
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    (0,react.useEffect)(function() {
        if (!clevertapRef.current) {
            initClevertap();
        }
    }, [
        clevertapRef.current,
        initClevertap
    ]);
    return null;
}
/* harmony default export */ var hooks_useClevertap = (useClevertap);

// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/global/WebSocketV2/index.ts
var WebSocketV2 = __webpack_require__(36784);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
;// CONCATENATED MODULE: ./src/hooks/useWebSocketSocialV2.ts





function useWebSocketSocialV2(param) {
    var isLoggedIn = param.isLoggedIn;
    var ref = (0,react.useState)(), webSocketSocialV2 = ref[0], setWebSocketSocialV2Connection = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var createSocialSocket = function() {
        return (0,WebSocketV2_slice/* getWskey */.fh)().then(function(wskey) {
            if (wskey !== null) {
                setWebSocketSocialV2Connection((0,WebSocketV2/* initWebsocketSocialV2 */.JC)(constant/* socketV2Key.social */.Iv.social, wskey));
            }
        });
    };
    (0,react.useEffect)(function() {
        if (!isLoggedIn) return;
        if (!webSocketSocialV2) {
            createSocialSocket();
        }
        dispatch(WebSocketV2_slice/* effects.initWebsocketSocialV2 */.Sz.initWebsocketSocialV2({
            webSocketSocialV2: webSocketSocialV2,
            createSocialSocket: createSocialSocket
        }));
    }, [
        webSocketSocialV2,
        isLoggedIn
    ]);
    return webSocketSocialV2;
}
/* harmony default export */ var hooks_useWebSocketSocialV2 = (useWebSocketSocialV2);

;// CONCATENATED MODULE: ./src/global/WebSocket/index.ts
var SOCKET_URL = "https://ws3.stockbit.com/";
function initPrimus() {
    var server = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SOCKET_URL;
    // @ts-ignore
    if ( false || typeof window.Primus === "undefined") {
        return null;
    }
    // @ts-ignore
    var primus = window.Primus(server, {
        strategy: false
    });
    // @ts-ignore
    window.primus = primus;
    return primus;
}
/* harmony default export */ var global_WebSocket = (initPrimus);

;// CONCATENATED MODULE: ./src/hooks/useWebSocket.ts


// WebSocket



/**
 * @summary open websocket connection
 * @param {Object} primus - primus object
 * @returns {[*, () => void]}
 */ function useWebSocket(scriptLoaded) {
    var ref = (0,react.useState)(null), ws = ref[0], setWs = ref[1];
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var dispatch = (0,es/* useDispatch */.I0)();
    var clearPriceAlert = function() {
        dispatch(WebSocket_slice/* default.actions.clearAlert */.ZP.actions.clearAlert());
        localStorage.removeItem("price-alert");
    };
    (0,react.useEffect)(function() {
        if (!scriptLoaded) {
            return;
        }
        if (isLoggedIn) {
            var primus = global_WebSocket();
            setWs(primus);
            // @ts-ignore
            dispatch(WebSocket_slice/* effects.initWebsocket */.Sz.initWebsocket(primus));
            // @ts-ignore
            dispatch(WebSocket_slice/* effects.initListenData */.Sz.initListenData(primus));
        } else {
            clearPriceAlert();
            ws === null || ws === void 0 ? void 0 : ws.end();
        }
    }, [
        isLoggedIn,
        scriptLoaded
    ]);
    return ws;
}
/* harmony default export */ var hooks_useWebSocket = (useWebSocket);

;// CONCATENATED MODULE: ./src/global/Scripts/primus.tsx





var Primus = function() {
    var ref = (0,react.useState)(false), scriptLoaded = ref[0], setScriptLoaded = ref[1];
    hooks_useWebSocket(scriptLoaded);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        src: "".concat(app/* assetPrefix */.Vc, "/js/primus.min.js"),
        async: true,
        onLoad: function() {
            return setScriptLoaded(true);
        }
    });
};
/* harmony default export */ var primus = (Primus);

;// CONCATENATED MODULE: ./src/global/Scripts/firebase.tsx


var Firebase = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                src: "https://www.gstatic.com/firebasejs/7.6.2/firebase-app.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                src: "https://www.gstatic.com/firebasejs/7.6.2/firebase-analytics.js"
            })
        ]
    });
};
/* harmony default export */ var firebase = (Firebase);

// EXTERNAL MODULE: ./node_modules/crisp-sdk-web/dist/crisp.esm.js
var crisp_esm = __webpack_require__(36661);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
// EXTERNAL MODULE: ./src/utils/general.js
var utils_general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/hooks/useCrisp.ts











function useCrisp() {
    var ref;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* isLoggedInSelector */.dd);
    var dataProfile = (0,es/* useSelector */.v9)(profile/* profileSelector */.Rd);
    // @ts-ignore
    var supportId = dataProfile === null || dataProfile === void 0 ? void 0 : (ref = dataProfile.support) === null || ref === void 0 ? void 0 : ref.id;
    (0,react.useEffect)(function() {
        crisp_esm/* Crisp.configure */.fv.configure(app/* CRISP_ID */.t0, {
            safeMode: true,
            clientUrl: "".concat(app/* assetPrefix */.Vc, "/js/crisp-client.js")
        });
        var crispData = localStorage.getItem("crisp");
        if (crispData) {
            var crispDecoded = (0,utils_general/* decodeBase64ToJS */.OB)(crispData);
            // @ts-ignore
            if (crispDecoded === null || crispDecoded === void 0 ? void 0 : crispDecoded.id) {
                // @ts-ignore
                crisp_esm/* Crisp.setTokenId */.fv.setTokenId(crispDecoded.id);
            }
        }
        // configuration on crisp load
        if (isLoggedIn) {
            (0,crisp/* onLoaded */.l4)();
        }
        // configuration on open
        (0,crisp/* onOpen */.zp)();
        // configuration on receive message
        (0,crisp/* onReceiveMessage */.Dj)();
    }, []);
    (0,react.useEffect)(function() {
        try {
            if ((0,app/* isClient */.C5)() && isLoggedIn) {
                var crispData = localStorage.getItem("crisp");
                // @ts-ignore
                var ref = auth/* default.getUserAccess */.Z.getUserAccess(), email = ref.email, avatar = ref.avatar, username = ref.username;
                if (supportId) {
                    crisp_esm/* Crisp.setTokenId */.fv.setTokenId(supportId);
                }
                var data = {
                    email: email,
                    avatar: avatar,
                    username: username
                };
                if (crispData) {
                    var crispDecoded = (0,utils_general/* decodeBase64ToJS */.OB)(crispData);
                    // @ts-ignore
                    var phone = (crispDecoded === null || crispDecoded === void 0 ? void 0 : crispDecoded.phone) || (dataProfile === null || dataProfile === void 0 ? void 0 : dataProfile.phone);
                    if (phone) {
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            phone: phone
                        });
                    }
                }
                (0,crisp/* setNewSession */.kG)(data);
                localStorage.removeItem("crisp_visitor");
            }
        } catch (err) {
            ;
        }
    }, [
        isLoggedIn,
        supportId
    ]);
}
/* harmony default export */ var hooks_useCrisp = (useCrisp);

;// CONCATENATED MODULE: ./src/typings/platform.ts
var Platform;
(function(Platform) {
    Platform["Unspecified"] = "unspecified";
    Platform["Web"] = "web";
    Platform["Desktop"] = "desktop";
})(Platform || (Platform = {}));

;// CONCATENATED MODULE: ./src/hooks/useSharedWindowData.ts



/** Shares non-confidential data to the window object for Nx module federation */ var useSharedWindowData = function() {
    (0,react.useEffect)(function() {
        window.webSharedData = {
            projectFolder: app/* PROJECT_FOLDER */.sP,
            platform: Platform.Web
        };
    }, []);
};
/* harmony default export */ var hooks_useSharedWindowData = (useSharedWindowData);

// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var OrderTable_store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/global/MainApp/index.tsx
/* eslint-disable wrap-iife */ 


/* eslint-disable no-undef */ 



// store




// configs

// styles

// scripts

// components



// hooks
















var MainApp_queryClient = new queryClient/* QueryClient */.S({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});
function MainApp(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var routerPath = router.asPath;
    var dispatch = (0,es/* useDispatch */.I0)();
    hooks_useSharedWindowData(); // Used for Nx module federation
    hooks_useCrisp();
    hooks_useClevertap();
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* isLoggedInSelector */.dd);
    var setFliptUserId = (0,useFliptStore/* default */.Z)(function(s) {
        return s.setUserId;
    });
    var au = auth/* default.getUserAccess */.Z.getUserAccess();
    var tradingType = (0,useTradingAccount/* default */.Z)().tradingType;
    hooks_useWebSocketSocialV2({
        isLoggedIn: isLoggedIn
    });
    var resetUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.resetUIValue;
    });
    var isSecuritiesStaticPage = router.asPath.includes("/securities/static");
    var hideSupportButton = isSecuritiesStaticPage;
    var isFundachartPage = false;
    var renderPrimusScript = !isFundachartPage;
    var isScriptShouldShow = [
        isFundachartPage
    ].every(function(item) {
        return !item;
    });
    // Reset minimized header when route changes
    (0,react.useEffect)(function() {
        // @ts-ignore
        dispatch(MainLayout_slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
    }, [
        routerPath
    ]);
    (0,react.useEffect)(function() {
        (0,logger/* sentrySetUser */.Kp)(isLoggedIn);
    }, [
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        setFliptUserId(au === null || au === void 0 ? void 0 : au.id);
    }, [
        au === null || au === void 0 ? void 0 : au.id
    ]);
    var handleLogoutSecurities = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isSecuritiesPage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        isSecuritiesPage = /securities\/.+/i.test(router.asPath);
                        if (!isSecuritiesPage) {
                            _ctx.next = 8;
                            break;
                        }
                        OrderTable_store/* default.getState */.Z.getState().resetOrderTableStore();
                        resetUIValue(typings_auth/* LoginType.Securities */.B.Securities);
                        _ctx.next = 8;
                        return router.push("/stream");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogoutSecurities() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: isScriptShouldShow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(google, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Scripts_TikTokPixel, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !hideSupportButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportButton/* default */.Z, {
                    isLoggedIn: isLoggedIn
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: renderPrimusScript,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primus, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isScriptShouldShow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(firebase, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
                client: MainApp_queryClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Datafeed/* DatafeedProvider */.l, {
                    isLoggedIn: isLoggedIn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(websocket_SecuritiesProvider, {
                        isLoggedIn: isLoggedIn && !!tradingType,
                        handleLogoutSecurities: handleLogoutSecurities,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm/* ThemeProvider */.f6, {
                            theme: theme/* default */.ZP,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_GlobalStyles, {}),
                                children
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var global_MainApp = (wrapper.withRedux(MainApp));


/***/ }),

/***/ 13180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O$": function() { return /* binding */ accDistColor; },
/* harmony export */   "RB": function() { return /* binding */ transactionTypeList; },
/* harmony export */   "XF": function() { return /* binding */ defaultBrokerData; },
/* harmony export */   "Xt": function() { return /* binding */ defaultTransactionData; },
/* harmony export */   "Zm": function() { return /* binding */ BrokerSortColumnPairs; },
/* harmony export */   "ez": function() { return /* binding */ marketBoardList; },
/* harmony export */   "k$": function() { return /* binding */ TRANSACTION_TYPE; },
/* harmony export */   "lA": function() { return /* binding */ BANDAR_DETECTOR_MENU_KEY; },
/* harmony export */   "l_": function() { return /* binding */ defaultSummaryData; },
/* harmony export */   "nJ": function() { return /* binding */ brokerType; },
/* harmony export */   "nN": function() { return /* binding */ defaultBrokerSummary; },
/* harmony export */   "qi": function() { return /* binding */ TIME_FILTER; },
/* harmony export */   "x$": function() { return /* binding */ investorTypeList; },
/* harmony export */   "yN": function() { return /* binding */ MARKET_TYPES; }
/* harmony export */ });
/* unused harmony exports defaultTransactionListData, MARKET_BOARD, INVESTOR_TYPE, SORT, emptyData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84607);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63914);




var cellBgType = {
    green: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lightGreen */ .Z.lightGreen,
    red: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].monaLisa */ .Z.monaLisa,
    lightGreen: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lightGreen */ .Z.lightGreen + (0,_deprecated_ui_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(50),
    lightRed: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].monaLisa */ .Z.monaLisa + (0,_deprecated_ui_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(50),
    grey: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro
};
var accDistColor = {
    Neutral: cellBgType.grey,
    Dist: cellBgType.lightRed,
    "Small Dist": cellBgType.red,
    "Normal Dist": cellBgType.red,
    "Big Dist": cellBgType.red,
    Acc: cellBgType.lightGreen,
    "Small Acc": cellBgType.green,
    "Normal Acc": cellBgType.green,
    "Big Acc": cellBgType.green
};
var brokerType = {
    Lokal: "local",
    Pemerintah: "bumn",
    Asing: "foreign",
    BROKER_GROUP_LOCAL: "local",
    BROKER_GROUP_GOVERNMENT: "bumn",
    BROKER_GROUP_FOREIGN: "foreign"
};
var defaultTransactionData = [
    {
        key: "top1",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Top 1"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    },
    {
        key: "top3",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Top 3"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    },
    {
        key: "top5",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Top 5"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    },
    {
        key: "average",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Average"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    }, 
];
var defaultBrokerData = [
    {
        key: "broker",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Broker"
        }),
        buyer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        seller: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        hash: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    }, 
];
var defaultSummaryData = [
    {
        key: "summary_1",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: "Net Volume"
        }),
        value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        empty: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {})
    },
    {
        key: "summary_2",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: "Net Value"
        }),
        value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        empty: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {})
    },
    {
        key: "summary_3",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: "Average (Rp)"
        }),
        value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        empty: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {})
    }, 
];
var defaultTransactionListData = [
    {
        by: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        bval: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        bavg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        sl: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        sval: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        savg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        })
    }, 
];
var BANDAR_DETECTOR_MENU_KEY = {
    BROKER_SUMMARY: "BROKER_SUMMARY",
    TOP_BROKER: "TOP_BROKER",
    TOP_STOCKS: "TOP_STOCKS",
    BROKER_ACTIVITY: "BROKER_ACTIVITY"
};
var TRANSACTION_TYPE = {
    UNSPECIFIED: "TRANSACTION_TYPE_UNSPECIFIED",
    NET: "TRANSACTION_TYPE_NET",
    GROSS: "TRANSACTION_TYPE_GROSS"
};
var MARKET_BOARD = {
    UNSPECIFIED: "MARKET_BOARD_UNSPECIFIED",
    ALL: "MARKET_BOARD_ALL",
    REGULER: "MARKET_BOARD_REGULER",
    TUNAI: "MARKET_BOARD_TUNAI",
    NEGO: "MARKET_BOARD_NEGO"
};
var INVESTOR_TYPE = {
    UNSPECIFIED: "INVESTOR_TYPE_UNSPECIFIED",
    ALL: "INVESTOR_TYPE_ALL",
    FOREIGN: "INVESTOR_TYPE_FOREIGN",
    DOMESTIC: "INVESTOR_TYPE_DOMESTIC"
};
var transactionTypeList = [
    {
        label: "Net",
        value: TRANSACTION_TYPE.NET
    },
    {
        label: "Gross",
        value: TRANSACTION_TYPE.GROSS
    }, 
];
var marketBoardList = [
    {
        label: "All Market",
        value: MARKET_BOARD.ALL
    },
    {
        label: "Regular",
        value: MARKET_BOARD.REGULER
    },
    {
        label: "Tunai",
        value: MARKET_BOARD.TUNAI
    },
    {
        label: "Nego",
        value: MARKET_BOARD.NEGO
    }, 
];
var investorTypeList = [
    {
        label: "All Investor",
        value: INVESTOR_TYPE.ALL
    },
    {
        label: "Domestic",
        value: INVESTOR_TYPE.DOMESTIC
    },
    {
        label: "Foreign",
        value: INVESTOR_TYPE.FOREIGN
    }, 
];
var TIME_FILTER = [
    {
        label: "Latest",
        value: "TB_PERIOD_LAST_1_DAY"
    },
    {
        label: "Previous Day",
        value: "TB_PERIOD_PREVIOUS_DAY"
    },
    {
        label: "Last 7 Days",
        value: "TB_PERIOD_LAST_7_DAYS"
    },
    {
        label: "Last 1 Month",
        value: "TB_PERIOD_LAST_1_MONTH"
    },
    {
        label: "Year to Date",
        value: "TB_PERIOD_YEAR_TO_DATE"
    },
    {
        label: "Last 1 Year",
        value: "TB_PERIOD_LAST_1_YEAR"
    },
    {
        label: "Custom",
        value: "Custom"
    }, 
];
var SORT = {
    asc: "ORDER_BY_ASC",
    desc: "ORDER_BY_DESC"
};
var emptyData = {
    buy_value: "",
    code: "",
    name: "",
    net_value: "",
    sell_value: "",
    total_frequency: "",
    total_value: "",
    total_volume: "",
    group: "BROKER_GROUP_UNSPECIFIED"
};
var MARKET_TYPES = [
    {
        label: "All Market",
        value: "MARKET_TYPE_ALL"
    },
    {
        label: "Regular",
        value: "MARKET_TYPE_REGULER"
    },
    {
        label: "Tunai",
        value: "MARKET_TYPE_TUNAI"
    },
    {
        label: "Nego",
        value: "MARKET_TYPE_NEGO"
    }, 
];
var defaultBrokerSummary = {
    brokers_buy: [
        {
            blot: "-",
            blotv: "-",
            bval: "-",
            bvalv: "-",
            netbs_broker_code: "-",
            netbs_buy_avg_price: "-",
            netbs_date: "-",
            netbs_stock_code: "-",
            type: "-"
        }, 
    ],
    brokers_sell: [
        {
            netbs_broker_code: "-",
            netbs_date: "-",
            netbs_sell_avg_price: "-",
            netbs_stock_code: "-",
            slot: "-",
            slotv: "-",
            sval: "-",
            svalv: "-",
            type: "-"
        }, 
    ]
};
var BrokerSortColumnPairs = {
    bval: "sval",
    blot: "slot",
    netbs_buy_avg_price: "netbs_sell_avg_price",
    sval: "bval",
    slot: "blot",
    netbs_sell_avg_price: "netbs_buy_avg_price"
};



/***/ }),

/***/ 46881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13180);
/* eslint-disable no-undef */ 







var defaultSummary = {
    brokers_buy: [],
    brokers_sell: [],
    symbol: ""
};
var defaultPagination = {
    page: 1,
    limit: 50,
    isScrollable: true
};
// Initial state
var initialState = {
    brokerSummary: {
        detector: {},
        summary: defaultSummary,
        from: "",
        to: ""
    },
    data: {
        detector: {},
        summary: defaultSummary,
        from: "",
        to: ""
    },
    brokerActivity: {
        summary: defaultSummary,
        from: "",
        to: "",
        activeBroker: "",
        brokerList: [],
        pagination: defaultPagination,
        transactionType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .transactionTypeList[0].value */ .RB[0].value,
        marketBoard: _constants__WEBPACK_IMPORTED_MODULE_2__/* .marketBoardList[1].value */ .ez[1].value,
        investorType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .investorTypeList[0].value */ .x$[0].value
    },
    topBrokers: {
        date: {
            from: "",
            to: "",
            idx: ""
        },
        list: []
    },
    isLoading: true,
    error: null,
    message: "",
    // TODO: Remove this object when permanent solution applied to the pages
    brokerSummaryForm: {
        from: "",
        to: ""
    }
};
// Selector
var bandarDetectorState = function(state) {
    return state.mainLayout.bandarDetector;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(bandarDetectorState, function(state) {
    return {
        data: state.data,
        detector: state.data.detector,
        summary: state.data.summary,
        brokerSummary: state.brokerSummary,
        brokerActivity: state.brokerActivity,
        topBrokers: state.topBrokers.list,
        topBrokerDate: state.topBrokers.date,
        isLoading: state.isLoading,
        // TODO: Remove this line when permanent solution applied to the pages
        brokerSummaryForm: state.brokerSummaryForm
    };
});
// Action types
var CONTEXT = "@side-widget/bandarDetector";
var actionType = {
    GET_BANDAR_DETECTOR: "".concat(CONTEXT, "/GET_BANDAR_DETECTOR"),
    GET_BROKER_LIST: "".concat(CONTEXT, "/GET_BROKER_LIST"),
    GET_BROKER_ACTIVITY: "".concat(CONTEXT, "/GET_BROKER_ACTIVITY"),
    GET_BROKER_ACTIVITY_NEXT_PAGE: "".concat(CONTEXT, "/GET_BROKER_ACTIVITY_NEXT_PAGE"),
    GET_TOP_BROKER: "".concat(CONTEXT, "/GET_TOP_BROKER")
};
// Side effects
var effects = {
    getBandarDetector: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BANDAR_DETECTOR, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, params, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMarketDetector */ .Z.getMarketDetector(symbol, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get market detector failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getTopBroker: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_TOP_BROKER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTopBroker */ .Z.getTopBroker(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get top broker failed!");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBrokerList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BROKER_LIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getBrokerList */ .Z.getBrokerList(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get broker list failed!");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBrokerActivity: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BROKER_ACTIVITY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var brokerCode, params, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        brokerCode = param.brokerCode, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMarketDetectorActivity */ .Z.getMarketDetectorActivity(brokerCode, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get broker activity failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBrokerActivityNextPage: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BROKER_ACTIVITY_NEXT_PAGE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var brokerCode, params, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        brokerCode = param.brokerCode, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMarketDetectorActivity */ .Z.getMarketDetectorActivity(brokerCode, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get broker activity failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    setActiveBroker: function(state, action) {
        state.brokerActivity.activeBroker = action.payload;
        // reset pagination to default when active broker is changed
        if (state.brokerActivity.pagination.page !== 1) {
            state.brokerActivity.pagination = defaultPagination;
        }
    },
    setPagination: function(state) {
        var _summary = state.brokerActivity.summary, brokersBuy = _summary.brokers_buy, brokersSell = _summary.brokers_sell;
        var sizeData = Math.max(brokersBuy.length, brokersSell.length);
        var _pagination = state.brokerActivity.pagination, page = _pagination.page, isScrollable = _pagination.isScrollable;
        if (isScrollable && sizeData >= 50) {
            state.brokerActivity.pagination = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state.brokerActivity.pagination), {
                page: page + 1
            });
        }
    },
    resetPagination: function(state) {
        state.brokerActivity.pagination = defaultPagination;
    },
    // TODO: Remove this reducer when permanent solution applied to the pages
    setBrokerSummaryForm: function(state, action) {
        var _payload = action.payload, key = _payload.key, value = _payload.value;
        state.brokerSummaryForm[key] = value;
    },
    setTransactionType: function(state, action) {
        state.brokerActivity.transactionType = action.payload;
    },
    setMarketBoard: function(state, action) {
        state.brokerActivity.marketBoard = action.payload;
    },
    setInvestorType: function(state, action) {
        state.brokerActivity.investorType = action.payload;
    },
    resetState: function(state) {
        Object.assign(state, initialState);
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getBandarDetector.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getBandarDetector.fulfilled, function(state, action) {
        var _payload = action.payload, _data = _payload.data, data = _data === void 0 ? {} : _data, error = _payload.error, message = _payload.message;
        if (error) {
            state.error = error;
        }
        if (!data.bandar_detector || !data.broker_summary) {
            state.brokerSummary.detector = {};
            state.brokerSummary.summary = defaultSummary;
            state.brokerSummary.from = "";
            state.brokerSummary.to = "";
            state.error = null;
        }
        if (data.bandar_detector && data.broker_summary) {
            state.brokerSummary.detector = data.bandar_detector;
            state.brokerSummary.summary = data.broker_summary;
            state.brokerSummary.from = data.from;
            state.brokerSummary.to = data.to;
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBandarDetector.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    }).addCase(effects.getBrokerList.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) state.error = error;
        if (data) {
            state.brokerActivity.brokerList = data;
            if (!state.brokerActivity.activeBroker) {
                state.brokerActivity.activeBroker = data[0].code;
            }
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivity.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getBrokerActivity.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        var newSummary = data === null || data === void 0 ? void 0 : data.broker_summary;
        if (error) {
            state.error = error;
        }
        if (!newSummary) {
            state.brokerActivity.summary = defaultSummary;
            state.brokerActivity.from = "";
            state.brokerActivity.to = "";
        } else {
            state.brokerActivity.summary = newSummary;
            state.brokerActivity.from = data.from;
            state.brokerActivity.to = data.to;
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivity.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivityNextPage.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getBrokerActivityNextPage.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        var newSummary = data === null || data === void 0 ? void 0 : data.broker_summary;
        if (error) state.error = error;
        if (!newSummary) {
            state.brokerActivity.pagination = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state.brokerActivity.pagination), {
                isScrollable: false
            });
        } else {
            var sizeBrokersBuy = newSummary.brokers_buy.length;
            var sizeBrokersSell = newSummary.brokers_sell.length;
            if (sizeBrokersBuy || sizeBrokersSell) {
                state.brokerActivity.summary = {
                    brokers_buy: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.brokerActivity.summary.brokers_buy).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newSummary.brokers_buy)),
                    brokers_sell: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.brokerActivity.summary.brokers_sell).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newSummary.brokers_sell)),
                    symbol: ""
                };
            } else {
                state.brokerActivity.pagination.isScrollable = false;
            }
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivityNextPage.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    }).addCase(effects.getTopBroker.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getTopBroker.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.error = error;
        }
        if (!data) {
            state.topBrokers.list = [];
            state.topBrokers.date = {
                from: "",
                to: "",
                idx: ""
            };
            state.error = null;
        } else {
            state.topBrokers.list = data.list;
            state.topBrokers.date = data.date;
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getTopBroker.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    });
};
var bandarDetectorSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "bandarDetector",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (bandarDetectorSlice);


/***/ }),

/***/ 63914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ PeriodSelect; },
/* harmony export */   "$q": function() { return /* binding */ BandarSearchCompanyWrapper; },
/* harmony export */   "AB": function() { return /* binding */ ModalWrapper; },
/* harmony export */   "Bb": function() { return /* binding */ DatePickerWrapper; },
/* harmony export */   "Dr": function() { return /* binding */ TopBrokerContainer; },
/* harmony export */   "Ds": function() { return /* binding */ TableTransactionBroker; },
/* harmony export */   "Ec": function() { return /* binding */ MarketSelect; },
/* harmony export */   "FP": function() { return /* binding */ ModalPeriodSelect; },
/* harmony export */   "Fq": function() { return /* binding */ TableListTransaction; },
/* harmony export */   "Hu": function() { return /* binding */ BrokActivityText; },
/* harmony export */   "Ks": function() { return /* binding */ ModalTopBroker; },
/* harmony export */   "Mt": function() { return /* binding */ DatePicker; },
/* harmony export */   "Nr": function() { return /* binding */ CodeTag; },
/* harmony export */   "O9": function() { return /* binding */ ModalBrokerSummary; },
/* harmony export */   "Od": function() { return /* binding */ Skeleton; },
/* harmony export */   "QU": function() { return /* binding */ TableTopBroker; },
/* harmony export */   "Qr": function() { return /* binding */ DropdownOption; },
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "Wb": function() { return /* binding */ ButtonOpenModal; },
/* harmony export */   "Xr": function() { return /* binding */ BrokerListSelect; },
/* harmony export */   "Y9": function() { return /* binding */ TableBrokerAccDist; },
/* harmony export */   "Yt": function() { return /* binding */ StyledTabs; },
/* harmony export */   "Z_": function() { return /* binding */ DropdownWrapper; },
/* harmony export */   "_8": function() { return /* binding */ SearchWrapper; },
/* harmony export */   "_n": function() { return /* binding */ TableSortableHeader; },
/* harmony export */   "bL": function() { return /* binding */ SelectWrapper; },
/* harmony export */   "b_": function() { return /* binding */ PeriodSkeleton; },
/* harmony export */   "dk": function() { return /* binding */ BrokerActivityWrapper; },
/* harmony export */   "eI": function() { return /* binding */ SelectContainer; },
/* harmony export */   "el": function() { return /* binding */ WrapperTransactionList; },
/* harmony export */   "gM": function() { return /* binding */ HeaderContainer; },
/* harmony export */   "gp": function() { return /* binding */ TableBrokerWrapper; },
/* harmony export */   "ln": function() { return /* binding */ BrokerActivityTabelWrap; },
/* harmony export */   "r6": function() { return /* binding */ ModalTitle; },
/* harmony export */   "rL": function() { return /* binding */ WrapperMenu; },
/* harmony export */   "rS": function() { return /* binding */ BrokerSummaryOuterWrapper; },
/* harmony export */   "ry": function() { return /* binding */ TableBrokerSummary; },
/* harmony export */   "xu": function() { return /* binding */ Box; }
/* harmony export */ });
/* unused harmony export convertToPixel */
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_DatePicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70420);
/* harmony import */ var _deprecated_ui_common_Select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6305);
/* harmony import */ var _deprecated_ui_widget_Table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61166);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Popover__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70187);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76750);
/* harmony import */ var _deprecated_ui_company_Modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50550);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 40px;\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-family: 'ProximaNovaBd';\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    min-width: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  height: 32px;\n\n  :nth-child(1) {\n    border: none !important;\n  }\n\n  :nth-child(3) {\n    border: none !important;\n  }\n\n  :hover,\n  :focus {\n    :nth-child(1) {\n      border: none !important;\n    }\n\n    :nth-child(3) {\n      border: none !important;\n    }\n  }\n\n  input {\n    color: ",
        ";\n  }\n\n  input::placeholder {\n    color: ",
        ";\n  }\n\n  .ant-picker-content {\n    table-layout: auto;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: hidden;\n  height: 100%;\n\n  & > div::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  .top-stock-table {\n    width: ",
        ";\n  }\n\n  input {\n    font-family: 'ProximaNovaRg';\n  }\n\n  .bandar-detector-wrapper {\n    .ant-tabs-nav-list {\n      gap: 12px;\n      overflow: auto;\n      ",
        "\n\n      ::-webkit-scrollbar {\n        display: none;\n      }\n    }\n    .ant-tabs-tab {\n      padding: 0;\n      height: 48px;\n      &:first-of-type {\n        padding-left: 12px;\n      }\n\n      padding-right: 12px;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 11px;\n  margin-bottom: 6px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & {\n    min-height: 100%;\n  }\n\n  .ant-tabs-nav {\n    margin-bottom: 12px;\n\n    &::before {\n      border: none;\n    }\n  }\n\n  .ant-tabs-nav-wrap {\n    overflow: auto !important;\n    ::-webkit-scrollbar-thumb {\n      display: none;\n    }\n    ::-webkit-scrollbar {\n      display: none;\n    }\n    ::-webkit-scrollbar-track {\n      display: none;\n    }\n    .ant-tabs-nav-list {\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    background: transparent;\n\n    &::after {\n      background: #00ab6b;\n      content: ' ';\n      position: absolute;\n      left: 50%;\n      right: 0;\n      bottom: 5px;\n      height: 2px;\n      width: 40px;\n      transform: translateX(-50%);\n    }\n  }\n\n  .ant-tabs-tab {\n    font-size: 13px;\n    margin: 0;\n    padding: 14px 12px;\n    color: #858585;\n    &.ant-tabs-tab-active {\n      .ant-tabs-tab-btn {\n        text-shadow: none;\n        font-family: 'ProximaNovaBd';\n        font-weight: 700;\n      }\n    }\n\n    &:hover {\n      color: unset;\n    }\n  }\n\n  .ant-tabs-nav-operations {\n    display: none !important;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  border: 1px solid ",
        ";\n  border-radius: 2px 2px 0 0;\n\n  .ant-picker {\n    padding: 8px;\n  }\n  .ant-picker:last-child .ant-picker-input input {\n    text-align: right;\n  }\n  .ant-picker:last-child .ant-picker-input .ant-picker-suffix {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > :first-child {\n    width: 100%;\n\n    .ant-select-selector {\n      border-top: none;\n      border-bottom-right-radius: 0;\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n\n  > :nth-child(2) {\n    width: 100%;\n\n    .ant-select-selector {\n      border-left: none;\n      border-radius: 0;\n      border-right: none;\n      border-top: none;\n    }\n  }\n\n  > :last-child {\n    width: 80%;\n\n    .ant-select-selector {\n      border-top: none;\n      border-bottom-left-radius: 0;\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n\n  .ant-select-selector {\n    padding: 0 8px !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 12px;\n  min-height: 400px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 12px;\n  overflow-x: auto;\n\n  thead th {\n    background: transparent;\n    border-bottom: 1px solid ",
        " !important;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 400;\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-family: 'ProximaNovaBd';\n  display: inline-block;\n  width: 30px;\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: auto;\n  }\n  ",
        "::after {\n    content: ' -';\n    margin: 0 4px;\n    color: ",
        ";\n    font-family: 'ProximaNovaRg';\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-table-container {\n    table {\n      tr {\n        th {\n          background-color: transparent;\n          border-bottom: 1px solid ",
        ";\n\n          &.ant-table-cell-scrollbar {\n            display: none;\n          }\n\n          p {\n            font-size: 13px;\n          }\n        }\n\n        .ant-table-cell {\n          white-space: nowrap;\n        }\n\n        th:not(:first-child) p,\n        td:not(:first-child) p {\n          margin-left: 8px;\n        }\n\n        td.ant-table-column-sort {\n          background: #ffffff;\n\n          &:hover {\n            background: unset;\n          }\n        }\n      }\n    }\n\n    .ant-table-body {\n      &::-webkit-scrollbar {\n        height: 4px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: ",
        ";\n        border-radius: 2px;\n      }\n    }\n  }\n\n  .ant-table-ping-right:not(.ant-table-has-fix-right)\n    .ant-table-container::after {\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  .ant-table-container {\n    table {\n      tbody:before {\n        content: '@';\n        display: block;\n        line-height: 8px;\n        text-indent: -99999px;\n      }\n      tr {\n        th {\n          background-color: transparent;\n          border-bottom: 1px solid ",
        ";\n        }\n\n        th:nth-child(2) p,\n        td:nth-child(2) p,\n        th:nth-child(3) p,\n        td:nth-child(3) p,\n        th:nth-child(4) p,\n        td:nth-child(4) p {\n          text-align: right;\n          padding-right: 8px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  .ant-table-container {\n    table {\n      tr {\n        th:nth-child(2) p,\n        th:nth-child(3) p,\n        th:nth-child(4) p,\n        td:nth-child(2) p,\n        td:nth-child(3) p,\n        td:nth-child(4) p {\n          text-align: right;\n        }\n      }\n      tr td:nth-child(4) p {\n        padding-right: 8px;\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  padding: 0 12px;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 12px;\n\n  .ant-table-container {\n    padding: 0 12px;\n\n    table {\n      tr {\n        th {\n          background-color: transparent;\n          border-bottom: 1px solid ",
        ";\n        }\n\n        th:nth-child(2) p,\n        td:nth-child(2) p,\n        th:nth-child(3) p,\n        td:nth-child(3) p,\n        th:nth-child(4) p,\n        td:nth-child(4) p {\n          text-align: right;\n        }\n        th:not(:last-child) p,\n        td:not(:last-child) p {\n          padding-right: 8px;\n        }\n      }\n\n      tbody:before {\n        content: '@';\n        display: block;\n        line-height: 8px;\n        text-indent: -99999px;\n      }\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 12px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  position: absolute;\n  bottom: 13px;\n  right: 50px;\n  width: 32px;\n  height: 32px;\n  padding: 8px;\n  color: ",
        ";\n  font-weight: 700;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px;\n\n  .ant-modal {\n    padding: 25px;\n  }\n\n  .ant-modal-mask {\n    background: #00000080;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  top: 20px;\n  .ant-modal-header {\n    border-radius: 8px 8px 0 0;\n    margin-bottom: 16px;\n  }\n\n  .ant-modal-content {\n    border-radius: 8px;\n  }\n\n  .ant-modal-close-x {\n    width: 20px;\n    height: 20px;\n    line-height: unset;\n    margin: 10px 16px 11px 0;\n  }\n\n  .ant-modal-body {\n    padding: 0px 0px !important;\n    height: calc(100vh - 100px);\n    ::-webkit-scrollbar-thumb {\n      display: none;\n    }\n    ::-webkit-scrollbar-track {\n      display: none;\n    }\n\n    .web {\n      padding-left: 16px;\n    }\n\n    .top-stock-table {\n      width: unset;\n    }\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 25px 20px 15px 20px;\n\n  .top-broker-title {\n    font-family: 'ProximaNovaBd';\n    font-size: 18px;\n  }\n\n  .top-broker-subtitle {\n    font-size: 12px;\n    font-weight: 400;\n    color: #858585;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-table-container::after {\n    box-shadow: none !important;\n  }\n\n  .ant-table-container {\n    height: 50vh;\n  }\n  .ant-table-ping-left:not(.ant-table-has-fix-left)\n    .ant-table-container::before {\n    box-shadow: none;\n  }\n\n  .ant-table-container {\n    padding: ",
        ";\n\n    table {\n      tr {\n        th {\n          background-color: #ffffff;\n\n          p {\n            padding: 5px 0;\n            font-family: 'ProximaNovaBd';\n          }\n\n          &.ant-table-column-has-sorters {\n            &:hover {\n              background-color: #ffffff;\n            }\n\n            .ant-table-column-sorters {\n              padding: 0;\n\n              .ant-table-column-sorter {\n                display: none;\n              }\n            }\n          }\n\n          &.ant-table-column-sort {\n            .ant-table-column-sorters {\n              .ant-table-column-sorter {\n                margin-left: 4px;\n                display: inline-block;\n              }\n            }\n          }\n        }\n\n        td {\n          &.ant-table-column-sort {\n            background-color: #ffffff;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.scrollable {\n    max-height: calc(100vh - 185px);\n    overflow-y: auto;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 12px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  height: 47px;\n  background: linear-gradient(\n    270deg,\n    #ffffff 50%,\n    rgba(255, 255, 255, 0) 205.63%\n  );\n  justify-content: end;\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  align-items: center;\n  width: 72px;\n  z-index: 1;\n\n  .container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 8px;\n    &.end {\n      justify-content: flex-end;\n      padding-right: 16px;\n    }\n    &.center {\n      justify-content: center;\n    }\n    .rotate {\n      animation: ",
        " 1s linear infinite;\n      -webkit-animation: ",
        " 1s linear infinite;\n    }\n  }\n\n  button {\n    background-color: transparent;\n    border-width: 0;\n    font-family: inherit;\n    font-size: inherit;\n    font-style: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    padding: 0;\n  }\n  img {\n    cursor: pointer;\n    width: 16px;\n    height: 16px;\n  }\n\n  .ant-tabs-nav-list {\n    margin-right: 70px;\n    ",
        "\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #ededed;\n  -webkit-box-shadow: 0 1px 8px 1px rgb(0 0 0 / 6%);\n  box-shadow: 0 1px 8px 1px rgb(0 0 0 / 6%);\n  border-radius: 3px;\n  min-width: 160px;\n  padding: 8px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  text-decoration: none;\n  line-height: 18px;\n  padding: 8px;\n  margin: 0;\n  font-size: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n  font-size: 14px;\n  color: #333333;\n  cursor: pointer;\n  :hover {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 20px);\n  margin-bottom: 12px;\n  .ant-select-selector {\n    border-radius: 4px 0 0 4px !important;\n    border-right: none !important;\n  }\n\n  .ant-select-selector {\n    .ant-select-selection-item,\n    ant-select-selection-search {\n      color: ",
        ";\n      font-size: 13px;\n    }\n  }\n\n  .ant-select-arrow {\n    width: 16px;\n    height: 16px;\n    background: url('/icon/calendar-green.svg') no-repeat;\n    background-size: 13px 13px;\n    background-position: center;\n    top: calc(50% - 8px) !important;\n    margin-top: 0;\n\n    span {\n      display: none !important;\n    }\n  }\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-selector {\n    border-radius: 4px 0 0 4px !important;\n    border-right: none !important;\n  }\n\n  .ant-select-selector {\n    .ant-select-selection-item,\n    ant-select-selection-search {\n      color: ",
        ";\n      font-size: 12px;\n    }\n  }\n\n  .ant-select-arrow {\n    width: 16px;\n    height: 16px;\n    background: url('/icon/calendar-green.svg') no-repeat;\n    background-size: 13px 13px;\n    background-position: center;\n    top: calc(50% - 8px) !important;\n    margin-top: 0;\n\n    span {\n      display: none !important;\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-dropdown {\n    width: 128px !important;\n    min-width: 128px !important;\n    box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.08);\n\n    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n      background: ",
        ";\n      span {\n        font-weight: bold;\n        font-family: var(--font-bold) !important;\n      }\n    }\n\n    .ant-select-item-option-active {\n      background: ",
        ";\n      .ant-select-item-option-content {\n        text-overflow: unset;\n      }\n    }\n  }\n\n  .ant-picker-date-panel {\n    width: 280px;\n  }\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: transparent;\n    border: 1px solid #f7f7f7;\n  "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  height: ",
        ";\n  width: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #d9d9d9;\n  padding: 5px;\n  border-radius: 3px;\n  margin: 0 10px 16px 10px;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n\n  .ant-table-body {\n    height: calc(100vh - 140px);\n    padding-bottom: 10px;\n  }\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-selector {\n    border-radius: 0 4px 4px 0 !important;\n  }\n\n  .ant-select-arrow {\n    top: 48% !important;\n  }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    height: 617px;\n    overflow: scroll;\n  }\n\n  .ant-table-placeholder {\n    height: 460px;\n  }\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}











var cellType = {
    up: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary,
    down: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange,
    neutral: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].suvaGrey */ .Z.suvaGrey,
    default: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].highempahis */ .Z.highempahis,
    local: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].purpleHeart */ .Z.purpleHeart,
    bumn: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].green */ .Z.green,
    foreign: "#D73F3C",
    newForeign: "#D73F3C"
};
var HeaderContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "space-between",
    px: "10px"
}).withConfig({
    componentId: "sc-4858c0ef-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].aliceBlue */ .Z.aliceBlue, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var Td = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        height: "auto",
        padding: "6px 0px",
        size: "13px",
        // @ts-expect-error
        type: props.type || "default"
    };
}).withConfig({
    componentId: "sc-4858c0ef-1"
})(_templateObject5(), function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject1(), // @ts-expect-error
    props.bgType);
}, function(param) {
    var type = param.type;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject2(), cellType[type]);
}, function(param) {
    var weight = param.weight;
    return weight === "bold" && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject3());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject4(), // @ts-expect-error
    props.minWidth);
});
var Th = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(Td).attrs({
    padding: "6px 0px",
    size: "13px",
    whiteSpace: "nowrap"
}).withConfig({
    componentId: "sc-4858c0ef-2"
})(_templateObject6());
var DatePicker = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_DatePicker__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-3"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);
var Box = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-4"
})(_templateObject8(), function(param) {
    var isSidewigetOpen = param.isSidewigetOpen;
    if (!isSidewigetOpen) {
        return "320px";
    }
    return "380px";
}, function(param) {
    var showTopStock = param.showTopStock;
    return showTopStock && "padding-right: 70px;";
});
var SearchWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-5"
})(_templateObject9());
var StyledTabs = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-6"
})(_templateObject10());
var DatePickerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-7"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var SelectWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-8"
})(_templateObject12());
var BrokerActivityWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-9"
})(_templateObject13());
var BrokerActivityTabelWrap = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-10"
})(_templateObject14(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var BrokActivityText = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        height: "auto",
        size: "13px",
        align: "center",
        padding: "6px 0px",
        // @ts-expect-error
        type: props.type || "default"
    };
}).withConfig({
    componentId: "sc-4858c0ef-11"
})(_templateObject16(), function(param) {
    var type = param.type;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject15(), cellType[type]);
});
var CodeTag = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.attrs */ .ZP.span.attrs(function(props) {
    return {
        type: props.className || "default"
    };
}).withConfig({
    componentId: "sc-4858c0ef-12"
})(_templateObject18(), function(param) {
    var type = param.type;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject17(), cellType[type]);
});
var BrokerListSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs(function() {
    return {
        style: {
            width: "100%",
            marginBottom: 12
        }
    };
}).withConfig({
    componentId: "sc-4858c0ef-13"
})(_templateObject19(), CodeTag, CodeTag, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].highempahis */ .Z.highempahis);
var TableListTransaction = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_widget_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-14"
})(_templateObject20(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].downgray */ .Z.downgray);
var TableSortableHeader = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-15"
})(_templateObject21());
var TableBrokerAccDist = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_widget_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-16"
})(_templateObject22(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var TableBrokerSummary = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_widget_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-17"
})(_templateObject23());
var TableBrokerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-18"
})(_templateObject24());
var TableTransactionBroker = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_widget_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-19"
})(_templateObject25(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var BandarSearchCompanyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-20"
})(_templateObject26());
var ButtonOpenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-21"
})(_templateObject27(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-22"
})(_templateObject28());
var ModalBrokerSummary = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_company_Modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-23"
})(_templateObject29());
var ModalTitle = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-24"
})(_templateObject30());
var TableTopBroker = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_widget_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-25"
})(_templateObject31(), function(props) {
    return(// @ts-expect-error
    props.isModal ? 0 : "0 12px");
});
var BrokerSummaryOuterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-26"
})(_templateObject32());
var WrapperTransactionList = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-27"
})(_templateObject33());
var loadingAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .keyframes */ .F4)(_templateObject34());
var WrapperMenu = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-28"
})(_templateObject35(), function(param) {
    var inModal = param.inModal;
    return inModal ? "50px" : "1px";
}, function(param) {
    var inModal = param.inModal;
    return inModal ? "5px" : "48px";
}, loadingAnimation, loadingAnimation, function(param) {
    var inModal = param.inModal;
    return !inModal && "\n     justify-content: space-between;\n      width: 100%;\n      max-width: 347px;\n    ";
});
var DropdownWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Popover__WEBPACK_IMPORTED_MODULE_8__/* .PopoverContentWrapper */ .R_).withConfig({
    componentId: "sc-4858c0ef-29"
})(_templateObject36());
var DropdownOption = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-30"
})(_templateObject38(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].aliceBlue */ .Z.aliceBlue, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject37(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary);
});
var PeriodSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-31"
})(_templateObject39(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].green */ .Z.green);
var ModalPeriodSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-32"
})(_templateObject40(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].green */ .Z.green);
var SelectContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-33"
})(_templateObject41(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].component */ .Z.component, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].whisper */ .Z.whisper);
var convertToPixel = function(value) {
    if (value === undefined) return value;
    return typeof value === "number" ? "".concat(value, "px") : value;
};
var variantStyles = function(param) {
    var background = param.background;
    return {
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject42(), background || "#f7f7f7"),
        outline: (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject43())
    };
};
var Skeleton = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-34"
})(_templateObject44(), function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_param, [
        "variant"
    ]);
    return variantStyles(props)[variant];
}, function(param) {
    var height = param.height;
    return convertToPixel(height || 20);
}, function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width;
    return convertToPixel(width);
}, function(param) {
    var rounded = param.rounded, width = param.width, height = param.height;
    if (typeof width === "number") {
        return rounded ? convertToPixel(width / 2) : "6px";
    }
    if (typeof height === "number") {
        return rounded ? convertToPixel(height / 2) : "6px";
    }
    return rounded ? "50%" : "6px";
});
var PeriodSkeleton = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-35"
})(_templateObject45());
var TopBrokerContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4858c0ef-36"
})(_templateObject46());
var MarketSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_common_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4858c0ef-37"
})(_templateObject47());
var ModalTopBroker = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_deprecated_ui_company_Modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).attrs({
    radius: "4px"
}).withConfig({
    componentId: "sc-4858c0ef-38"
})(_templateObject48());



/***/ }),

/***/ 6767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19225);
/* eslint-disable camelcase */ 




// constants
var CONTEXT = "@sidewidget/companyWatchlist";
var actionType = {
    GET_WATCHLIST: "".concat(CONTEXT, "/GET_WATCHLIST"),
    UNFOLLOW_COMPANY: "".concat(CONTEXT, "/UNFOLLOW_COMPANY")
};
// initial state
var initialState = {
    showList: false,
    list: [],
    isLoading: false,
    error: null
};
// Selectors
var selfSelector = function(state) {
    return state.mainLayout.watchlist.company;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(selfSelector, function(state) {
    return state;
});
// Async Actions / Side Effects
var effects = {
    getCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_WATCHLIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistId, ref, watchlistIdCookie, targetWatchlistId, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId;
                        ref = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess(), watchlistIdCookie = ref.watchlist_id;
                        targetWatchlistId = watchlistId || watchlistIdCookie;
                        if (targetWatchlistId) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("watchListId is required");
                    case 5:
                        _ctx.next = 7;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDetailWatchlist */ .Z.getDetailWatchlist(targetWatchlistId);
                    case 7:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 10:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error(error);
                    case 13:
                        return _ctx.abrupt("return", data.result.map(function(param) {
                            var change = param.change, id = param.id, last = param.last, name = param.name, percent = param.percent, previous = param.previous, symbol = param.symbol, type = param.type, notation = param.notation, uma = param.uma, corp_action = param.corp_action, icon_url = param.icon_url, prices = param.prices;
                            var direction = "neutral";
                            if (change > 0) {
                                direction = "up";
                            } else if (change < 0) {
                                direction = "down";
                            }
                            return {
                                change: change,
                                id: id,
                                last: last,
                                name: name,
                                percent: percent,
                                previous: previous,
                                symbol: symbol,
                                type: type,
                                direction: direction,
                                notation: notation,
                                uma: uma,
                                corp_action: corp_action,
                                icon_url: icon_url,
                                prices: prices
                            };
                        }));
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Unfollow Company
    unfollowCompany: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.UNFOLLOW_COMPANY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var companyId, watchlistId, dispatch, ref, watchlistIdCookie, targetWatchlistId, response, _data, data, error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        companyId = param.companyId, watchlistId = param.watchlistId, dispatch = param1.dispatch;
                        ref = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess(), watchlistIdCookie = ref.watchlist_id;
                        targetWatchlistId = watchlistId || watchlistIdCookie;
                        if (targetWatchlistId) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("watchListId is required");
                    case 5:
                        _ctx.next = 7;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postUnfollowCompany */ .Z.postUnfollowCompany(targetWatchlistId, companyId);
                    case 7:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 10:
                        _data = response.data, data = _data.data, error = _data.error, message = _data.message;
                        if (!error) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error(error);
                    case 13:
                        dispatch(effects.getCompanyWatchlist({
                            watchlistId: watchlistId
                        }));
                        return _ctx.abrupt("return", {
                            message: message,
                            data: data
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    toggleViewType: function(draft) {
        draft.showList = !draft.showList;
    }
};
// Extra Reducer for async actions
var extraReducers = function(builder) {
    builder// get company watchlist
    .addCase(effects.getCompanyWatchlist.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.getCompanyWatchlist.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    }).addCase(effects.getCompanyWatchlist.fulfilled, function(draft, action) {
        draft.list = action.payload;
        draft.isLoading = false;
    })// unfollow
    .addCase(effects.unfollowCompany.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.unfollowCompany.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    }).addCase(effects.unfollowCompany.fulfilled, function(draft) {
        draft.isLoading = false;
    });
};
// Slice
var companyWatchlistSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "companyWatchlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (companyWatchlistSlice);


/***/ }),

/***/ 31390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78626);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);





// constants
var CONTEXT = "@sidewidget/listWatchlist";
// initial state
var initialState = {
    saved: [],
    isLoading: false,
    isCreateModalVisible: false,
    isDeleteModalVisible: false,
    watchlistTobeDeleted: null,
    error: null
};
// Selectors
var selectSelf = function(state) {
    return state.mainLayout.watchlist.listWatchlist;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(selectSelf, function(state) {
    return state;
});
// Async Actions / Side Effects
var effects = {
    getSavedWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/GET_SAVED_WATCHLIST"), (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAllWatchlist */ .Z.getAllWatchlist();
                case 2:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to fetch stream failed");
                case 5:
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(error);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // create new watchlist
    createNewWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/CREATE_NEW_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var name, description, dispatch, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, description = param.description, dispatch = param1.dispatch;
                        if (name) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Watchlist name should be provided");
                    case 3:
                        _ctx.next = 5;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].createNewWatchlist */ .Z.createNewWatchlist(name, description);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 8:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(error);
                    case 11:
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setCurrentwatchlistId */ .ZP.actions.setCurrentwatchlistId({
                            watchlistId: data.watchlist_id
                        }));
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.toggleViewType */ .ZP.actions.toggleViewType({
                            listType: "company"
                        }));
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // delete selected watchlist
    deleteSelectedWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/DELETE_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var _watchlistid, watchlistid, activeWatchlistId, dispatch, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _watchlistid = param.watchlistid, watchlistid = _watchlistid === void 0 ? null : _watchlistid, activeWatchlistId = param.activeWatchlistId, dispatch = param1.dispatch;
                        if (watchlistid) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Watchlist id should be provided");
                    case 3:
                        _ctx.next = 5;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].deleteWatchlistById */ .Z.deleteWatchlistById(watchlistid);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to delete company watchlist failed");
                    case 8:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(error);
                    case 11:
                        if (activeWatchlistId === watchlistid) {
                            dispatch(_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setCurrentwatchlistId */ .ZP.actions.setCurrentwatchlistId({
                                watchlistId: null
                            }));
                        }
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer
var reducers = {
    toggleCreateModal: function(draft) {
        draft.isCreateModalVisible = !draft.isCreateModalVisible;
    },
    toggleDeleteModal: function(draft) {
        draft.isDeleteModalVisible = !draft.isDeleteModalVisible;
    },
    setDeleteId: function(draft, action) {
        draft.watchlistTobeDeleted = action.payload.id;
        draft.isDeleteModalVisible = true;
    }
};
// Extra Reducer for async actions
var extraReducers = function(builder) {
    builder// add new watchlist
    .addCase(effects.createNewWatchlist.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.createNewWatchlist.fulfilled, function(state, action) {
        state.isLoading = false;
        if (action.payload.data) state.saved.push(action.payload.data);
    }).addCase(effects.createNewWatchlist.rejected, function(state, action) {
        state.error = action.error;
    })// get saved watchlists
    .addCase(effects.getSavedWatchlist.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.getSavedWatchlist.fulfilled, function(state, action) {
        state.isLoading = false;
        state.saved = action.payload.data;
    }).addCase(effects.getSavedWatchlist.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    })// delete watchlist id
    .addCase(effects.deleteSelectedWatchlist.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.deleteSelectedWatchlist.fulfilled, function(state, action) {
        state.isLoading = false;
        state.isDeleteModalVisible = false;
        state.watchlistTobeDeleted = null;
        if (action.payload.data) {
            state.saved = state.saved.filter(function(x) {
                return x.watchlist_id !== action.payload.data.watchlist_id;
            });
        }
    }).addCase(effects.deleteSelectedWatchlist.rejected, function(state) {
        state.isLoading = false;
        state.isDeleteModalVisible = false;
        state.watchlistTobeDeleted = null;
    });
};
// Slice
var listWatchlistSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "listWatchlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (listWatchlistSlice);


/***/ }),

/***/ 18388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mb": function() { return /* binding */ symbolSelector; },
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83384);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44590);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51346);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85440);





// libs


// types


var initialState = {
    requestStatus: "idle",
    isSearchbarActive: false,
    offerSectionStatus: "idle",
    symbol: "IHSG",
    name: "Indeks Harga Saham Gabungan",
    lastprice: null,
    change: null,
    percentageChange: null,
    keyword: "",
    searchResult: [],
    ohlc: null,
    offer: null,
    isBidOfferExists: false,
    summary: null,
    priceData: null,
    orderbookPriceData: {},
    error: null,
    previous: 0,
    orderbook: null
};
var reducers = {
    setisSearchbarActive: function(draft, action) {
        draft.isSearchbarActive = action.payload.isOpen;
    },
    setSymbol: function(draft, action) {
        draft.symbol = action.payload.symbol;
    }
};
// selectors
var selfSelector = function(state) {
    return state.mainLayout.watchlist.orderbook;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(selfSelector, function(state) {
    return state;
});
var symbolSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.watchlist.orderbook.symbol;
}, function(state) {
    return state;
});
// thunk actions
var CONTEXT = "ORDERBOOK_WIDGET";
var fetchOrderbook = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/FETCH_ORDERBOOK"), function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var symbol, response, companyResponse, _data, responseData, error, _data1, compData, compError, data, previous, ohlc, isOfferExists, isBidExists, priceData, orderbookPriceData, summary, isBidOfferExists, bid, offer, lastprice, change, percentageChange;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    symbol = param.symbol;
                    _ctx.next = 3;
                    return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getOrderbookPreviewBySymbol */ .Z.getOrderbookPreviewBySymbol(symbol);
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getCompanyInfo */ .Z.getCompanyInfo(symbol);
                case 6:
                    companyResponse = _ctx.sent;
                    _data = response.data, responseData = _data.data, error = _data.error;
                    _data1 = companyResponse.data, compData = _data1.data, compError = _data1.error;
                    data = (0,features_orderbook_utils__WEBPACK_IMPORTED_MODULE_4__/* .transformNewOrderbookListToExisting */ .M6)(responseData);
                    previous = data.previous;
                    if (!(error || compError)) {
                        _ctx.next = 13;
                        break;
                    }
                    throw new Error(error || compError);
                case 13:
                    ohlc = function(param) {
                        var previous = param.previous, change = param.change, percentage_change = param.percentage_change, frequency = param.frequency, open = param.open, high = param.high, low = param.low, fbuy = param.fbuy, volume = param.volume, value = param.value, average = param.average, fsell = param.fsell, close = param.close, lastprice = param.lastprice, symbol = param.symbol, exchange = param.exchange, ara = param.ara, arb = param.arb;
                        return {
                            previous: previous,
                            change: change,
                            percentage_change: percentage_change,
                            frequency: frequency,
                            open: open,
                            high: high,
                            low: low,
                            fbuy: fbuy,
                            volume: volume,
                            value: value,
                            average: average,
                            fsell: fsell,
                            close: close,
                            lastprice: lastprice,
                            symbol: symbol,
                            exchange: exchange,
                            ara: ara,
                            arb: arb
                        };
                    }(data);
                    isOfferExists = Boolean(!!data.offer && typeof data.offer === "object" && Object.keys(data.offer).length > 0);
                    isBidExists = Boolean(!!data.bid && typeof data.bid === "object" && Object.keys(data.bid).length > 0);
                    priceData = null;
                    orderbookPriceData = {};
                    summary = null;
                    isBidOfferExists = isBidExists || isOfferExists;
                    if (isBidOfferExists) {
                        bid = (data === null || data === void 0 ? void 0 : data.bid) || {};
                        offer = (data === null || data === void 0 ? void 0 : data.offer) || {};
                        orderbookPriceData = {
                            bid: bid,
                            offer: offer
                        };
                    }
                    lastprice = numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.lastprice).format("0,0[.]00");
                    change = numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.change).format("0");
                    percentageChange = "".concat(numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.percentage_change).format("0.00"), "%");
                    (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .setValue */ .sO)({
                        key: "liveprice",
                        symbol: data.symbol,
                        type: "update_general_pricedata",
                        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, data)
                    });
                    return _ctx.abrupt("return", {
                        isBidOfferExists: isBidOfferExists,
                        ohlc: ohlc,
                        lastprice: lastprice,
                        change: change,
                        percentageChange: percentageChange,
                        name: compData.name,
                        priceData: priceData,
                        summary: summary,
                        previous: previous,
                        orderbookPriceData: orderbookPriceData,
                        orderbook: data
                    });
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var fetchSymbolSuggestions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/FETCH_SUGGESTIONS"), function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keyword, response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keyword = param.keyword;
                    _ctx.next = 3;
                    return lib_api_search__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSearchCompany */ .Z.getSearchCompany(keyword);
                case 3:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        company: data.company
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var effects = {
    fetchOrderbook: fetchOrderbook,
    fetchSymbolSuggestions: fetchSymbolSuggestions
};
// thunks reducers
var extraReducers = function(builder) {
    // fetch orderbook details
    builder.addCase(fetchOrderbook.pending, function(draft) {
        draft.requestStatus = "pending";
        draft.error = null;
    }).addCase(fetchOrderbook.fulfilled, function(draft, action) {
        draft.requestStatus = "loaded";
        draft.isBidOfferExists = action.payload.isBidOfferExists;
        draft.ohlc = action.payload.ohlc;
        draft.lastprice = action.payload.lastprice;
        draft.change = action.payload.change;
        draft.percentageChange = action.payload.percentageChange;
        draft.name = action.payload.name;
        draft.priceData = action.payload.priceData;
        draft.summary = action.payload.summary;
        draft.previous = action.payload.previous;
        draft.orderbookPriceData = action.payload.orderbookPriceData;
        draft.orderbook = action.payload.orderbook;
    }).addCase(fetchOrderbook.rejected, function(draft, action) {
        draft.error = action.error;
    })// fetch company suggestions
    .addCase(fetchSymbolSuggestions.pending, function(draft) {
        draft.error = null;
    }).addCase(fetchSymbolSuggestions.fulfilled, function(draft, action) {
        draft.searchResult = action.payload.company;
    }).addCase(fetchSymbolSuggestions.rejected, function(draft, action) {
        draft.error = action.error;
    });
};
var orderbookSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "orderbook",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (orderbookSlice);


/***/ }),

/***/ 85440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ useOrderbookStore; },
/* harmony export */   "sO": function() { return /* binding */ setValue; }
/* harmony export */ });
/* unused harmony exports OrderbookState, setValueBatch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);




var OrderbookState = {
    liveprice: {}
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(_set, _get, _store, _storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, OrderbookState);
});
var handleUpdateGeneralPriceData = function(draft, payload, isInit) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft, isInit ? payload : {}), {
        average: payload.average,
        change: payload.change,
        close: payload.close,
        frequency: payload.frequency,
        fsell: payload.fsell,
        high: payload.high,
        id: payload.id,
        lastprice: payload.lastprice,
        low: payload.low,
        open: payload.open,
        percentage_change: payload.percentage_change,
        previous: payload.previous,
        symbol: payload.symbol,
        value: payload.value,
        volume: payload.volume,
        time: payload === null || payload === void 0 ? void 0 : payload.time
    });
};
var handleUpdateOrderbookPriceData = function(draft, payload) {
    if (payload.bid) {
        draft.bid = payload.bid;
    }
    if (payload.offer) {
        draft.offer = payload.offer;
    }
    return draft;
};
var handleUpdateIepIev = function(draft, payload) {
    var ref, ref1;
    draft.iepiev = payload ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : draft.iepiev), {
        iep: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref = draft.iepiev) === null || ref === void 0 ? void 0 : ref.iep), {
            raw: payload.iep
        }),
        iev: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref1 = draft.iepiev) === null || ref1 === void 0 ? void 0 : ref1.iev), {
            raw: payload.iev
        })
    }) : null;
    return draft;
};
var TYPE_SET = {
    "update_general_pricedata_liveprice": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, false);
    },
    "update_orderbook_pricedata_liveprice": function(draft, payload) {
        return handleUpdateOrderbookPriceData(draft, payload);
    },
    "update_general_pricedata": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, true);
    },
    "update_iepiev": handleUpdateIepIev
};
var setValue = function(param) {
    var key = param.key, value = param.value, symbol = param.symbol, _type = param.type, type = _type === void 0 ? "update_general_pricedata" : _type;
    return useOrderbookStore.setState(function(state) {
        return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(state, function(draft) {
            var ref;
            var draftSymbol = ((ref = draft[key]) === null || ref === void 0 ? void 0 : ref[symbol]) || {};
            draft[key][symbol] = TYPE_SET[type](draftSymbol, value);
            return;
        });
    });
};
var setValueBatch = function(payload) {
    return useOrderbookStore.setState(function(state) {
        return produce(state, function(draft) {
            payload.map(function(item) {
                var ref;
                var _payload = item.payload, value = _payload.data, index = _payload.index, type = item.name;
                var draftSymbol = ((ref = draft["liveprice"]) === null || ref === void 0 ? void 0 : ref[index]) || {};
                draft["liveprice"][index] = TYPE_SET[type](draftSymbol, value);
            });
            return draft;
        });
    });
};


/***/ }),

/***/ 78626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "ag": function() { return /* binding */ wlIdSelector; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40872);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1349);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19225);
/* harmony import */ var _CompanyWatchlist_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6767);








// initial state
var initialState = {
    error: null,
    isLoading: false,
    showList: "company",
    suggestions: [],
    watchlistId: null
};
// constants
var CONTEXT = "@sidewidget/Allwatchlist";
var actionType = {
    GET_COMPANY_SUGGESTION: "".concat(CONTEXT, "/GET_COMPANY_SUGGESTION"),
    SAVE_COMPANY_TO_WATCHLIST: "".concat(CONTEXT, "/SAVE_COMPANY_TO_WATCHLIST")
};
// Selectors
var selectSelf = function(state) {
    return state.mainLayout.watchlist.root;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(selectSelf, function(state) {
    return state;
});
var wlIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.watchlist.root.watchlistId;
}, function(state) {
    return state;
});
// Async Actions / Side Effects
var effects = {
    getCompanySuggestions: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_SUGGESTION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var params, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _param);
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getSearchCompany */ .Z.getSearchCompany(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to fetch suggestion company failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data.companies
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    saveCompanyToWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.SAVE_COMPANY_TO_WATCHLIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var watchlistId, companyid, dispatch, ref, watchlistIdCookie, targetWathclistId, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyid = param.companyid, dispatch = param1.dispatch;
                        ref = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserAccess */ .Z.getUserAccess(), watchlistIdCookie = ref.watchlist_id;
                        targetWathclistId = watchlistId || watchlistIdCookie;
                        if (companyid) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("Company id is not provided");
                    case 5:
                        _ctx.next = 7;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postFollowCompany */ .Z.postFollowCompany(targetWathclistId, companyid);
                    case 7:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to follow company failed");
                    case 10:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error(error);
                    case 13:
                        // re-fetch selected watchlist contents
                        dispatch(_CompanyWatchlist_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.getCompanyWatchlist */ .Sz.getCompanyWatchlist({
                            watchlistId: watchlistId
                        }));
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    toggleViewType: function(draft, action) {
        draft.showList = action.payload.listType;
    },
    setCurrentwatchlistId: function(draft, action) {
        draft.watchlistId = action.payload.watchlistId;
    }
};
// Extra Reducer for async actions
var extraReducers = function(builder) {
    builder// Extra reducers for fetch suggestions
    .addCase(effects.getCompanySuggestions.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.getCompanySuggestions.fulfilled, function(draft, action) {
        draft.isLoading = false;
        draft.suggestions = action.payload.data;
    }).addCase(effects.getCompanySuggestions.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// Extra reducers for save company to watchlist
    .addCase(effects.saveCompanyToWatchlist.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.saveCompanyToWatchlist.fulfilled, function(draft) {
        draft.isLoading = false;
    }).addCase(effects.saveCompanyToWatchlist.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// Slice
var allWatchlistSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "watchlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (allWatchlistSlice);


/***/ }),

/***/ 6421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ SmartOrderLabel; },
/* harmony export */   "ax": function() { return /* binding */ ORDER_TYPE_VALUE_TEXT; },
/* harmony export */   "by": function() { return /* binding */ EventTypeEnum; },
/* harmony export */   "n5": function() { return /* binding */ TradingFeatureEnum; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var TradingFeatureEnum;
(function(TradingFeatureEnum) {
    TradingFeatureEnum["UNSPECIFIED"] = "FEATURE_UNSPECIFIED";
    TradingFeatureEnum["DAY_TRADE"] = "FEATURE_DAY_TRADE";
    TradingFeatureEnum["SPLIT_ORDER"] = "FEATURE_SPLIT_ORDER";
})(TradingFeatureEnum || (TradingFeatureEnum = {}));
var EventTypeEnum;
(function(EventTypeEnum) {
    EventTypeEnum["UNSPECIFIED"] = "EVENT_TYPE_UNSPECIFIED";
    EventTypeEnum["OUTSIDE_MARKET_HOURS"] = "EVENT_TYPE_DISABLE_OUTSIDE_MARKET_HOURS";
    EventTypeEnum["EXCEED_DEBT_RATIO"] = "EVENT_TYPE_DISABLE_EXCEED_DEBT_RATIO";
})(EventTypeEnum || (EventTypeEnum = {}));
var SmartOrderLabel;
(function(SmartOrderLabel) {
    SmartOrderLabel["TP"] = "TP";
    SmartOrderLabel["SL"] = "SL";
    SmartOrderLabel["MO"] = "MO";
    SmartOrderLabel["TS"] = "TS";
    SmartOrderLabel["AB"] = "AB";
    SmartOrderLabel["BO"] = "BO";
    SmartOrderLabel["LIT_SELL"] = "LIT_SELL";
    SmartOrderLabel["VTO"] = "VTO";
})(SmartOrderLabel || (SmartOrderLabel = {}));
var _obj;
var ORDER_TYPE_VALUE_TEXT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.TP, "Take Profit"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.SL, "Stop Loss"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.TS, "Trailing Stop"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.AB, "Limit If Touched"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.LIT_SELL, "Limit If Touched"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.BO, "Bracket Limit Order"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.MO, "Market Order"), _obj);


/***/ }),

/***/ 28840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ useSecuritiesStore; }
/* harmony export */ });
/* unused harmony exports securitiesState, securitiesActions */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14671);





var securitiesState = {
    channel: {},
    isReconnectionFailed: false,
    isSocketOnline: false
};
var securitiesActions = function(set) {
    return {
        setChannel: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.channel = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, draft.channel), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value));
                });
            });
        },
        setIsReconnectionFailed: function(value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.isReconnectionFailed = value;
                });
            });
        },
        setIsSocketOnline: function(isSocketOnline) {
            set({
                isSocketOnline: isSocketOnline
            });
        },
        resetChannel: function() {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.channel = {};
                });
            });
        }
    };
};
var useSecuritiesStore = (0,zustand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, securitiesState, securitiesActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 61048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25641);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51679);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14601);
/* harmony import */ var _StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47225);









// APIs
// External reducer

var STATUS_FOLLOWING = 1;
var STATUS_UNFOLLOWING = 0;
var STATUS_SAVED = 1;
var STATUS_UNSAVED = 0;
var STATUS_LIKED = 1;
var STATUS_UNLIKED = 0;
var initialState = {
    data: {},
    selected: {},
    isLoading: true,
    isLoadingMore: false,
    error: null,
    message: ""
};
// Selectors -----------------------------------------------------------
var convoSelector = function(state) {
    return state.streamConversation;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(convoSelector, function(convo) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, convo);
});
// Action type -----------------------------------------------------------
var CONTEXT = "@redux/streamConversation";
var actionType = {
    GET_CONVERSATION: "".concat(CONTEXT, "/GET_CONVERSATION"),
    LOAD_PREV_CONVERSATION: "".concat(CONTEXT, "/LOAD_PREV_CONVERSATION")
};
var // Helper -----------------------------------------------------------
IActionStatus;
(function(IActionStatus) {
    IActionStatus[IActionStatus["STATUS_FOLLOWING"] = 0] = "STATUS_FOLLOWING";
    IActionStatus[IActionStatus["STATUS_UNFOLLOWING"] = 1] = "STATUS_UNFOLLOWING";
    IActionStatus[IActionStatus["STATUS_SAVED"] = 2] = "STATUS_SAVED";
    IActionStatus[IActionStatus["STATUS_UNSAVED"] = 3] = "STATUS_UNSAVED";
    IActionStatus[IActionStatus["STATUS_LIKED"] = 4] = "STATUS_LIKED";
    IActionStatus[IActionStatus["STATUS_UNLIKED"] = 5] = "STATUS_UNLIKED";
})(IActionStatus || (IActionStatus = {}));
/**
 * Do Count of Stream Post Likes
 * @param state state
 * @param status status
 */ var countStreamPostLike = function(state, status) {
    if (status === STATUS_LIKED) {
        state.likes += 1;
    } else if (status === STATUS_UNLIKED) {
        state.likes -= 1;
    }
};
/**
 * Change Status of Action
 * @param state state object
 * @param postid post id
 * @param action property that want to change
 * @param status value that you want to apply to the property
 * @description
 * this for change follow, saved, liked, likes value
 * from state.selected
 */ var changeActionStatus = function(state, postid, action, status) {
    var ref, ref1, ref2;
    // check index of replies item of selected convo
    var replyIdx = (ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(reply) {
        return reply.postid === postid;
    });
    // change 'action' value of replies item with status
    if (replyIdx !== undefined && replyIdx > -1) {
        var ref3, ref4;
        var targetReply = (ref3 = state.selected) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.replies) === null || ref4 === void 0 ? void 0 : ref4[replyIdx];
        if (targetReply) {
            targetReply[action] = status;
            if (action === "liked") {
                countStreamPostLike(targetReply, status);
            }
        }
    } else if (((ref2 = state.selected.parent) === null || ref2 === void 0 ? void 0 : ref2.postid) === postid) {
        if (state.selected.parent) {
            state.selected.parent[action] = status;
            if (action === "liked") {
                countStreamPostLike(state.selected.parent, status);
            }
        }
    }
};
// Effects -----------------------------------------------------------
var effects = {
    getStreamConversation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_CONVERSATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var postId, parentId, response, _data, posts, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postId = param.postId, parentId = param.parentId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getStreamConversation */ .Z.getStreamConversation({
                            postId: postId,
                            parentId: parentId
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to fetch stream conversation failed");
                    case 7:
                        _data = response.data, posts = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        data = (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .transformConversationV3 */ .PI)(posts.conversation);
                        return _ctx.abrupt("return", {
                            postid: postId,
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadPreviousConversation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.LOAD_PREV_CONVERSATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var ref, lastReplyPostId, postid, response, _data, posts, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        lastReplyPostId = params.lastReplyPostId, postid = params.postid;
                        _ctx.next = 5;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getPrevStreamConversation */ .Z.getPrevStreamConversation(lastReplyPostId);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to fetch stream conversation failed");
                    case 8:
                        _data = response.data, posts = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        data = {
                            more: !((ref = posts.pagination) === null || ref === void 0 ? void 0 : ref.is_last_page),
                            replies: (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .transformV3Response */ .bv)(posts.stream)
                        };
                        return _ctx.abrupt("return", {
                            postid: postid,
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers -----------------------------------------------------------
var reducers = {
    closeStreamConversation: function(state) {
        state.isLoading = initialState.isLoading;
        state.isLoadingMore = initialState.isLoadingMore;
    }
};
// Extra reducers -----------------------------------------------------------
var extraReducers = function(builder) {
    builder.addCase(effects.getStreamConversation.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getStreamConversation.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.selected = data;
            state.error = null;
            state.isLoading = false;
        }
        state.message = message;
    }).addCase(effects.getStreamConversation.rejected, function(state, action) {
        state.error = action.payload.error;
    }).addCase(effects.loadPreviousConversation.pending, function(state) {
        state.isLoadingMore = true;
        state.error = null;
    }).addCase(effects.loadPreviousConversation.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.selected = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state.selected), {
                // @ts-ignore
                replies: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(data.replies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(state.selected.replies)),
                more: data.more
            });
            state.error = null;
        }
        state.isLoadingMore = false;
        state.message = message;
    }).addCase(effects.loadPreviousConversation.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoadingMore = false;
    })// Follow/unfollow stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.followPost.fulfilled */ .Sz.followPost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "follow", STATUS_FOLLOWING);
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unfollowPost.fulfilled */ .Sz.unfollowPost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "follow", STATUS_UNFOLLOWING);
    })// Save/unsave stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.savePost.fulfilled */ .Sz.savePost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "saved", STATUS_SAVED);
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unsavePost.fulfilled */ .Sz.unsavePost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "saved", STATUS_UNSAVED);
    })// Like/unline stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.likePost.fulfilled */ .Sz.likePost.fulfilled, function(state, action) {
        var _payload = action.payload, postid = _payload.postid, error = _payload.error;
        if (!error) {
            changeActionStatus(state, postid, "liked", STATUS_LIKED);
        }
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unlikePost.fulfilled */ .Sz.unlikePost.fulfilled, function(state, action) {
        var _payload = action.payload, postid = _payload.postid, error = _payload.error;
        if (!error) {
            changeActionStatus(state, postid, "liked", STATUS_UNLIKED);
        }
    })// When conversation success replied, the response will be added
    // as new reply to the state.data
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__/* .effects.postConversationStream.fulfilled */ .Sz.postConversationStream.fulfilled, function(state, action) {
        var data = action.payload.data;
        if (data) {
            // @ts-ignore
            var replies = state.selected.replies;
            var newReplies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(replies).concat([
                data
            ]);
            // @ts-ignore
            state.selected.replies = newReplies;
        }
    })// When conversation reply success replied, the reply item state
    // will be updated with api response
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__/* .effects.updatePostStream.fulfilled */ .Sz.updatePostStream.fulfilled, function(state, action) {
        var data = action.payload.data;
        var isReply = (data === null || data === void 0 ? void 0 : data.postid) !== (data === null || data === void 0 ? void 0 : data.parent_postid);
        if (data) {
            var ref;
            // @ts-ignore
            if (isReply && ((ref = state.selected) === null || ref === void 0 ? void 0 : ref.replies)) {
                var _arg = action.meta.arg, commenterType = _arg.commenter_type;
                // @ts-ignore
                var replies = state.selected.replies;
                var idxReplies = replies.findIndex(function(reply) {
                    return (reply === null || reply === void 0 ? void 0 : reply.postid) === (data === null || data === void 0 ? void 0 : data.postid);
                });
                if (idxReplies > -1) {
                    // Update reply item
                    // update created using old and updated as created we receive from server
                    var newReplies = replies;
                    var currentComment = newReplies[idxReplies];
                    newReplies[idxReplies] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                        commenter_type: commenterType,
                        created: currentComment.created,
                        created_display: currentComment.created_display,
                        updated: data === null || data === void 0 ? void 0 : data.created
                    });
                    // @ts-ignore
                    state.selected.replies = newReplies;
                }
            }
        }
    })// When stream post detail/conversation change the comment limitation
    // it will update the commenter_type of parent stream post
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.changeCommenter.fulfilled */ .Sz.changeCommenter.fulfilled, function(state, action) {
        var ref;
        var error = action.payload.error;
        var type = action.meta.arg.type;
        // @ts-ignore
        if (!error && ((ref = state.selected) === null || ref === void 0 ? void 0 : ref.parent)) {
            // @ts-ignore
            state.selected.parent.commenter_type = type;
        }
    })// Handle sideeffect when user post polling vote on convo
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.postVotePolling.fulfilled */ .Sz.postVotePolling.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            var selectedParent = (ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : ref1.polling;
            if (selectedParent) {
                var ref2;
                if (selectedParent.length > 0 && ((ref2 = selectedParent[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === data.id) {
                    // @ts-ignore
                    state.selected.parent.polling[0] = data;
                }
            }
        }
    })// Handle sideeffect when user click price target action on convo
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.postVoteTargetPrice.fulfilled */ .Sz.postVoteTargetPrice.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            if (((ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : ref1.postid) === data.postid) {
                // @ts-ignore
                state.selected.parent = data;
            }
        }
    });
};
var streamConversation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "streamConversation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (streamConversation);


/***/ }),

/***/ 84468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ buttonSupportId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var utils_crisp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65458);
/* eslint-disable react/require-default-props */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: #404040;\n  border: none;\n  border-radius: 50%;\n  bottom: 20px;\n  cursor: pointer;\n  display: flex;\n  height: 60px;\n  justify-content: center;\n  position: fixed;\n  right: 23px;\n  width: 60px;\n  z-index: 9999;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ButtonSupport = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-7e299afe-0"
})(_templateObject());
var buttonSupportId = "buttonSupport";
function SupportButton(param) {
    var isLoggedIn = param.isLoggedIn;
    if (isLoggedIn) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonSupport, {
        onClick: utils_crisp__WEBPACK_IMPORTED_MODULE_4__/* .handleClickSupport */ .lA,
        id: buttonSupportId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: "icon-widget_support",
            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light,
            hoverColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light,
            size: "40px"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SupportButton);


/***/ }),

/***/ 33908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);




// Action type
var CONTEXT = "@global/searchCompany";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: []
};
var searchCompanyState = function(state) {
    return state.searchCompany;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(searchCompanyState, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result
    };
}, function(state) {
    return state;
});
// Effects
var effects = {
    getSearchResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(keyword) {
            var response;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearch */ .Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    resetResult: function(state) {
        state.result = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state, action) {
        state.isLoading = true;
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        var ref, ref1;
        state.result = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.company;
        state.isLoading = false;
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload;
    });
};
// Slice
var searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "searchCompany",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (searchSlice);


/***/ }),

/***/ 63600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ INDEX_DATA_FILTER; },
/* harmony export */   "ce": function() { return /* binding */ QUERY_KEY_DATA; },
/* harmony export */   "e_": function() { return /* binding */ FETCH_STATUS; },
/* harmony export */   "n0": function() { return /* binding */ FILTER_CHOICE; },
/* harmony export */   "t6": function() { return /* binding */ LIST_CHOICE; }
/* harmony export */ });
/* unused harmony exports SUGGESTIONS_PERPAGE, LIMIT_SEARCH_USER, USER_TYPES */
/* harmony import */ var features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28635);

var USER_TYPES = {
    OFFICIAL_USER: "OFFICIAL",
    TOP: "TOP"
};
var SUGGESTIONS_PERPAGE = 30;
var LIMIT_SEARCH_USER = 20;
var QUERY_KEY_DATA = {
    suggested: "getDataFriendSuggestionsListTrendingWidget",
    trending: "getDataTrendingList"
};
// fetch statuses
var FETCH_STATUS = {
    IDLE: "idle",
    PENDING: "pending",
    RESOLVED: "resolved",
    REJECTED: "rejected"
};
var FILTER_CHOICE = [
    {
        label: "Weekly",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ONE_WEEK */ .b.ONE_WEEK
    },
    {
        label: "Monthly",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ONE_MONTH */ .b.ONE_MONTH
    },
    {
        label: "All-time",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ALL */ .b.ALL
    }, 
];
var LIST_CHOICE = {
    SUGGESTED: "suggested",
    TRENDING: "trending"
};
var INDEX_DATA_FILTER = {
    SUGGESTED: "useSuggestionList",
    TRENDING: "useTrendingList"
};



/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 56703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ /* eslint-disable max-len */ 



var alertURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/alert");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getDataPriceAlert = function(params) {
    return request.get("".concat(alertURL, "/status/active"), {
        params: params
    });
};
var getDataAlertLog = function() {
    var statusNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", opt = arguments.length > 1 ? arguments[1] : void 0;
    var status = statusNumber;
    return request.get("".concat(alertURL), {
        params: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, opt), {
            status: status
        })
    });
};
var getDetailAlert = function(alertId) {
    return request.get("".concat(alertURL, "/").concat(alertId));
};
// command is a string of {"stock": [stock], "value": [value], "operator": [opt], "item": "[item]}
var addPriceAlert = function(name, command) {
    var options = {
        name: name,
        command: command
    };
    return request.post("".concat(alertURL), options);
};
var editPriceAlert = function(alertId, name, command) {
    var options = {
        name: name,
        command: command
    };
    return request.put("".concat(alertURL, "/").concat(alertId), options);
};
var cancelPriceAlert = function(id) {
    return request.delete("".concat(alertURL, "/").concat(id));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getDataPriceAlert: getDataPriceAlert,
    getDataAlertLog: getDataAlertLog,
    getDetailAlert: getDetailAlert,
    addPriceAlert: addPriceAlert,
    editPriceAlert: editPriceAlert,
    cancelPriceAlert: cancelPriceAlert
});


/***/ }),

/***/ 29172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var SECTOR_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/emitten");
var getSectorList = function() {
    return request.get("".concat(SECTOR_API, "/sectors"));
};
var getSubsectorList = function(sectorId) {
    return request.get("".concat(SECTOR_API, "/sectors/").concat(sectorId, "/subsectors"));
};
var getCompanyList = function(sectorId, subSectorId) {
    return request.get("".concat(SECTOR_API, "/v3/sector/").concat(sectorId, "/subsector/").concat(subSectorId, "/company"));
};
var getCompanyInSector = function(sectorId) {
    return request.get("".concat(SECTOR_API, "/v3/sector/").concat(sectorId, "/company"));
};
var getSpecialBoardIndex = function() {
    return request.get("".concat(SECTOR_API, "/indexes/special-board"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSectorList: getSectorList,
    getSubsectorList: getSubsectorList,
    getCompanyList: getCompanyList,
    getCompanyInSector: getCompanyInSector,
    getSpecialBoardIndex: getSpecialBoardIndex
});


/***/ }),

/***/ 83384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* eslint-disable import/named */ /* eslint-disable no-undef */ 


var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
// APIs
var ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// EXODUS APIs
var EXODUS_ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// Should be replaced with get company orderbook data but the exodus endpoint
// doesn't support special symbols e.g. IHSG
var getOrderbookPreviewBySymbol = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/company-price-feed/v2/orderbook/companies/").concat(symbol));
};
var getOrderbookList = function() {
    return requestExodus.get(EXODUS_ORDERBOOK_API);
};
var createOrderbookList = function(param) {
    var orderbookName = param.orderbookName;
    return requestExodus.post(EXODUS_ORDERBOOK_API, {
        name: orderbookName
    });
};
var editOrderbookList = function(param) {
    var id = param.id, orderbookName = param.orderbookName, symbols = param.symbols;
    var params = {
        name: orderbookName
    };
    if (symbols) params.symbols = symbols;
    return requestExodus.put("".concat(EXODUS_ORDERBOOK_API, "/").concat(id), params);
};
var deleteOrderbookList = function(param) {
    var id = param.id;
    return requestExodus.delete("".concat(EXODUS_ORDERBOOK_API, "/").concat(id));
};
var getOrderbookListItem = function(id) {
    if (id) {
        return requestExodus.get("/company-price-feed/v2/orderbook/template/".concat(id));
    }
    // Get default orderbook if ID is not passed
    // Harusnya nantinya ada lebih lanjut terkait ini sih, gimana kalo enggak ada ID nya
    return requestExodus.get(ORDERBOOK_API);
};
var getCompanyInfo = function(symbol) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/emitten/").concat(symbol, "/info"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getOrderbookPreviewBySymbol: getOrderbookPreviewBySymbol,
    getOrderbookList: getOrderbookList,
    createOrderbookList: createOrderbookList,
    editOrderbookList: editOrderbookList,
    deleteOrderbookList: deleteOrderbookList,
    getOrderbookListItem: getOrderbookListItem,
    getCompanyInfo: getCompanyInfo
});


/***/ }),

/***/ 20072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable camelcase */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 

var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
// URLs aliases
var TIPPING_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/tip");
// EXODUS TIPPING URL
var EXODUS_TIPPING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/tip");
/**
 * @return {APIResponse}
 */ var getTippingJar = function() {
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/jar"));
};
/**
 * Send tipping from stream
 * @param {Object} tipData
 * @param {Object} tipData.tipable - Target tip
 * @param {number} tipData.tipable.id - Target tip id
 * @param {Object} tipData.tipable.type - Target tip
 * @param {number} tipData.amount - Amount given
 * @param {string=} tipData.message - Additional message
 * @param {string=} tipData.callback_url - Additional message
 * @return {APIResponse}
 */ var sendTippingStream = function(tipData) {
    return requestExodus.post(TIPPING_EXODUS_URL, tipData);
};
/**
 * Claim tipping balance
 * @param {number} amount - Amount to be claimed
 * @return {APIResponse}
 */ var claimTippingBalance = function(amount) {
    return requestExodus.post("".concat(TIPPING_EXODUS_URL, "/claim"), {
        amount: amount
    });
};
/**
 * Update gopay account by number for tipping
 * @param {string} account - Account number
 * @return {APIResponse}
 */ var updateGopayAccount = function(account) {
    return requestExodus.patch("".concat(EXODUS_TIPPING_URL, "/gopay-account"), {
        gopay_account: account
    });
};
/**
 * Get detail tipping from notif
 * @param {string | number} tippingId
 * @return {APIResponse}
 */ var getTippingDetail = function(tippingId) {
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/detail/").concat(tippingId));
};
var getTippingActivity = function() {
    var tabActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "TIP_TAB_TIPPING";
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/activity"), {
        params: {
            tab: tabActivity
        }
    });
};
/**
 * Send tipping
 * @param {Object} tipData
 * @param {Object} tipData.tipable - Target tip
 * @param {number} tipData.tipable.id - Target tip id
 * @param {Object} tipData.tipable.type - Target tip
 * @param {number} tipData.amount - Amount given
 * @param {string=} tipData.message - Additional message
 * @param {string=} tipData.callback_url - Additional message
 * @return {APIResponse}
 */ var sendTipping = function(tipData) {
    return requestExodus.post(TIPPING_EXODUS_URL, tipData);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getTippingJar: getTippingJar,
    getTippingDetail: getTippingDetail,
    sendTippingStream: sendTippingStream,
    claimTippingBalance: claimTippingBalance,
    updateGopayAccount: updateGopayAccount,
    getTippingActivity: getTippingActivity,
    sendTipping: sendTipping
});


/***/ }),

/***/ 74645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_P": function() { return /* binding */ STATE_DETAIL; },
  "yM": function() { return /* binding */ STATE_SEARCH; },
  "IN": function() { return /* binding */ STATE_SUGGESTION; },
  "ZP": function() { return /* binding */ entities_company; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/lib/api/company.ts
var company = __webpack_require__(1349);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/company/follow.js

var schema = {
    change: 0,
    companyid: "",
    followed: 0,
    followers: "",
    percent: 0,
    price: "",
    symbol: ""
};
var propTypes = {
    change: prop_types.number,
    companyid: prop_types.string,
    followed: prop_types.number,
    followers: prop_types.string,
    percent: prop_types.number,
    price: prop_types.string,
    symbol: prop_types.string
};
/* harmony default export */ var follow = ({
    schema: schema,
    propTypes: propTypes
});

;// CONCATENATED MODULE: ./src/lib/entities/company.ts









// States can be updated through follow/unfollow
var STATE_SUGGESTION = "suggestion";
var STATE_SEARCH = "search";
var STATE_DETAIL = "detail";
var defaultSummary = {
    brokers_buy: [],
    brokers_sell: [],
    symbol: ""
};
// Initial state
var initialState = {
    detail: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    search: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    },
    chart: {
        data: {},
        popoverData: {},
        isLoading: false,
        error: null,
        message: ""
    },
    postFollowCompany: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    },
    postUnfollowCompany: {
        data: follow.schema,
        isLoading: false,
        error: null,
        message: ""
    },
    contact: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    brokerSummary: {
        data: {
            detector: {},
            summary: defaultSummary,
            from: "",
            to: ""
        },
        isLoading: false,
        error: null,
        message: ""
    }
};
var companySelector = function(state) {
    return state.entities.company;
};
var selectors = (0,es/* createSelector */.P1)(companySelector, function(company) {
    return (0,_object_spread/* default */.Z)({}, company);
});
// Action types
var CONTEXT = "@redux/company";
var actionType = {
    FETCH_SEARCH: "".concat(CONTEXT, "/FETCH_SEARCH"),
    CLEAR_SEARCH: "".concat(CONTEXT, "/CLEAR_SEARCH"),
    POST_FOLLOW_COMPANY: "".concat(CONTEXT, "/POST_FOLLOW_COMPANY"),
    POST_UNFOLLOW_COMPANY: "".concat(CONTEXT, "/POST_UNFOLLOW_COMPANY"),
    GET_COMPANY_DETAIL: "".concat(CONTEXT, "/GET_COMPANY_DETAIL"),
    GET_COMPANY_CHART: "".concat(CONTEXT, "/GET_COMPANY_CHART"),
    GET_COMPANY_CONTACT: "".concat(CONTEXT, "/GET_COMPANY_CONTACT"),
    FOLLOW_USER: "".concat(CONTEXT, "/FOLLOW_USER"),
    GET_BANDAR_DETECTOR: "".concat(CONTEXT, "/GET_BANDAR_DETECTOR")
};
// symbol, timeframe
// Effects
// Side effect from external
var effects = {
    getSearchCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FETCH_SEARCH, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var response, _data, data, message, _$error, sanitizedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return search/* default.getSearchCompany */.Z.getSearchCompany(keyword);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 8:
                        sanitizedData = (0,_to_consumable_array/* default */.Z)(data.company);
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message
                        });
                    case 10:
                        throw new Error("Attempt to fetch Search company Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyDetail: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_DETAIL, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return company/* default.getCompanyInfo */.Z.getCompanyInfo(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company detail failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyChart: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_CHART, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, timeframe, _isPopover, isPopover, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, timeframe = param.timeframe, _isPopover = param.isPopover, isPopover = _isPopover === void 0 ? false : _isPopover;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return company/* default.getCompanyChart */.Z.getCompanyChart(symbol, timeframe);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get company chart failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol,
                            isPopover: isPopover
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Update follow status company, given parameters
    // Watchlist ID, Company ID,
    // and state to be updated (search | suggestion | etc)
    postFollowCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_FOLLOW_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var watchlistId, companyId, _stateToUpdate, stateToUpdate, response, _data, data, message, _$error, sanitizedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyId = param.companyId, _stateToUpdate = param.stateToUpdate, stateToUpdate = _stateToUpdate === void 0 ? STATE_SUGGESTION : _stateToUpdate;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.postFollowCompany */.Z.postFollowCompany(watchlistId, companyId);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error_type;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        sanitizedData = data[0];
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message,
                            stateToUpdate: stateToUpdate
                        });
                    case 11:
                        throw new Error("Attempt to post Follow company Failed");
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Update unfollow status company, given parameters
    // Watchlist ID, Company ID,
    // and state to be updated (search | suggestion | etc)
    postUnfollowCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_UNFOLLOW_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var watchlistId, companyId, _stateToUpdate, stateToUpdate, response, _data, data, message, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyId = param.companyId, _stateToUpdate = param.stateToUpdate, stateToUpdate = _stateToUpdate === void 0 ? STATE_SUGGESTION : _stateToUpdate;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.postUnfollowCompany */.Z.postUnfollowCompany(watchlistId, companyId);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error_type;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            stateToUpdate: stateToUpdate
                        });
                    case 10:
                        throw new Error("Attempt to post Follow company Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyContact: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_CONTACT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return company/* default.getCompanyContact */.Z.getCompanyContact(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company detail failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    // TODO integrate postFollowUser to watchlist followUser
    postFollowUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FOLLOW_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var username, userid, _type, type, targetAPI, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = param.username, userid = param.userid, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("User id is empty");
                    case 4:
                        targetAPI = watchlist/* default.postFollowUser */.Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = watchlist/* default.postUnfollowUser */.Z.postUnfollowUser;
                        }
                        _ctx.next = 8;
                        return targetAPI(userid);
                    case 8:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Attempt to follow user failed");
                    case 11:
                        _data = response.data, _$error = _data.error_type, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 14:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            type: type,
                            username: username,
                            userid: userid
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBandarDetector: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_BANDAR_DETECTOR, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, params, response, _data, data, _$error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return company/* default.getMarketDetector */.Z.getMarketDetector(symbol, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get market detector failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    clearSearch: function(state) {
        state.search.data = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchCompany.pending, function(state) {
        state.detail.isLoading = true;
        state.detail.error = null;
    }).addCase(effects.getSearchCompany.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.search.error = error;
        } else {
            state.search.data = data;
        }
        state.search.message = message;
        state.search.isLoading = false;
    }).addCase(effects.getSearchCompany.rejected, function(state, action) {
        state.search.error = action.payload.error;
        state.search.isLoading = false;
    }).addCase(effects.getCompanyDetail.pending, function(state) {
        state.detail.isLoading = true;
        state.detail.error = null;
    }).addCase(effects.getCompanyDetail.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.detail.error = error;
        } else {
            state.detail.data[symbol] = data;
            state.detail.error = null;
        }
        state.detail.isLoading = false;
        state.detail.message = message;
    }).addCase(effects.getCompanyDetail.rejected, function(state, action) {
        state.detail.error = action.payload.error;
        state.detail.isLoading = false;
    }).addCase(effects.getCompanyChart.pending, function(state) {
        state.chart.isLoading = true;
        state.chart.error = null;
    }).addCase(effects.getCompanyChart.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol, isPopover = _payload.isPopover;
        if (error) {
            state.chart.error = error;
        } else {
            // data might be null, e.g. CPO timeframe 1d
            var newData = data ? (0,_object_spread/* default */.Z)({}, data) : null;
            // Inject Previous Price to 'today' prices
            // https://stockbit.atlassian.net/browse/IDT-501
            if (data && data.timeframe === "today" && data.prices.length && data.previous) {
                newData.prices = [
                    {
                        date: "0",
                        formatted_date: "",
                        xlabel: "0",
                        value: data.previous.toString(),
                        percentage: "0.00",
                        change: 0
                    }, 
                ].concat((0,_to_consumable_array/* default */.Z)(data.prices));
            }
            // Mini chart
            state.chart.data[symbol] = newData;
            // Popover chart
            if (isPopover) {
                state.chart.popoverData[symbol] = newData;
            }
            state.chart.error = null;
        }
        state.chart.isLoading = false;
        state.chart.message = message;
    }).addCase(effects.getCompanyChart.rejected, function(state, action) {
        state.chart.error = action.payload.error;
        state.chart.isLoading = false;
    }).addCase(effects.postFollowCompany.pending, function(state) {
        state.postFollowCompany.isLoading = true;
        state.postFollowCompany.error = null;
    }).addCase(effects.postFollowCompany.fulfilled, function(state, action) {
        var STATUS_FOLLOWING = 1;
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
        if (error) {
            state.postFollowCompany.error = error;
        } else {
            state.postFollowCompany.data = data;
            // TODO: Move to new function to wrap this, if allowed
            // update state search
            // find company with `id` == `data.companyId`
            // update followed value to `1`
            var companyid = data.companyid, symbol = data.symbol;
            var newDataState = state.search.data;
            var changedDataIndex = newDataState.findIndex(function(param) {
                var id = param.id;
                return Number(id) === Number(companyid);
            });
            // Do if else to only change specific data state based on
            // flag `stateToUpdate`
            if (stateToUpdate === STATE_SEARCH && changedDataIndex > -1) {
                state.search.data[changedDataIndex].is_following = !!STATUS_FOLLOWING;
            }
            if (stateToUpdate === STATE_DETAIL) {
                state.detail.data[symbol].followed = STATUS_FOLLOWING;
            }
        }
        state.postFollowCompany.message = message;
        state.postFollowCompany.isLoading = false;
    }).addCase(effects.postFollowCompany.rejected, function(state, action) {
        state.postFollowCompany.error = action.payload.error;
        state.postFollowCompany.isLoading = false;
    }).addCase(effects.postUnfollowCompany.pending, function(state) {
        state.postUnfollowCompany.isLoading = true;
        state.postUnfollowCompany.error = null;
    }).addCase(effects.postUnfollowCompany.fulfilled, function(state, action) {
        var STATUS_UNFOLLOWING = 0;
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
        if (error) {
            state.postUnfollowCompany.error = error;
        } else {
            state.postUnfollowCompany.data = data;
            // TODO: Move this to new function to wrap it, if allowed
            // update state
            // find company with `id` == `data.companyId`
            // update followed value to `1`
            var companyid = data.companyid, symbol = data.symbol;
            var newDataState = state.search.data;
            var changedDataIndex = newDataState.findIndex(function(param) {
                var id = param.id;
                return Number(id) === Number(companyid);
            });
            if (stateToUpdate === STATE_SEARCH && changedDataIndex > -1) {
                state.search.data[changedDataIndex].is_following = !!STATUS_UNFOLLOWING;
            }
            if (stateToUpdate === STATE_DETAIL) {
                state.detail.data[symbol].followed = STATUS_UNFOLLOWING;
            }
        }
        state.postUnfollowCompany.message = message;
        state.postUnfollowCompany.isLoading = false;
    }).addCase(effects.postUnfollowCompany.rejected, function(state, action) {
        state.postUnfollowCompany.error = action.payload.error;
        state.postUnfollowCompany.isLoading = false;
    }).addCase(effects.getCompanyContact.pending, function(state) {
        state.contact.isLoading = true;
        state.contact.error = null;
    }).addCase(effects.getCompanyContact.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.contact.error = error;
        } else {
            state.contact.data[symbol] = data;
            state.contact.error = null;
        }
        state.contact.isLoading = false;
        state.contact.message = message;
    }).addCase(effects.getCompanyContact.rejected, function(state, action) {
        state.contact.error = action.payload.error;
        state.contact.isLoading = false;
    }).addCase(effects.postFollowUser.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, userid = _payload.userid, type = _payload.type, symbol = _payload.username;
        if (!error) {
            var activeSymbol = state.contact.data[symbol];
            if (activeSymbol) {
                var idx = activeSymbol.findIndex(function(item) {
                    return item.id === userid;
                });
                if (idx !== -1) {
                    var FOLLOWING = type === "FOLLOW" ? 1 : 0;
                    // If follow specific child, also add following to all watchlist
                    // Update the selected wathclist item
                    state.contact.data[symbol][idx].is_followed = FOLLOWING;
                }
            }
        }
    }).addCase(effects.getBandarDetector.pending, function(state) {
        state.brokerSummary.isLoading = true;
        state.brokerSummary.error = null;
    }).addCase(effects.getBandarDetector.fulfilled, function(state, action) {
        var _payload = action.payload, _data = _payload.data, data = _data === void 0 ? {} : _data, error = _payload.error, message = _payload.message;
        if (error) {
            state.brokerSummary.error = error;
        }
        if (!data.bandar_detector || !data.broker_summary) {
            state.brokerSummary.data.detector = {};
            state.brokerSummary.data.summary = defaultSummary;
            state.brokerSummary.data.from = "";
            state.brokerSummary.data.to = "";
            state.brokerSummary.error = null;
        }
        if (data.bandar_detector && data.broker_summary) {
            state.brokerSummary.data.detector = data.bandar_detector;
            state.brokerSummary.data.summary = data.broker_summary;
            state.brokerSummary.data.from = data.from;
            state.brokerSummary.data.to = data.to;
            state.brokerSummary.error = null;
        }
        state.brokerSummary.message = message;
        state.brokerSummary.isLoading = false;
    }).addCase(effects.getBandarDetector.rejected, function(state, action) {
        state.brokerSummary.error = action.payload.error;
        state.brokerSummary.isLoading = false;
    });
};
// Create redux slice
var companySlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "company",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var entities_company = (companySlice);


/***/ }),

/***/ 61942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_livestream; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/livestream.ts
/* eslint-disable import/named */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 

var request = (0,requestExodus/* default */.Z)();
var LIVE_STREAM_URL = "".concat(api/* API_EXODUS_URL */.q7, "/live-stream");
/**
 * Get Livestreams Event List
 * @param { Object } params
 * @param {number=} params.page
 * @param {string=} params.limit
 * @param {string=} params.status
 * @returns {APIResponse}
 */ var getEventList = function(params) {
    return request.get("".concat(LIVE_STREAM_URL, "/event"), {
        params: params
    });
};
/**
 * Get Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEvent = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/event/").concat(id));
};
/**
 * Write Question
 * @param { Object } params
 * @param {number=} params.id
 * @param {string=} params.question
 * @returns {APIResponse}
 */ var writeQuestion = function(params) {
    return request.post("".concat(LIVE_STREAM_URL, "/event/").concat(params.id, "/question"), {
        question: params.question
    });
};
/**
 * Get Nont Login Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEventNonLogin = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/non-login/event/").concat(id));
};
/* harmony default export */ var livestream = ({
    getEventList: getEventList,
    getEvent: getEvent,
    writeQuestion: writeQuestion,
    getEventNonLogin: getEventNonLogin
});

;// CONCATENATED MODULE: ./src/lib/entities/livestream.ts








/**
 * Note for event filtered data Schema
 * because we pass status as argument, we will use that as key to save the response
 * the schema will look like this
 *
 * data[eventStatus]: [
 *   { ... }
 * ]
 */ var initialState = {
    eventList: {
        data: [],
        isLoading: false,
        message: "",
        error: ""
    },
    eventFiltered: {
        data: {},
        isLoading: false,
        isLoadingMore: false,
        hasMore: false,
        message: "",
        error: ""
    },
    event: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    },
    writeQuestion: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    }
};
var liveStream = function(state) {
    return state.liveStream;
};
var selectors = (0,es/* createSelector */.P1)(liveStream, function(liveStreamState) {
    return {
        events: liveStreamState.eventList,
        event: liveStreamState.event,
        eventFiltered: liveStreamState.eventFiltered,
        writeQuestions: liveStreamState.writeQuestion
    };
});
var CONTEXT = "@feature/livestream";
var actionType = {
    GET_EVENTS: "".concat(CONTEXT, "/GET_EVENTS"),
    GET_EVENTS_FILTERED: "".concat(CONTEXT, "/GET_EVENTS_FILTERED"),
    GET_EVENT: "".concat(CONTEXT, "/GET_EVENT"),
    WRITE_QUESTION: "".concat(CONTEXT, "/WRITE_QUESTION")
};
var effects = {
    getEventList: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS, // @ts-ignore
    (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getEventList({
                        page: 1,
                        limit: 20
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed to get event list");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message;
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getEvent: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getEvent(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    getEventListFiltered: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS_FILTERED, function() {
        var _ref = // @ts-ignore
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var _page, page, _limit, limit, status, response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _page = props.page, page = _page === void 0 ? 1 : _page, _limit = props.limit, limit = _limit === void 0 ? 16 : _limit, status = props.status;
                        _ctx.next = 4;
                        return getEventList({
                            page: page,
                            limit: limit,
                            status: status
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    writeQuestion: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.WRITE_QUESTION, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return writeQuestion(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducers = function(builder) {
    builder.addCase(effects.getEventList.pending, function(state) {
        state.eventList.isLoading = true;
        state.eventList.error = null;
    }).addCase(effects.getEventList.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.eventList.error = error;
        } else {
            state.eventList.data = data;
        }
        state.eventList.message = message;
        state.eventList.isLoading = false;
    }).addCase(effects.getEventList.rejected, function(state, action) {
        state.eventList.isLoading = false;
        state.eventList.error = action.payload.error;
    }).addCase(effects.getEvent.pending, function(state) {
        state.event.isLoading = true;
        state.event.error = null;
    }).addCase(effects.getEvent.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.event.error = error;
        } else {
            state.event.data = data;
        }
        state.event.message = message;
        state.event.isLoading = false;
    }).addCase(effects.getEvent.rejected, function(state, action) {
        state.event.isLoading = false;
        state.event.error = action.payload.error;
    }).addCase(effects.writeQuestion.pending, function(state) {
        state.writeQuestion.isLoading = true;
        state.writeQuestion.error = null;
    }).addCase(effects.writeQuestion.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.writeQuestion.error = error;
        } else {
            state.writeQuestion.data = data;
        }
        state.writeQuestion.message = message;
        state.writeQuestion.isLoading = false;
    }).addCase(effects.writeQuestion.rejected, function(state, action) {
        state.writeQuestion.isLoading = false;
        state.writeQuestion.error = action.payload.error;
    }).addCase(effects.getEventListFiltered.pending, function(state, action) {
        var page = action.meta.arg.page;
        state.eventFiltered.error = null;
        if (page > 1) {
            state.eventFiltered.isLoadingMore = true;
        } else {
            state.eventFiltered.isLoading = true;
        }
    }).addCase(effects.getEventListFiltered.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        var _arg = action.meta.arg, page = _arg.page, status = _arg.status;
        if (error) {
            state.eventFiltered.error = error;
        } else {
            if (page > 1) {
                state.eventFiltered.data = (0,_define_property/* default */.Z)({}, status, (0,_to_consumable_array/* default */.Z)(state.eventFiltered.data[status]).concat((0,_to_consumable_array/* default */.Z)(data)));
                state.eventFiltered.isLoadingMore = false;
            } else {
                state.eventFiltered.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.eventFiltered.data), (0,_define_property/* default */.Z)({}, status, data));
                state.eventFiltered.isLoading = false;
            }
            if (data.length === 16) {
                state.eventFiltered.hasMore = true;
            } else {
                state.eventFiltered.hasMore = false;
            }
        }
        state.eventFiltered.message = message;
    }).addCase(effects.getEventListFiltered.rejected, function(state, action) {
        state.eventFiltered.isLoading = false;
        state.eventFiltered.error = action.payload.error;
    });
};
var liveStreamSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "livestream",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ var entities_livestream = (liveStreamSlice);


/***/ }),

/***/ 9526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; }
/* harmony export */ });
/* unused harmony export selectors */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1955);
/* harmony import */ var _profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(333);



// api

// module profile

// initial state
var initialState = {
    data: {},
    isLoading: false,
    error: null,
    message: "",
    userSkipOnboarding: {
        data: [],
        success: false,
        isLoading: true,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(function(state) {
    return {
        data: state.entities.onboarding.data,
        isLoading: state.entities.onboarding.isLoading,
        error: state.entities.onboarding.error,
        message: state.entities.onboarding.message,
        userSkipOnboarding: state.entities.onboarding.userSkipOnboarding
    };
}, function(state) {
    return state;
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@redux/user";
var actionType = {
    ONBOARDING_SKIP: "".concat(CONTEXT, "/ONBOARDING_SKIP"),
    UPLOAD_IMAGE_AVATAR: "".concat(CONTEXT, "/UPLOAD_IMAGE_AVATAR")
};
// effects
var effects = {
    // userSkipOnboarding -------------------------------------------------------------------
    userSkipOnboarding: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.ONBOARDING_SKIP, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(step, param) {
            var dispatch, response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch = param.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"].userSkipOnboarding */ .Z.userSkipOnboarding(step);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        // to update state profile
                        dispatch(// @ts-ignore
                        _profile__WEBPACK_IMPORTED_MODULE_2__/* ["default"].actions.updateOnboardingStep */ .ZP.actions.updateOnboardingStep({
                            step: step,
                            isClickedPreviousButton: false
                        }));
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 11:
                        throw new Error("Attempt to skip step onboarding Failed");
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(step, _) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer ---------------------------------------------------------------------
var reducers = {
    /**
   * resetUserSkipOnBoarding
   * change resetUserSkipOnBoarding state to initialState
   */ resetUserSkipOnBoarding: function(draft) {
        draft.userSkipOnboarding.data = [];
        draft.userSkipOnboarding.success = false;
        draft.userSkipOnboarding.isLoading = true;
        draft.userSkipOnboarding.error = null;
        draft.userSkipOnboarding.message = "";
    }
};
// Extra Reducer ---------------------------------------------------------------
var extraReducers = function(builder) {
    builder.addCase(effects.userSkipOnboarding.pending, function(state, action) {
        state.userSkipOnboarding.isLoading = true;
    }).addCase(effects.userSkipOnboarding.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.userSkipOnboarding.error = error;
        } else {
            // to know response API is success or not
            state.userSkipOnboarding.success = true;
            state.userSkipOnboarding.data = data;
        }
        state.userSkipOnboarding.message = message;
        state.userSkipOnboarding.isLoading = false;
    }).addCase(effects.userSkipOnboarding.rejected, function(state, action) {
        state.userSkipOnboarding.error = action.payload.error;
        state.userSkipOnboarding.isLoading = false;
    });
};
// Slice -----------------------------------------------------------------------
var onboardingSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "onboarding",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (onboardingSlice);


/***/ }),

/***/ 11733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_shop; },
  "wl": function() { return /* binding */ selectors; },
  "CJ": function() { return /* binding */ thunks; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/shop.ts


// init request config
var request = (0,requestExodus/* default */.Z)();
// constants
var SHOP_URL = "".concat(api/* API_EXODUS_URL */.q7, "/pro-sub");
// api wrappers
var getProducts = function() {
    return request.get("".concat(SHOP_URL, "/products"));
};
var addItems = function(id, quantity) {
    return request.post("".concat(SHOP_URL, "/cart/item"), {
        id: id,
        quantity: quantity
    });
};
var removeItem = function() {
    return request.delete("".concat(SHOP_URL, "/cart"));
};
var getCart = function() {
    return request.get("".concat(SHOP_URL, "/cart"));
};
var checkout = function(gateway) {
    return request.post("".concat(SHOP_URL, "/cart/checkout"), {
        gateway: gateway
    });
};
var applyCoupon = function(coupon) {
    return request.post("".concat(SHOP_URL, "/coupon"), {
        coupon: coupon
    });
};
var removeCoupon = function() {
    return request.delete("".concat(SHOP_URL, "/coupon"));
};
var applyVoucher = function(voucher) {
    return request.post("".concat(SHOP_URL, "/voucher"), {
        voucher: voucher
    });
};
var removePromo = function(type) {
    return request.delete("".concat(SHOP_URL, "/").concat(type));
};
var getSubscriptions = function() {
    return request.get("".concat(SHOP_URL, "/subscription"));
};
var activateFreeTrial = function() {
    return request.post("".concat(SHOP_URL, "/free-trial/activate"));
};
var getPurchaseHistory = function(params) {
    return request.get("".concat(SHOP_URL, "/order/history"), {
        params: params
    });
};
/* harmony default export */ var shop = ({
    getProducts: getProducts,
    getCart: getCart,
    addItems: addItems,
    checkout: checkout,
    applyCoupon: applyCoupon,
    removeCoupon: removeCoupon,
    applyVoucher: applyVoucher,
    removeItem: removeItem,
    removePromo: removePromo,
    getSubscriptions: getSubscriptions,
    getPurchaseHistory: getPurchaseHistory,
    activateFreeTrial: activateFreeTrial
});

// EXTERNAL MODULE: ./src/features/shop-revamp/utils.ts
var utils = __webpack_require__(31366);
;// CONCATENATED MODULE: ./src/lib/entities/shop.ts









// lib

// types

// constants
var CONTEXT = "@entity/shop";
var actionType = {
    GET_PRODUCTS: "".concat(CONTEXT, "/GET_PRODUCTS"),
    CART_ADD_ITEM: "".concat(CONTEXT, "/CART_ADD_ITEM"),
    CONTINUE_SUBSCRIBE: "".concat(CONTEXT, "/CONTINUE_SUBSCRIBE"),
    CART_ADD_RECENT_ITEM: "".concat(CONTEXT, "/CART_ADD_RECENT_ITEM"),
    CART_REMOVE_ITEM: "".concat(CONTEXT, "/CART_REMOVE_ITEM"),
    CART_FETCH: "".concat(CONTEXT, "/CART_FETCH"),
    PAYMENT_CHECKOUT: "".concat(CONTEXT, "/PAYMENT_CHECKOUT"),
    APPLY_COUPON: "".concat(CONTEXT, "/APPLY_COUPON"),
    APPLY_VOUCHER: "".concat(CONTEXT, "/APPLY_VOUCHER"),
    REMOVE_PROMO: "".concat(CONTEXT, "/REMOVE_PROMO"),
    REMOVE_COUPON: "".concat(CONTEXT, "/REMOVE_COUPON"),
    GET_PURCHASE: "".concat(CONTEXT, "/GET_PURCHASE"),
    ACTIVATE_FREE: "".concat(CONTEXT, "/ACTIVATE_FREE"),
    GET_PURCHASE_HISTORY: "".concat(CONTEXT, "/GET_PURCHASE_HISTORY")
};
var initialState = {
    products: {
        isLoading: false,
        list: [],
        error: null,
        message: null
    },
    cart: {
        isLoading: false,
        error: null,
        products: [],
        promos: null,
        totals: null
    },
    payment: {
        isLoading: false,
        error: null,
        gateway: "bca_va",
        paymentURL: null,
        paymentType: "popup",
        orderId: ""
    },
    purchase: {
        isLoading: true,
        error: null,
        purchases: []
    },
    activateFreeTrial: {
        isLoading: true,
        error: null
    },
    history: {
        isLoading: false,
        orders: {},
        subscription: null
    }
};
// reducers
var reducers = {
    setGateway: function(draft, actions) {
        draft.payment.gateway = actions.payload;
    }
};
// thunks
var thunks = {
    // -- Fetch products
    fetchProducts: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PRODUCTS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getProducts();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data, message = _data.message;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        products: data,
                        message: message
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Add items
    addItems: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_ADD_ITEM, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var selected, rejectWithValue, code, id, quantity, response, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selected = param.selected, rejectWithValue = param1.rejectWithValue;
                        code = selected.code, id = selected.id;
                        quantity = parseInt(code.substring(5, 7), 10);
                        if (quantity) {
                            _ctx.next = 6;
                            break;
                        }
                        rejectWithValue(quantity);
                        throw new Error("Invalid quantity format!");
                    case 6:
                        _ctx.next = 8;
                        return shop.addItems(id, quantity);
                    case 8:
                        response = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(error);
                    case 12:
                        return _ctx.abrupt("return", {
                            data: [
                                response.data.data
                            ]
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    continueSubscribe: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CONTINUE_SUBSCRIBE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var selected, rejectWithValue, code, id, quantity, response, responseCart, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selected = param.selected, rejectWithValue = param1.rejectWithValue;
                        code = selected.code, id = selected.id;
                        quantity = parseInt(code.substring(5, 7), 10);
                        if (quantity) {
                            _ctx.next = 6;
                            break;
                        }
                        rejectWithValue(quantity);
                        throw new Error("Invalid quantity format!");
                    case 6:
                        _ctx.next = 8;
                        return shop.addItems(id, quantity);
                    case 8:
                        response = _ctx.sent;
                        _ctx.next = 11;
                        return shop.getCart();
                    case 11:
                        responseCart = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 15;
                            break;
                        }
                        throw new Error(error);
                    case 15:
                        return _ctx.abrupt("return", {
                            data: [
                                response.data.data
                            ],
                            cart: responseCart.data.data
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Add items
    removeItem: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_REMOVE_ITEM, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.removeItem();
                case 2:
                    response = _ctx.sent;
                    data = response.data;
                    error = data.error;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        message: "success"
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch Cart
    fetchCart: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_FETCH, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getCart();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        products: data.products,
                        promos: data.promos,
                        totals: data.totals
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Checkout
    checkout: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.PAYMENT_CHECKOUT, function() {
        var _ref = // @ts-ignore
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(gateway) {
            var response, _data, data, error, apiURL, paymentType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.checkout(gateway);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        if (!(data === null || data === void 0 ? void 0 : data.action)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            paymentType: "popup",
                            snapToken: data.action.snap_token,
                            clientKey: data.action.client_key,
                            orderId: data.action.order_id
                        });
                    case 8:
                        apiURL = new URL(data.url);
                        paymentType = gateway === "veritrans" ? "redirect" : "popup";
                        return _ctx.abrupt("return", {
                            gateway: data.gateway,
                            url: data.url,
                            paymentType: paymentType,
                            snapToken: apiURL.searchParams.get("snap_token"),
                            clientKey: apiURL.searchParams.get("client_key")
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(gateway) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    applyCoupon: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.APPLY_COUPON, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(coupon) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.applyCoupon(coupon);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(coupon) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    applyVoucher: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.APPLY_VOUCHER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(coupon) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.applyVoucher(coupon);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(coupon) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    removePromo: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.REMOVE_PROMO, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.removePromo(type);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Remove Coupon
    removeCoupon: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.REMOVE_COUPON, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.removeCoupon();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch products
    getPurchase: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PURCHASE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getSubscriptions();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data, message = _data.message;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        purchases: data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch products
    activateFreeTrial: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.ACTIVATE_FREE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message, error_type;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.activateFreeTrial();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data;
                    message = data.message, error_type = data.error_type;
                    if (!(error || error_type)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    fetchPurchaseHistory: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PURCHASE_HISTORY, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var params, response, _data, error, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = {
                        last_id: 0,
                        limit: 10
                    };
                    _ctx.next = 3;
                    return shop.getPurchaseHistory(params);
                case 3:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })))
};
var extraReducers = function(builder) {
    return builder// Fetch products
    .addCase(thunks.fetchProducts.pending, function(draft) {
        draft.products.isLoading = true;
    }).addCase(thunks.fetchProducts.fulfilled, function(draft, actions) {
        draft.products.isLoading = false;
        draft.products.list = actions.payload.products;
        draft.products.message = actions.payload.message;
        draft.products.error = null;
    }).addCase(thunks.fetchProducts.rejected, function(draft, actions) {
        draft.products.isLoading = false;
        draft.products.error = actions.error;
    })// -- Add to cart
    .addCase(thunks.addItems.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.addItems.fulfilled, function(draft, actions) {
        draft.cart.error = null;
        draft.cart.isLoading = false;
        draft.cart.products = actions.payload.data;
        router_default().push("/shop/cart");
    }).addCase(thunks.addItems.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// Continue Subscribe
    .addCase(thunks.continueSubscribe.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.continueSubscribe.fulfilled, function(draft, actions) {
        draft.cart.error = null;
        draft.cart.isLoading = false;
        draft.cart.products = actions.payload.cart.products;
        router_default().push("/shop/cart");
    }).addCase(thunks.continueSubscribe.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// -- Fetch cart
    .addCase(thunks.fetchCart.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.fetchCart.fulfilled, function(draft, actions) {
        draft.cart = {
            isLoading: false,
            error: null,
            products: actions.payload.products,
            promos: actions.payload.promos,
            totals: actions.payload.totals,
            applyingVoucher: false
        };
    }).addCase(thunks.fetchCart.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// -- Checkout
    .addCase(thunks.checkout.pending, function(draft) {
        draft.payment.isLoading = true;
    }).addCase(thunks.checkout.fulfilled, function(draft, actions) {
        draft.payment.error = null;
        draft.payment.isLoading = false;
        draft.payment.paymentType = actions.payload.paymentType;
        draft.payment.gateway = actions.payload.gateway;
        draft.payment.paymentURL = actions.payload.url;
        draft.payment.snapToken = actions.payload.snapToken;
        draft.payment.clientKey = actions.payload.clientKey;
    }).addCase(thunks.checkout.rejected, function(draft, actions) {
        draft.payment.isLoading = false;
        draft.payment.error = actions.error;
    }).addCase(thunks.removeItem.fulfilled, function() {
        router_default().push("/shop");
    }).addCase(thunks.applyCoupon.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    }).addCase(thunks.applyVoucher.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    }).addCase(thunks.removePromo.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    })// Fetch Purchases
    .addCase(thunks.getPurchase.pending, function(draft) {
        draft.purchase.isLoading = true;
    }).addCase(thunks.getPurchase.fulfilled, function(draft, actions) {
        draft.purchase.isLoading = false;
        draft.purchase.purchases = actions.payload.purchases;
    }).addCase(thunks.getPurchase.rejected, function(draft, actions) {
        draft.purchase.isLoading = false;
        draft.purchase.error = actions.error;
    })// Fetch Purchases
    .addCase(thunks.activateFreeTrial.pending, function(draft) {
        draft.activateFreeTrial.isLoading = true;
    }).addCase(thunks.activateFreeTrial.fulfilled, function(draft, actions) {
        draft.activateFreeTrial.isLoading = false;
    }).addCase(thunks.activateFreeTrial.rejected, function(draft, actions) {
        draft.activateFreeTrial.isLoading = false;
    })// Fetch Purchase History
    .addCase(thunks.fetchPurchaseHistory.pending, function(draft) {
        draft.history.isLoading = true;
    }).addCase(thunks.fetchPurchaseHistory.fulfilled, function(draft, actions) {
        draft.history.isLoading = false;
        draft.history.orders = (0,utils/* createMonthlyStatements */.gs)(actions.payload.data.orders);
        draft.history.subscription = actions.payload.data.subscription;
    }).addCase(thunks.fetchPurchaseHistory.rejected, function(draft, actions) {
        draft.history.isLoading = false;
    });
};
// selectors
var shopEntitySelector = function(state) {
    return state.entities.shop;
};
var selectProductList = function(state) {
    return state.products.list.map(function(param) {
        var description = param.description, keyword = param.keyword, price = param.price;
        return {
            duration: description,
            price: (numeral_default()(price).value() / 1000).toString(),
            description: keyword,
            features: "Full Features"
        };
    });
};
var selectors = (0,es/* createSelector */.P1)(shopEntitySelector, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        products: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.products), {
            availableProducts: selectProductList(state)
        })
    });
});
// slice
var shopSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    initialState: initialState,
    name: "shop",
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var entities_shop = (shopSlice);


/***/ }),

/***/ 98585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; }
/* harmony export */ });
/* unused harmony export selector */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20072);



// APIs

// Initial state
var initialState = {
    detail: {},
    data: {},
    isLoading: false,
    error: null,
    message: ""
};
// Selectors
var selector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.entities.tipping;
}, function(tipping) {
    return {
        data: tipping.data,
        isLoading: tipping.isLoading,
        error: tipping.error,
        detail: tipping.detail
    };
});
// Action types
var CONTEXT = "@redux/entities";
var actionType = {
    GET_TIPPING_JAR: "".concat(CONTEXT, "/GET_TIPPING_JAR"),
    CLAIM_TIPPING_BALANCE: "".concat(CONTEXT, "/CLAIM_TIPPING_BALANCE"),
    SEND_TIPPING: "".concat(CONTEXT, "/SEND_TIPPING"),
    UPDATE_GOPAY_ACCOUNT: "".concat(CONTEXT, "/UPDATE_GOPAY_ACCOUNT"),
    GET_TIPPING_DETAIL: "".concat(CONTEXT, "/GET_TIPPING_DETAIL"),
    SEND_TIPPING_GENERAL: "".concat(CONTEXT, "/SEND_TIPPING_GENERAL")
};
// Effects
var effects = {
    sendTipping: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SEND_TIPPING, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tipData) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sendTippingStream */ .Z.sendTippingStream(tipData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send tip failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(tipData) {
            return _ref.apply(this, arguments);
        };
    }()),
    sendTippingGeneral: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SEND_TIPPING_GENERAL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tipData) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sendTipping */ .Z.sendTipping(tipData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send tip failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(tipData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var extraReducers = {
};
var tipping = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "tipping",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (tipping);


/***/ }),

/***/ 7639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useUIConfigStore; }
});

// UNUSED EXPORTS: resetRules

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/utils/objectOperations.ts

var pickObject = function(obj, keys) {
    var pickedObject = {};
    keys.forEach(function(key) {
        pickedObject[key] = obj === null || obj === void 0 ? void 0 : obj[key];
    });
    return pickedObject;
};
var omitObject = function(obj, keys) {
    var omittedObject = (0,_object_spread/* default */.Z)({}, obj);
    keys.forEach(function(key) {
        return delete omittedObject[key];
    });
    return omittedObject;
};

;// CONCATENATED MODULE: ./src/stores/useUIConfigStore/index.ts









var _obj;
var resetRules = (_obj = {}, // List item that should not deleted on social logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, [
    "tradingLimitTooltip",
    "tradingLimitTnc",
    // Day Trade
    "dayTradeTnc",
    "dayTradeTncShown", 
]), // List item that should be deleted on securities logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, [
    "featureFlags"
]), _obj);
var initialState = {
    userConfig: {}
};
var useUIConfigStore = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    var ref, ref1, ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setUIValue: function(key, value) {
            var userId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.id;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (!state.userConfig[userId]) state.userConfig[userId] = {};
                if (typeof value === "function") {
                    if (!state.userConfig[userId][key]) {
                        state.userConfig[userId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.userConfig[userId]), (0,_define_property/* default */.Z)({}, key, {}));
                    }
                    value(state.userConfig[userId][key]);
                    return;
                }
                state.userConfig[userId][key] = value;
            }));
        },
        getUIValue: function(key) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref1 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref1 === void 0 ? void 0 : ref1.id;
            var ref;
            return (ref = get().userConfig[userId]) === null || ref === void 0 ? void 0 : ref[key];
        },
        resetUIValue: function(loginType) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref2 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref2 === void 0 ? void 0 : ref2.id;
            var resetSocial = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = pickObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Social */.B.Social]);
                }));
            };
            var resetSecurities = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = omitObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Securities */.B.Securities]);
                }));
            };
            var _obj;
            var resetActions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, resetSocial), (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, resetSecurities), _obj);
            resetActions[loginType]();
        }
    });
}, {
    name: "UIConfigStore"
}));
/* harmony default export */ var stores_useUIConfigStore = (useUIConfigStore);


/***/ }),

/***/ 97718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["Social"] = "social";
    LoginType["Securities"] = "securities";
})(LoginType || (LoginType = {}));


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "Y4": function() { return /* binding */ numberFormat; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountAbbrv3, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += "M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += "B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += "T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var halfEven = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var roundingFn = number >= 0 ? Math.floor : Math.ceil;
    if (halfEven) roundingFn = Math.round;
    var nNumber = roundingFn(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n) {
    return Number(n) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    if (newNumber === null || newNumber === void 0 ? void 0 : newNumber.toString().startsWith("-")) {
        minus = true;
        newNumber = Math.abs(newNumber);
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += "".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += "".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(number))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal,
    parseCountAbbrv2: parseCountAbbrv2
});


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ })

}]);